webpackJsonp([1],{

/***/ "+/Q5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+XyB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icons.16d8b90.svg";

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0F2t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1b73":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4f9P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5ay1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AyeP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BI6m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BYpH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ENT2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GKAi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Izla":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JCVd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JEpz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JMQ1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K4gw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LhCU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N0Tb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/p-panel.vue
//
//
//
//
//
//


/* harmony default export */ var p_panel = ({
	name: 'p-panel',
	computed: {
		devmode: function devmode() {
			return this.$store.getters.devmode;
		},
		channel: function channel() {
			return this.$store.getters.channel;
		},
		loading: function loading() {
			return this.$store.getters.loading;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a82b20a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/p-panel.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.channel)?_c('div',{staticClass:"p-panel",class:{ 'p-panel--loading': _vm.loading, 'p-panel--devmode': _vm.devmode}},[_c('router-view',{staticClass:"view"})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var pages_p_panel = (esExports);
// CONCATENATED MODULE: ./src/pages/p-panel.vue
function injectStyle (ssrContext) {
  __webpack_require__("NYZZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  p_panel,
  pages_p_panel,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_pages_p_panel = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/p-404.vue
//
//
//
//
//
//

/* harmony default export */ var p_404 = ({
	name: 'p-404'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03809374","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/p-404.vue
var p_404_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-404"},[_c('h1',[_vm._v(_vm._s(_vm.$t("system.NotFound")))])])}
var p_404_staticRenderFns = []
var p_404_esExports = { render: p_404_render, staticRenderFns: p_404_staticRenderFns }
/* harmony default export */ var pages_p_404 = (p_404_esExports);
// CONCATENATED MODULE: ./src/pages/p-404.vue
var p_404_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var p_404___vue_template_functional__ = false
/* styles */
var p_404___vue_styles__ = null
/* scopeId */
var p_404___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var p_404___vue_module_identifier__ = null
var p_404_Component = p_404_normalizeComponent(
  p_404,
  pages_p_404,
  p_404___vue_template_functional__,
  p_404___vue_styles__,
  p_404___vue_scopeId__,
  p_404___vue_module_identifier__
)

/* harmony default export */ var src_pages_p_404 = (p_404_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/v-paging.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var v_paging = ({
	name: 'v-paging',
	props: {
		current_page: {
			type: Number,
			default: 0
		},
		min_page: {
			type: Number,
			default: 0
		},
		max_page: {
			type: Number,
			default: 0
		}
	},
	methods: {
		pagechange: function pagechange() {
			var self = this;
			if (self.current_page > self.max_page) {
				self.current_page = self.max_page;
			}
			if (self.current_page < self.min_page) {
				self.current_page = self.min_page;
			}

			if (this.timeoutId) window.clearTimeout(this.timeoutId);
			this.timeoutId = window.setTimeout(function () {
				self.$emit('pagechange', self.current_page);
			}, 500);
		},
		prev: function prev() {
			this.$emit('prev', -1);
		},
		next: function next() {
			this.$emit('next', +1);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3397438e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v-paging.vue
var v_paging_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-paging st-paging"},[_vm._v("\n\n    "+_vm._s(_vm.$t('Page'))+"\n    "),_c('div',{staticClass:"inline-block"},[_c('button',{staticClass:"st-btn st-btn--small",attrs:{"disabled":_vm.current_page <= _vm.min_page},on:{"click":function($event){_vm.prev()}}},[_c('i',{staticClass:"fa fa-angle-left",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.current_page),expression:"current_page"}],staticClass:"inline text-center st-input st-input--fit st-input--small",attrs:{"size":"2","disabled":_vm.current_page >= _vm.max_page && _vm.current_page <= _vm.min_page,"type":"text"},domProps:{"value":(_vm.current_page)},on:{"keyup":_vm.pagechange,"input":function($event){if($event.target.composing){ return; }_vm.current_page=$event.target.value}}}),_vm._v(" "+_vm._s(_vm.$t('to'))+" "+_vm._s(_vm.max_page)+"\n    "),_c('div',{staticClass:"inline-block"},[_c('button',{staticClass:"st-btn st-btn--small",attrs:{"disabled":_vm.current_page >= _vm.max_page},on:{"click":function($event){_vm.next()}}},[_c('i',{staticClass:"fa fa-angle-right",attrs:{"aria-hidden":"true"}})])])])}
var v_paging_staticRenderFns = []
var v_paging_esExports = { render: v_paging_render, staticRenderFns: v_paging_staticRenderFns }
/* harmony default export */ var components_v_paging = (v_paging_esExports);
// CONCATENATED MODULE: ./src/components/v-paging.vue
function v_paging_injectStyle (ssrContext) {
  __webpack_require__("NLJ+")
}
var v_paging_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var v_paging___vue_template_functional__ = false
/* styles */
var v_paging___vue_styles__ = v_paging_injectStyle
/* scopeId */
var v_paging___vue_scopeId__ = "data-v-3397438e"
/* moduleIdentifier (server only) */
var v_paging___vue_module_identifier__ = null
var v_paging_Component = v_paging_normalizeComponent(
  v_paging,
  components_v_paging,
  v_paging___vue_template_functional__,
  v_paging___vue_styles__,
  v_paging___vue_scopeId__,
  v_paging___vue_module_identifier__
)

/* harmony default export */ var src_components_v_paging = (v_paging_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__("O4Lo");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("lHK6");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__("309y");
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);

// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__("HN2V");
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("hygk");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ListFilters.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var ListFilters = ({
	name: 'ListFilters',
	components: {
		VPaging: src_components_v_paging
	},
	computed: {
		loading: function loading() {
			return this.$store.getters.loading;
		},
		channel: function channel() {
			return this.$store.getters.channel;
		},
		role: function role() {
			if (this.rolename) return this.$store.getters.channel.roles[this.rolename];
			return false;
		},
		leader_role: function leader_role() {
			if (this.role && this.role.leader) {
				return this.$store.getters.channel.roles[this.role.leader];
			}
			return false;
		}
	},
	props: {
		totals: {
			default: function _default() {
				return {};
			}
		},
		rolename: {
			default: ''
		}
	},
	data: function data() {
		return {
			page: 1,
			pages: 1,
			debounceEvents: debounce_default()(this.sendEvent, 300),
			query: {},
			init: false,
			filters: {
				q: '',
				page: 1,
				limit: 10,
				my: false,
				roles: []
			}
		};
	},
	mounted: function mounted() {
		var _this = this;

		var query = JSON.parse(stringify_default()(this.$route.query));

		forEach_default()(query, function (value, key) {
			if (typeof _this.filters[key] !== 'undefined') {
				if (Array.isArray(_this.filters[key]) && !Array.isArray(value)) {
					_this.filters[key] = [value];
				} else {
					_this.filters[key] = value;
				}
			}
		});

		this.update();
	},
	destroyed: function destroyed() {
		this.reset(false);
	},

	methods: {
		update: function update() {
			var pre = JSON.parse(stringify_default()(this.query)),
			    query = {};

			forEach_default()(this.$route.query, function (value, key) {
				query[key] = JSON.parse(stringify_default()(value));
			});

			forEach_default()(this.filters, function (value, key) {
				query[key] = JSON.parse(stringify_default()(value));
			});

			query.q = query.q.trim();
			if (query.q.length <= 2) query.q = '';

			forEach_default()(query, function (value, key) {
				if (typeof value === 'boolean') {
					if (key == 'my' && value === false) delete query[key];
				} else if (typeof value == 'number') {
					if (key == 'page' && value == 1 || key == 'limit' && value == 10) {
						delete query[key];
					}
				} else {
					if (isEmpty_default()(value)) delete query[key];
				}
			});

			var eq = !isEqual_default()(pre, query);
			if (eq || !this.init) {
				this.init = true;
				this.debounceEvents(query);
			}
		},
		sendEvent: function sendEvent(query) {
			// this.$router.replace({ query });
			this.$emit('update', extends_default()({}, query));
			this.query = query;
		},
		reset: function reset(update) {
			this.filters = {
				q: '',
				page: 1,
				limit: 10,
				my: false,
				roles: []
			};
			if (update) this.update();
		},
		changePageByNumber: function changePageByNumber(numb) {
			this.filters.page = numb;
			this.update();
		},
		changePage: function changePage(add) {
			this.filters.page = this.filters.page + add;
			this.update();
		},
		hasFilters: function hasFilters() {
			var min = 0;
			if (this.query.q) min += 1;
			return keys_default()(this.query).length > min;
		},

		toggleRole: function toggleRole(name) {
			if (typeof_default()(this.filters.roles) != 'object') this.filters.roles = [];
			var self = this,
			    index = self.filters.roles.indexOf(name);

			if (index === -1) {
				self.filters.roles.push(name);
			} else {
				self.filters.roles.splice(index, 1);
			}
			this.update();
		},
		toggleMy: function toggleMy() {
			this.filters.my = !this.filters.my;
			this.update();
		},
		isLast: function isLast(arr, obj) {
			return arr.length - 1 == arr.indexOf(obj);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a622248","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListFilters.vue
var ListFilters_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ListFilters row margin-bottom-medium"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{staticClass:"st-filters"},[_c('div',{staticClass:"inline"},[_c('button',{staticClass:"st-filters__link",class:{'st-filters__link--active': !_vm.hasFilters() },on:{"click":_vm.reset}},[_vm._v(_vm._s(_vm.$t("All"))+" ("+_vm._s(_vm.role.total)+")")]),(_vm.role.subroles || _vm.channel.me.role != _vm.role.name)?_c('span',[_vm._v(" | ")]):_vm._e()]),_vm._v(" "),(_vm.channel.me.role != _vm.role.name)?_c('div',{staticClass:"inline"},[_c('button',{staticClass:"st-filters__link",class:{'st-filters__link--active': _vm.filters.my },on:{"click":function($event){_vm.toggleMy()}}},[_vm._v(_vm._s(_vm.$t("My")))])]):_vm._e(),_vm._v(" "),(_vm.leader_role)?_c('div',{staticClass:"inline"},[_c('span',[_vm._v(" | ")]),_vm._v(" "),_c('button',{staticClass:"st-filters__link",class:{ 'st-filters__link--active': _vm.filters.roles.indexOf(_vm.leader_role.name) >= 0 },on:{"click":function($event){_vm.toggleRole(_vm.leader_role.name)}}},[_vm._v(_vm._s(_vm.$t(_vm.leader_role.singular))+" ("+_vm._s(_vm.leader_role.total)+")")])]):_vm._e(),_vm._v(" "),(_vm.role.subroles)?_c('div',{staticClass:"inline"},[_c('span',[_vm._v(" | ")]),_vm._v(" "),_vm._l((_vm.role.subroles),function(sr){return _c('div',{staticClass:"inline"},[_c('button',{staticClass:"st-filters__link",class:{ 'st-filters__link--active': _vm.filters.roles.indexOf(sr.name) >= 0 },on:{"click":function($event){_vm.toggleRole(sr.name)}}},[_vm._v(_vm._s(_vm.$t(sr.singular))+" ("+_vm._s(sr.total)+")")]),(!_vm.isLast(_vm.role.subroles, sr))?_c('span',[_vm._v(" | ")]):_vm._e()])})],2):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 text-sm-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.q),expression:"filters.q"}],staticClass:"st-input st-input--sm st-input--text st-input--search",attrs:{"type":"text","placeholder":_vm.$t('Search ...')},domProps:{"value":(_vm.filters.q)},on:{"keyup":_vm.update,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "q", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"inline-block"},[_c('v-paging',{attrs:{"current_page":parseInt(_vm.filters.page),"min_page":1,"max_page":_vm.pages,"prev":"changePage"},on:{"pagechange":_vm.changePageByNumber,"":function($event){},"next":_vm.changePage}})],1)])])}
var ListFilters_staticRenderFns = []
var ListFilters_esExports = { render: ListFilters_render, staticRenderFns: ListFilters_staticRenderFns }
/* harmony default export */ var components_ListFilters = (ListFilters_esExports);
// CONCATENATED MODULE: ./src/components/ListFilters.vue
function ListFilters_injectStyle (ssrContext) {
  __webpack_require__("JEpz")
}
var ListFilters_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ListFilters___vue_template_functional__ = false
/* styles */
var ListFilters___vue_styles__ = ListFilters_injectStyle
/* scopeId */
var ListFilters___vue_scopeId__ = "data-v-7a622248"
/* moduleIdentifier (server only) */
var ListFilters___vue_module_identifier__ = null
var ListFilters_Component = ListFilters_normalizeComponent(
  ListFilters,
  components_ListFilters,
  ListFilters___vue_template_functional__,
  ListFilters___vue_styles__,
  ListFilters___vue_scopeId__,
  ListFilters___vue_module_identifier__
)

/* harmony default export */ var src_components_ListFilters = (ListFilters_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/helpers/rest.js







var general_axios_options = {
	maxRedirects: 5,
	mode: 'no-cors'
};

/* harmony default export */ var rest = ({

	axios_options: {
		get: extends_default()({}, general_axios_options),
		post: extends_default()({}, general_axios_options),
		patch: extends_default()({}, general_axios_options),
		put: extends_default()({}, general_axios_options),
		options: extends_default()({}, general_axios_options),
		delete: extends_default()({}, general_axios_options)
	},

	doNotices: function doNotices(notices) {
		var self = this;

		notices.forEach(function (notice) {
			self.$store.commit('ADD_NOTICE', notice);
		});

		return true;
	},
	doActions: function doActions(actions) {
		var self = this;

		actions.forEach(function (action) {
			if (action.type == 'redirect') {
				self.$router.push({ path: action.text });
			}
			if (action.type == 'login') {
				self.$store.commit('LOGOUT');
			}
		});

		return true;
	},


	/**
  * use:
 	this.restget(this.$store.getters.channel.urls.presentation.replace(':id:', 'master'), 'presentation')
 	.then(data => {
 		self.$store.commit('SET_PRESENTATIONID', self.pid);
 		self.data = data;
 		self.setupCharts();
 		self.setupFields();
 	});
 	 */
	restget: function restget(url, payload, name) {
		if (typeof payload == 'string') {
			name = payload;
			payload = undefined;
		}
		var self = this;
		return new promise_default.a(function (resolve, reject) {
			if (self.$store.getters.devmode) console.debug('START restget', url, name);
			if (name !== 'async') self.$store.commit('START_LOADING', name);

			var options = self.axios_options.get;
			if ((typeof options === 'undefined' ? 'undefined' : typeof_default()(options)) !== 'object') options = {};
			if (payload) options.params = payload;

			axios_default.a.get(url, options).then(self.handleResponse).then(function (response) {
				if (self.$store.getters.devmode) console.debug('FINISH restget', url, name);
				if (response.data.notices && typeof self.doNotices == 'function') {
					self.doNotices(response.data.notices);
				}
				if (response.data.actions && typeof self.doActions == 'function') {
					self.doActions(response.data.actions);
				}

				if (name !== 'async') self.$store.commit('END_LOADING', name);

				resolve(response.data.message);
			}).catch(function (error) {
				self.$store.commit('ADD_ERROR', error);
				reject(error);
			});
		});
	},


	/**
  * use:
 	this.restpatch(this.$store.getters.channel.urls.presentation.replace(':id:', 'master'), {}, 'presentation')
 	.then(data => {
 		self.$store.commit('SET_PRESENTATIONID', self.pid);
 		self.data = data;
 		self.setupCharts();
 		self.setupFields();
 	});
 	 */
	restpatch: function restpatch(url, payload, name) {
		var self = this;
		return new promise_default.a(function (resolve, reject) {
			if (self.$store.getters.devmode) console.debug('START restpatch', url, name);
			self.$store.commit('START_SAVEING', name);
			axios_default.a.patch(url, payload, self.axios_options.patch).then(function (response) {
				if (self.$store.getters.devmode) console.debug('FINISH restpatch', url, name);
				if (response.data.notices && typeof self.doNotices == 'function') {
					self.doNotices(response.data.notices);
				}
				if (response.data.actions && typeof self.doActions == 'function') {
					self.doActions(response.data.actions);
				}

				self.$store.commit('END_SAVEING', name);

				resolve(response.data.message);
			}).catch(function (error) {
				self.$store.commit('ADD_ERROR', error);
				self.$store.commit('END_SAVEING', name);
				reject(error);
			});
		});
	},

	/**
  * use:
 	this.restput(this.$store.getters.channel.urls.presentation.replace(':id:', 'master'), {}, 'presentation')
 	.then(data => {
 		self.$store.commit('SET_PRESENTATIONID', self.pid);
 		self.data = data;
 		self.setupCharts();
 		self.setupFields();
 	});
 	 */
	restput: function restput(url, payload, name) {
		var self = this;
		return new promise_default.a(function (resolve, reject) {
			if (self.$store.getters.devmode) console.debug('START restput', url, name);
			self.$store.commit('START_SAVEING', name);
			axios_default.a.put(url, payload, self.axios_options.put).then(function (response) {
				if (self.$store.getters.devmode) console.debug('FINISH restput', url, name);
				if (response.data.notices && typeof self.doNotices == 'function') {
					self.doNotices(response.data.notices);
				}
				if (response.data.actions && typeof self.doActions == 'function') {
					self.doActions(response.data.actions);
				}

				self.$store.commit('END_SAVEING', name);

				resolve(response.data.message);
			}).catch(function (error) {
				self.$store.commit('ADD_ERROR', error);
				self.$store.commit('END_SAVEING', name);
				reject(error);
			});
		});
	},


	/**
  * use:
 	this.restpost(this.$store.getters.channel.urls.presentation.replace(':id:', 'master'), {}, 'presentation')
 	.then(data => {
 		self.$store.commit('SET_PRESENTATIONID', self.pid);
 		self.data = data;
 		self.setupCharts();
 		self.setupFields();
 	});
 	 */
	restpost: function restpost(url, payload, name) {
		var self = this;
		return new promise_default.a(function (resolve, reject) {
			if (self.$store.getters.devmode) console.debug('START restpost', url, name);
			self.$store.commit('START_SAVEING', name);
			axios_default.a.post(url, payload, self.axios_options.post).then(function (response) {
				if (self.$store.getters.devmode) console.debug('FINISH restpost', url, name);
				if (response.data.notices && typeof self.doNotices == 'function') {
					self.doNotices(response.data.notices);
				}
				if (response.data.actions && typeof self.doActions == 'function') {
					self.doActions(response.data.actions);
				}

				self.$store.commit('END_SAVEING', name);

				resolve(response.data.message);
			}).catch(function (error) {
				self.$store.commit('ADD_ERROR', error);
				self.$store.commit('END_SAVEING', name);
				reject(error);
			});
		});
	},


	/**
  * use:
 	this.restdelete(this.$store.getters.channel.urls.presentation.replace(':id:', 'master'), 'presentation')
 	.then(data => {
 		self.$store.commit('SET_PRESENTATIONID', self.pid);
 		self.data = data;
 		self.setupCharts();
 		self.setupFields();
 	});
 	 */
	restdelete: function restdelete(url, payload, name) {
		if (typeof payload == 'string') {
			name = payload;
			payload = undefined;
		}
		var self = this;
		return new promise_default.a(function (resolve, reject) {
			if (self.$store.getters.devmode) console.debug('START restdelete', url, name);
			self.$store.commit('START_SAVEING', name);

			var options = self.axios_options.delete;
			if ((typeof options === 'undefined' ? 'undefined' : typeof_default()(options)) !== 'object') options = {};
			if (payload) options.params = payload;

			axios_default.a.delete(url, options).then(function (response) {
				if (self.$store.getters.devmode) console.debug('FINISH restdelete', url, name);
				if (response.data.notices && typeof self.doNotices == 'function') {
					self.doNotices(response.data.notices);
				}
				if (response.data.actions && typeof self.doActions == 'function') {
					self.doActions(response.data.actions);
				}

				self.$store.commit('END_SAVEING', name);

				resolve(response.data.message);
			}).catch(function (error) {
				self.$store.commit('ADD_ERROR', error);
				self.$store.commit('END_SAVEING', name);
				reject(error);
			});
		});
	},


	/**
  * use:
 	this.restoptions(this.$store.getters.channel.urls.presentation.replace(':id:', 'master'), {}, 'presentation')
 	.then(data => {
 		self.$store.commit('SET_PRESENTATIONID', self.pid);
 		self.data = data;
 		self.setupCharts();
 		self.setupFields();
 	});
 	 */
	restoptions: function restoptions(url, payload, name) {
		if (typeof payload == 'string') {
			name = payload;
			payload = undefined;
		}
		var self = this;
		return new promise_default.a(function (resolve, reject) {
			if (self.$store.getters.devmode) console.debug('START restoptions', url, name);
			self.$store.commit('START_LOADING', name);
			if (self.$store.getters.devmode) console.debug('OPTIONS REQUEST START', url);

			var options = self.axios_options.options;
			if ((typeof options === 'undefined' ? 'undefined' : typeof_default()(options)) !== 'object') options = {};
			if (payload) options.params = payload;

			axios_default.a.options(url, options).then(function (response) {
				if (self.$store.getters.devmode) console.debug('FINISH restoptions', url, name);
				if (self.$store.getters.devmode) console.debug('OPTIONS REQUEST FINISHED', url);
				if (response.data.notices && typeof self.doNotices == 'function') {
					self.doNotices(response.data.notices);
				}
				if (response.data.actions && typeof self.doActions == 'function') {
					self.doActions(response.data.actions);
				}

				self.$store.commit('END_LOADING', name);

				resolve(response.data.message);
			}).catch(function (error) {
				self.$store.commit('ADD_ERROR', error);
				self.$store.commit('END_SAVEING', name);
				reject(error);
			});
		});
	}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/c-user.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// helper



/* harmony default export */ var c_user = ({
	name: 'c-user',
	data: function data() {
		return {
			loading: false,
			isdeleting: false,
			deleteel: false
		};
	},


	computed: {
		isSomeoneEditing: function isSomeoneEditing() {
			var user_edit_status = this.$store.getters['socket/getFromLive']('user_edit_status');
			if (!user_edit_status || typeof user_edit_status[this.data.id] === 'undefined') return false;
			return true;
		},
		name: function name() {
			if (this.data.lastname && this.data.firstname) return this.data.lastname + ', ' + this.data.firstname;

			return this.data.title;
		},
		editurl: function editurl() {
			if (this.data.partner_id) {
				return {
					name: 'partner-user',
					params: {
						id: this.data.partner_id,
						uid: this.data.id
					}
				};
			}
			return { path: this.data.urls.edit };
		}
	},

	props: {
		data: {
			default: function _default() {
				return {};
			}
		},
		simple: {
			type: Boolean,
			default: false
		}
	},
	methods: extends_default()({}, rest, {
		startdeleteuser: function startdeleteuser(event) {
			this.deleteel = event.target;
			this.isdeleting = !this.isdeleting;
		},
		deleteuser: function deleteuser() {
			var _this = this;

			var self = this,
			    url = this.data && this.data.urls && this.data.urls.delete ? this.data.urls.delete : this.$store.getters.channel.urls.user.replace(':id:', this.data.id);

			self.loading = true;
			this.restdelete(url, 'delete').then(function (message) {
				self.loading = false;
				self.$emit('delete');
				_this.stopdeleteuser();
			});
		},
		stopdeleteuser: function stopdeleteuser() {
			this.deleteel = false;
			this.isdeleting = false;
		}
	})
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eb12fff","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-user.vue
var c_user_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"c-user",class:{'has-action': _vm.data.urls}},[(_vm.data.urls && _vm.data.urls.edit)?_c('router-link',{staticClass:"st-table__link",attrs:{"to":_vm.editurl}},[_vm._v(_vm._s(_vm.name))]):_c('span',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),(_vm.isSomeoneEditing)?_c('div',[_vm._v("\n\t\t\t"+_vm._s(_vm.$t('Someone is currently editing this User. Please try again later.'))+"\n\t\t")]):(_vm.data.urls && !_vm.simple)?_c('div',{staticClass:"st-table-action"},[(_vm.data.urls.edit)?_c('router-link',{staticClass:"st-table-action__link st-table-action__link--edit",attrs:{"to":_vm.editurl}},[_vm._v(_vm._s(_vm.$t('Edit')))]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.deleteel && _vm.isdeleting)?_c('v-tooldown',{attrs:{"loading":_vm.loading,"type":'delete',"el":_vm.deleteel,"yesno":true},on:{"ok":_vm.deleteuser,"cancel":_vm.stopdeleteuser}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.$t('Delete User')))]),_vm._v(" "),_c('span',{attrs:{"slot":"message"},slot:"message"},[_vm._v(_vm._s(_vm.$t('Do you really want to delete this user.')))]),_vm._v(" "),_c('span',{attrs:{"slot":"positive"},slot:"positive"},[_vm._v(_vm._s(_vm.$t('Delete')))])]):_vm._e()],1):_c('div',[_c('pre',[_vm._v(_vm._s(_vm.data))])])}
var c_user_staticRenderFns = []
var c_user_esExports = { render: c_user_render, staticRenderFns: c_user_staticRenderFns }
/* harmony default export */ var components_c_user = (c_user_esExports);
// CONCATENATED MODULE: ./src/components/c-user.vue
function c_user_injectStyle (ssrContext) {
  __webpack_require__("0F2t")
}
var c_user_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var c_user___vue_template_functional__ = false
/* styles */
var c_user___vue_styles__ = c_user_injectStyle
/* scopeId */
var c_user___vue_scopeId__ = "data-v-4eb12fff"
/* moduleIdentifier (server only) */
var c_user___vue_module_identifier__ = null
var c_user_Component = c_user_normalizeComponent(
  c_user,
  components_c_user,
  c_user___vue_template_functional__,
  c_user___vue_styles__,
  c_user___vue_scopeId__,
  c_user___vue_module_identifier__
)

/* harmony default export */ var src_components_c_user = (c_user_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DynamicColumn.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var DynamicColumn = ({
	name: 'DynamicColumn',
	components: {
		CUser: src_components_c_user
	},
	props: {
		row: {
			default: function _default() {
				return {};
			}
		},
		data: {
			default: function _default() {
				return {};
			}
		},
		reference: {
			default: function _default() {
				return {};
			}
		},
		simple: {
			default: true
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31ec362e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicColumn.vue
var DynamicColumn_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DynamicColumn"},[(Array.isArray(_vm.data))?_c('div',_vm._l((_vm.data),function(item,index){return _c('DynamicColumn',{key:index,attrs:{"reference":_vm.reference,"data":item,"simple":true}})})):_c('div',[(_vm.data.type == 'role' || _vm.data.type == 'channel')?_c('div',[_vm._v("\n\t\t\t\t"+_vm._s(_vm.data.singular)+"\n\t\t\t")]):(_vm.data.type == 'user' || _vm.data.type == 'partner' || _vm.data.type == 'customer' || _vm.data.type == 'presentation')?_c('c-user',{attrs:{"simple":_vm.simple,"data":_vm.data,"canedit":(_vm.data.urls && Object.keys(_vm.data.urls).length > 0)}}):(_vm.data.type == 'asset' || _vm.data.type == 'image')?_c('div',[(_vm.reference && _vm.reference.urls && _vm.reference.urls.edit)?_c('router-link',{staticClass:"st-table__link",attrs:{"to":_vm._a(0,function(){return {path: _vm.reference.urls.edit}})}},[(_vm.data.ext == 'png' || _vm.data.ext == 'gif' || _vm.data.ext == 'jpg' || _vm.data.ext == 'jpeg')?_c('img',{class:{'user-image': _vm.reference.fancyname, 'image': !_vm.reference.fancyname},attrs:{"src":_vm.data.url,"alt":(_vm.reference.fancyname ? _vm.reference.fancyname : _vm.reference.title) + ' image'}}):_vm._e()]):(_vm.data.ext == 'png' || _vm.data.ext == 'gif' || _vm.data.ext == 'jpg' || _vm.data.ext == 'jpeg')?_c('img',{class:{'user-image': _vm.reference.fancyname, 'image': !_vm.reference.fancyname},attrs:{"src":_vm.data.url,"alt":(_vm.reference.fancyname ? _vm.reference.fancyname : _vm.reference.title) + ' image'}}):_vm._e()],1):_c('div',[(_vm.reference && _vm.reference.urls && _vm.reference.urls.edit)?_c('router-link',{staticClass:"st-table__link",attrs:{"to":_vm._a(1,function(){return {path: _vm.reference.urls.edit}})}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.data)+"\n\t\t\t\t")]):_c('span',[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.data)+"\n\t\t\t\t")])],1)],1)])}
var DynamicColumn_staticRenderFns = []
var DynamicColumn_esExports = { render: DynamicColumn_render, staticRenderFns: DynamicColumn_staticRenderFns }
/* harmony default export */ var components_DynamicColumn = (DynamicColumn_esExports);
// CONCATENATED MODULE: ./src/components/DynamicColumn.vue
function DynamicColumn_injectStyle (ssrContext) {
  __webpack_require__("VvVP")
}
var DynamicColumn_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DynamicColumn___vue_template_functional__ = false
/* styles */
var DynamicColumn___vue_styles__ = DynamicColumn_injectStyle
/* scopeId */
var DynamicColumn___vue_scopeId__ = "data-v-31ec362e"
/* moduleIdentifier (server only) */
var DynamicColumn___vue_module_identifier__ = null
var DynamicColumn_Component = DynamicColumn_normalizeComponent(
  DynamicColumn,
  components_DynamicColumn,
  DynamicColumn___vue_template_functional__,
  DynamicColumn___vue_styles__,
  DynamicColumn___vue_scopeId__,
  DynamicColumn___vue_module_identifier__
)

/* harmony default export */ var src_components_DynamicColumn = (DynamicColumn_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SortableTable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SortableTable = ({
	name: 'SortableTable',
	components: {
		ListFilters: src_components_ListFilters,
		DynamicColumn: src_components_DynamicColumn,
		CUser: src_components_c_user
	},
	computed: {
		loading: function loading() {
			return this.$store.getters.loading;
		}
	},
	data: function data() {
		return {
			sort: 'this',
			direction: '+'
		};
	},
	props: {
		role: {
			default: ''
		},
		users: {
			default: function _default() {
				return [];
			}
		},
		columns: {
			default: function _default() {
				return ['image', 'this', 'mainrole', 'subrole', 'leader'];
			}
		},
		sortable: {
			default: function _default() {
				return ['this', 'mainrole', 'subrole', 'leader', 'customer', 'partner', 'appointment', 'title'];
			}
		},
		simpleusers: {
			default: true
		},
		newlink: {
			default: false
		}
	},
	methods: {
		getCSSClasses: function getCSSClasses(column) {
			var css = {};
			console.log();
			css['st-table__th--' + column] = true;
			if (this.sortable.indexOf(column) >= 0) css['pointer'] = true;
			return css;
		},
		filterUpdate: function filterUpdate(filter) {
			console.log('filterUpdate', filter);
		},
		toggleSort: function toggleSort(column) {
			if (this.sortable.indexOf(column) < 0) {
				return;
			}
			if (this.sort != column) {
				this.sort = column;
				this.direction = '+';
			} else {
				// togglelingen
				this.direction = this.direction == '+' ? '-' : '+';
			}
			this.$emit('update', {
				column: this.sort,
				direction: this.direction
			});
		}
	}

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6db2bd53","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SortableTable.vue
var SortableTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SortableTable"},[_c('table',{staticClass:"st-table st-table--full"},[_c('thead',[_c('tr',_vm._l((_vm.columns),function(column){return _c('th',{staticClass:"st-table__th",class:_vm.getCSSClasses(column),on:{"click":function($event){_vm.toggleSort(column)}}},[_vm._v(_vm._s(_vm.$t('Column: ' + column))+"\n                \t\t"),(_vm.sort == column)?_c('span',[(_vm.direction == '+')?_c('i',{staticClass:"fa fa-angle-up"}):_c('i',{staticClass:"fa fa-angle-down"})]):_vm._e()])}))]),_vm._v(" "),_c('tbody',[_vm._l((_vm.users),function(user,index){return (_vm.users && _vm.users.length > 0)?_c('tr',{class:{ 'has-action' : user.urls && Object.keys(user.urls).length > 0 }},_vm._l((_vm.columns),function(column){return _c('td',{staticClass:"st-table__td",class:'st-table__td--' + column},[(column == 'this')?_c('DynamicColumn',{attrs:{"simple":false,"reference":user,"data":user,"row":user}}):(user[column])?_c('DynamicColumn',{attrs:{"simple":_vm.simpleusers,"reference":user,"data":user[column],"row":user}}):_c('div',[_vm._v("---")])],1)})):_vm._e()}),_vm._v(" "),(!_vm.users || _vm.users.length <= 0)?_c('tr',[_c('td',{attrs:{"colspan":"3"}},[(_vm.loading)?_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"spinner"})]):_c('div',[_vm._v(_vm._s(_vm.$t('Nothing Found')))])])]):_vm._e()],2)]),_vm._v(" "),(_vm.newlink)?_c('router-link',{staticClass:"st-btn st-btn--small st-btn--submit",attrs:{"to":_vm.newlink}},[_vm._v("New")]):_vm._e()],1)}
var SortableTable_staticRenderFns = []
var SortableTable_esExports = { render: SortableTable_render, staticRenderFns: SortableTable_staticRenderFns }
/* harmony default export */ var components_SortableTable = (SortableTable_esExports);
// CONCATENATED MODULE: ./src/components/SortableTable.vue
function SortableTable_injectStyle (ssrContext) {
  __webpack_require__("LhCU")
}
var SortableTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SortableTable___vue_template_functional__ = false
/* styles */
var SortableTable___vue_styles__ = SortableTable_injectStyle
/* scopeId */
var SortableTable___vue_scopeId__ = "data-v-6db2bd53"
/* moduleIdentifier (server only) */
var SortableTable___vue_module_identifier__ = null
var SortableTable_Component = SortableTable_normalizeComponent(
  SortableTable,
  components_SortableTable,
  SortableTable___vue_template_functional__,
  SortableTable___vue_styles__,
  SortableTable___vue_scopeId__,
  SortableTable___vue_module_identifier__
)

/* harmony default export */ var src_components_SortableTable = (SortableTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UserList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var UserList = ({
	name: 'UserList',
	components: {
		ListFilters: src_components_ListFilters,
		SortableTable: src_components_SortableTable
	},
	data: function data() {
		return {
			sort: {
				column: 'this',
				direciton: '+'
			},
			totals: {},
			filters: {},
			list: [],
			pages: 1
		};
	},
	props: {
		justlist: {
			default: false
		},
		apiurl: {
			default: '/api/v1/users'
		},
		listname: {
			default: 'kam'
		},
		rolename: {
			default: false // kam
		},
		roleleadername: {
			default: false // kam_leader
		},
		columns: {
			default: function _default() {
				return ['image', 'this', 'mainrole', 'subrole', 'leader'];
			}
		},
		forcefilters: {
			default: function _default() {
				return {};
			}
		}
	},
	mounted: function mounted() {
		if (this.justlist) {
			this.update();
		}
	},

	methods: {
		// wird von ListFilters && filterUpdate gefeuert
		update: function update(filters) {
			var _this = this;

			var self = this;

			if (!self.apiurl) return;
			if (self.$store.getters.loadings[self.listname]) return;

			// filters
			if (typeof filters == 'undefined') filters = this.filters;
			if (typeof filters.mainrole == 'undefined') filters.mainrole = [];
			if (self.rolename && filters.mainrole.indexOf(self.rolename) == -1) filters.mainrole.push(self.rolename);
			if (self.roleleadername && filters.mainrole.indexOf(self.roleleadername) == -1) filters.mainrole.push(self.roleleadername);
			this.filters = filters;

			// sortierung

			if (this.sort && this.sort.column) {
				var column = this.sort.column;
				if (this.sort.column == 'this') {
					column = ['title', 'lastname'];
				}
				if (Array.isArray(column)) {
					filters.sort = [];
					forEach_default()(column, function (value) {
						filters.sort.push((_this.sort.direction == '-' ? _this.sort.direction : '') + value);
					});
				} else {
					filters.sort = (this.sort.direction == '-' ? this.sort.direction : '') + column;
				}
			}

			if (this.forcefilters) {
				forEach_default()(this.forcefilters, function (value, key) {
					filters[key] = value;
				});
			}

			self.$store.commit('START_LOADING', self.listname);
			self.$api.get(this.apiurl, {
				params: filters
			}).then(function (response) {
				self.$store.commit('END_LOADING', self.listname);
				self.list = response.data.message;

				if (response.data.total) self.totals.all = response.data.total;
				if (response.data.total && response.data.limit) {
					self.pages = Math.floor(response.data.total / response.data.limit);
				}
			}).catch(function (err) {
				console.error(err);
			});
		},
		filterUpdate: function filterUpdate(f) {
			if (this.list.length <= 0 || !isEqual_default()(this.filters, f)) {
				this.update(f);
			}
		},
		sortUpdate: function sortUpdate(sort) {
			if (this.sort != sort) {
				this.sort = sort;
				this.update();
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75b0fa8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserList.vue
var UserList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"UserList"},[(!_vm.justlist)?_c('ListFilters',{attrs:{"totals":_vm.totals,"rolename":_vm.rolename},on:{"update":_vm.filterUpdate}}):_vm._e(),_vm._v(" "),_c('SortableTable',{attrs:{"columns":_vm.columns,"users":_vm.list},on:{"update":_vm.sortUpdate}})],1)}
var UserList_staticRenderFns = []
var UserList_esExports = { render: UserList_render, staticRenderFns: UserList_staticRenderFns }
/* harmony default export */ var components_UserList = (UserList_esExports);
// CONCATENATED MODULE: ./src/components/UserList.vue
var UserList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UserList___vue_template_functional__ = false
/* styles */
var UserList___vue_styles__ = null
/* scopeId */
var UserList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UserList___vue_module_identifier__ = null
var UserList_Component = UserList_normalizeComponent(
  UserList,
  components_UserList,
  UserList___vue_template_functional__,
  UserList___vue_styles__,
  UserList___vue_scopeId__,
  UserList___vue_module_identifier__
)

/* harmony default export */ var src_components_UserList = (UserList_Component.exports);

// CONCATENATED MODULE: ./src/helpers/general.js

/* harmony default export */ var general = ({
	translate: function translate(obj) {
		var _this = this;

		var newObj = {};
		keys_default()(obj).forEach(function (name) {
			newObj[name] = _this.$t(obj[name]);
		});
		return newObj;
	},
	basename: function basename(str) {
		var base = new String(str).substring(str.lastIndexOf('/') + 1);
		if (base.lastIndexOf(".") != -1) base = base.substring(0, base.lastIndexOf("."));
		return base;
	},
	copyToClipboard: function copyToClipboard(text) {
		if (window.clipboardData && window.clipboardData.setData) {
			// IE specific code path to prevent textarea being shown while dialog is visible.
			return window.clipboardData.setData("Text", text);
		} else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
			var textarea = document.createElement("textarea");
			textarea.textContent = text;
			textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in MS Edge.
			document.body.appendChild(textarea);
			textarea.select();
			try {
				return document.execCommand("copy"); // Security exception may be thrown by some browsers.
			} catch (ex) {
				console.warn("Copy to clipboard failed.", ex);
				return false;
			} finally {
				document.body.removeChild(textarea);
			}
		}
	},
	getFieldValidation: function getFieldValidation(field) {
		var out = {};
		if (field.required) out.required = true;
		if (field.type == 'email') out.email = true;
		if (field.min) out.min = field.min;
		if (field.max) out.max = field.max;
		if (field.name == 'password') out.confirmed = 'password_confirmation';
		if (field.type == 'select' && field.options.length <= 1) out.required = false;

		if ((field.name == 'password' || field.name == 'password_confirmation') && field.value.length > 0) out.required = 'true';

		return out;
	}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/c-presentation.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var c_presentation = ({
	name: 'c-presentation',
	data: function data() {
		return {
			loading: false,
			isdeleting: false,
			deleteel: false
		};
	},

	computed: {
		currentUsers: function currentUsers() {
			var presentation_edit_status = this.$store.getters['socket/getFromLive']('presentation_edit_status');
			if (typeof presentation_edit_status[this.data.id] === 'undefined') return false;

			// forEach(presentation_edit_status[this.data.id], (id) => {

			// });
			return true;
		}
	},
	props: {
		data: {
			type: Object,
			default: function _default() {
				return {};
			}
		},
		simple: {
			type: Boolean,
			default: false
		},
		master: {
			type: Boolean,
			default: false
		}
	},
	methods: extends_default()({}, rest, {
		isSomeoneEditing: function isSomeoneEditing() {
			var presentation_edit_status = this.$store.getters['socket/getFromLive']('presentation_edit_status');
			return typeof presentation_edit_status[this.data.id] !== 'undefined' ? presentation_edit_status[this.data.id] : false;
		},
		copyLink: function copyLink(ev) {
			ev.preventDefault();
			var href = ev.target.getAttribute('href');
			general.copyToClipboard(href);
			this.$emit('copyedLink', href);
		},
		startdeletepresentation: function startdeletepresentation(event) {
			this.deleteel = event.target;
			this.isdeleting = !this.isdeleting;
		},
		deletepresentation: function deletepresentation() {
			var self = this;
			self.loading = true;
			this.restdelete(this.$store.getters.channel.urls.presentation.replace(':id:', this.data.id), 'delete-presentation').then(function (message) {
				self.loading = false;
				self.$emit('delete');
				self.stopdeletepresentation();
			});
		},
		stopdeletepresentation: function stopdeletepresentation() {
			this.deleteel = false;
			this.isdeleting = false;
		}
	})

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06c216aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-presentation.vue
var c_presentation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"c-presentation",class:{'has-action': _vm.data.urls, 'is-editing': _vm.isSomeoneEditing()}},[(_vm.data.urls && _vm.data.urls.edit)?_c('router-link',{staticClass:"st-table__link",attrs:{"to":_vm._a(0,function(){return {path: _vm.data.urls.edit}})}},[_vm._v("\n\t\t\t"+_vm._s(_vm.data.title)+"\n\t\t")]):_c('span',[_vm._v("\n\t    \t"+_vm._s(_vm.data.title)+"\n\t    ")]),_vm._v(" "),(_vm.isSomeoneEditing())?_c('div',[_vm._v("\n\t\t\t"+_vm._s(_vm.$t('Someone is currently editing this Presentation. Please try again later.'))+"\n\t\t")]):_vm._e(),_vm._v(" "),(_vm.data.urls && !_vm.isSomeoneEditing())?_c('div',{staticClass:"st-able-action",class:{'st-table-action--active': this.isdeleting}},[(_vm.data.urls.edit)?_c('router-link',{staticClass:"st-table-action__link st-table-action__link--edit",attrs:{"to":_vm._a(1,function(){return { name: (_vm.master ? 'master-' : '') + 'editor', params: { pid : _vm.data.id.toString() }}})}},[_vm._v(_vm._s(_vm.$t('Edit')))]):_vm._e(),_vm._v(" "),(_vm.data.urls.settings && !_vm.simple && !_vm.master)?_c('router-link',{staticClass:"st-table-action__link st-table-action__link--settings",attrs:{"to":_vm._a(2,function(){return { name: 'presentation-settings', params: { pid : _vm.data.id.toString() }}})}},[_vm._v(_vm._s(_vm.$t('Settings')))]):_vm._e(),_vm._v(" "),(_vm.data.urls.view)?_c('a',{staticClass:"st-table-action__link st-table-action__link--view",attrs:{"href":_vm.data.urls.view,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('View')))]):_vm._e(),_vm._v(" "),(_vm.data.urls.view && !_vm.simple)?_c('a',{staticClass:"st-table-action__link st-table-action__link--view",attrs:{"href":'mailto:?body=' + _vm.data.urls.view}},[_vm._v(_vm._s(_vm.$t('Copy Link')))]):_vm._e(),_vm._v(" "),(_vm.data.urls.download && !_vm.simple)?_c('a',{staticClass:"st-table-action__link st-table-action__link--download",attrs:{"download":"","href":_vm.data.urls.download}},[_vm._v(_vm._s(_vm.$t('Download')))]):_vm._e(),_vm._v(" "),(_vm.data.urls.delete && !_vm.simple)?_c('a',{staticClass:"st-table-action__link st-table-action__link--delete",attrs:{"href":_vm.data.urls.edit},on:{"click":function($event){$event.preventDefault();_vm.startdeletepresentation($event)}}},[_vm._v(_vm._s(_vm.$t('Delete')))]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.deleteel && _vm.isdeleting)?_c('v-tooldown',{attrs:{"loading":_vm.loading,"type":'delete',"el":_vm.deleteel,"yesno":true},on:{"ok":_vm.deletepresentation,"cancel":_vm.stopdeletepresentation}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.$t('Delete Presentation')))]),_vm._v(" "),_c('div',{attrs:{"slot":"message"},slot:"message"},[_vm._v(_vm._s(_vm.$t('Do you really want to delete this Presentation.')))]),_vm._v(" "),_c('div',{attrs:{"slot":"positive"},slot:"positive"},[_vm._v(_vm._s(_vm.$t('Delete')))])]):_vm._e()],1):_vm._e()}
var c_presentation_staticRenderFns = []
var c_presentation_esExports = { render: c_presentation_render, staticRenderFns: c_presentation_staticRenderFns }
/* harmony default export */ var components_c_presentation = (c_presentation_esExports);
// CONCATENATED MODULE: ./src/components/c-presentation.vue
var c_presentation_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var c_presentation___vue_template_functional__ = false
/* styles */
var c_presentation___vue_styles__ = null
/* scopeId */
var c_presentation___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var c_presentation___vue_module_identifier__ = null
var c_presentation_Component = c_presentation_normalizeComponent(
  c_presentation,
  components_c_presentation,
  c_presentation___vue_template_functional__,
  c_presentation___vue_styles__,
  c_presentation___vue_scopeId__,
  c_presentation___vue_module_identifier__
)

/* harmony default export */ var src_components_c_presentation = (c_presentation_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue2-selectize/dist/vue2-selectize.js
var vue2_selectize = __webpack_require__("py5U");
var vue2_selectize_default = /*#__PURE__*/__webpack_require__.n(vue2_selectize);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MultiSelect.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MultiSelect = ({
	name: 'MultiSelect',
	components: {
		Selectize: vue2_selectize_default.a
	},
	computed: {
		computedOptions: function computedOptions() {
			var out = [];
			for (var i = 0; i < this.options.length; i++) {
				if (this.value.indexOf(this.getValue(this.options[i], i)) < 0) {
					out.push(this.options[i]);
				}
			}
			return out;
		},
		computedDisabled: function computedDisabled() {
			if (this.computedOptions.length <= 0) return true;
			return this.disabled;
		}
	},
	data: function data() {

		var value = [];
		this.defaultValue.forEach(function (item, index) {
			if (typeof item == 'number') item = item.toString();
			value.push(item);
		});

		return {
			value: value
		};
	},

	props: {
		defaultValue: {
			default: function _default() {
				return [];
			}
		},
		defaultText: {
			default: 'Bitte Wählen'
		},
		disabled: {
			type: Boolean,
			default: false
		},
		options: {
			default: function _default() {
				return [];
			}
		},
		name: {
			type: String,
			default: ''
		},
		small: {
			type: Boolean,
			default: false
		},
		id: {
			type: String,
			default: ''
		}
	},
	methods: {
		getTextFromValue: function getTextFromValue(opt, index) {
			for (var i = this.options.length - 1; i >= 0; i--) {
				if (this.options[i].value == opt) {
					return this.getText(this.options[i], index);
				}
			}
			return false;
		},
		getText: function getText(opt, index) {
			if (typeof opt === 'string') {
				return opt;
			} else if (opt.label) {

				if (opt.translate) {
					return this.$t(opt.label).trim();
				}

				return opt.label;
			}

			if (typeof this.options[opt] !== 'undefined') {
				return this.getText(this.options[opt]);
			} else if (typeof this.options[index] !== 'undefined') {
				return this.getText(this.options[index]);
			}

			return false;
		},
		removeValue: function removeValue(index) {
			if (this.disabled) return;
			this.value.splice(index, 1);
			this.$emit('input', this.value);
		},
		getValue: function getValue(option, index) {
			var val = false;
			if (Array.isArray(this.options)) {
				if ((typeof option === 'undefined' ? 'undefined' : typeof_default()(option)) == 'object' && option.value) {
					val = option.value;
				} else {
					val = option;
				}
			} else {
				val = index;
			}

			if (typeof val === 'number') val = val.toString();
			return val;
		},
		updateValue: function updateValue(value) {

			if (value && value.length > 0 && this.value.indexOf(value) < 0) {
				if (typeof value === 'string') {
					this.value.push(value);
				} else if (!Array.isArray(value) && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) == 'object' && value.value) {
					this.value.push(value.value);
				} else {
					this.value.push(value);
				}

				this.$emit('input', this.value);
				this.$refs.select.value = '';
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a346f808","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MultiSelect.vue
var MultiSelect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MultiSelect"},[_c('div',{staticClass:"inputfield inputfield--select inputfield--multiselect",class:{'inputfield--small': _vm.small}},[_c('selectize',{ref:"select",staticClass:"MultiSelect__select",class:{'MultiSelect__select--small': _vm.small},attrs:{"disabled":_vm.computedDisabled,"name":_vm.name,"id":_vm.id,"multiple":false,"autocomplete":true},on:{"input":_vm.updateValue}},_vm._l((_vm.computedOptions),function(option,index){return (_vm.value.indexOf(_vm.getValue(option, index)) < 0)?_c('option',{staticClass:"MultiSelect__option MultiSelect__option--custom",domProps:{"value":_vm.getValue(option, index)}},[_vm._v(_vm._s(_vm.getText(option, index)))]):_vm._e()}))],1),_vm._v(" "),_c('ul',{staticClass:"MultiSelect__ul"},_vm._l((_vm.value),function(item,index){return _c('li',{staticClass:"MultiSelect__li",class:{'MultiSelect__li--small': _vm.small}},[_c('span',{staticClass:"MultiSelect__li-text"},[_vm._v(_vm._s(_vm.getTextFromValue(item, index)))]),_vm._v(" "),_c('button',{staticClass:"MultiSelect__li-btn     st-btn st-btn--small st-btn--icon",class:{ 'st-btn--disabled': _vm.disabled },on:{"click":function($event){$event.preventDefault();_vm.removeValue(index)}}},[_c('i',{staticClass:"fa fa-close",attrs:{"aria-hidden":"true"}})])])}))])}
var MultiSelect_staticRenderFns = []
var MultiSelect_esExports = { render: MultiSelect_render, staticRenderFns: MultiSelect_staticRenderFns }
/* harmony default export */ var components_MultiSelect = (MultiSelect_esExports);
// CONCATENATED MODULE: ./src/components/MultiSelect.vue
function MultiSelect_injectStyle (ssrContext) {
  __webpack_require__("YRXF")
}
var MultiSelect_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MultiSelect___vue_template_functional__ = false
/* styles */
var MultiSelect___vue_styles__ = MultiSelect_injectStyle
/* scopeId */
var MultiSelect___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MultiSelect___vue_module_identifier__ = null
var MultiSelect_Component = MultiSelect_normalizeComponent(
  MultiSelect,
  components_MultiSelect,
  MultiSelect___vue_template_functional__,
  MultiSelect___vue_styles__,
  MultiSelect___vue_scopeId__,
  MultiSelect___vue_module_identifier__
)

/* harmony default export */ var src_components_MultiSelect = (MultiSelect_Component.exports);

// CONCATENATED MODULE: ./src/helpers/user.js
/* harmony default export */ var helpers_user = ({
	editusertitle: function editusertitle() {
		if (!this.edituser && !this.edituser.fancyname && !this.edituser.title) {
			if (this.id == 'new') {
				return this.$t('Create new {name}', { name: this.role ? this.role : 'User' });
			} else {
				return false;
			}
		}
		if (this.id == 'new') {
			return this.$t('Create new {name}', { name: this.edituser.fancyname ? this.edituser.fancyname : this.edituser.title });
		}

		return this.$t('Edit {name}', { name: this.edituser.fancyname ? this.edituser.fancyname : this.edituser.title });
	},
	hasfitlers: function hasfitlers() {
		if (this.filters.roles && this.filters.roles.length > 0) {
			return true;
		}
		if (this.filters.my || this.filters.progress_status) {
			return true;
		}

		if (this.filters.q && this.filters.q.length > 0) {
			return true;
		}
	},
	iscurrentrole: function iscurrentrole(role) {
		if (!this.role) {
			console.log('iscurrentrole', this.role);
			return false;
		}
		return role.name == this.role.name;
	},
	iscurrentsubrole: function iscurrentsubrole(role) {
		if (!this.role) {
			console.log('iscurrentsubrole', this.role);
			return false;
		}
		return this.role.subroles.find(function (obj) {
			return obj.name === role.name;
		});
	},
	issubrole: function issubrole(role) {
		if (!this.channel) {
			console.log('issubrole', this.channel);
			return false;
		}
		return this.channel.subroles.find(function (obj) {
			return obj.name === role.name;
		});
	},
	isleaderrole: function isleaderrole(role) {
		return role.name.match(/_leader/);
	},
	getroleusers: function getroleusers(role, leaders) {
		if (!leaders) return [];
		return leaders.filter(function (user) {
			if (!user.mainrole) return false;
			return user.mainrole.name === role.name;
		});
	}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageDashboard.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var PageDashboard = ({
	name: 'PageDashboard',
	components: {
		DynamicColumn: src_components_DynamicColumn,
		MultiSelect: src_components_MultiSelect,
		CPresentation: src_components_c_presentation,
		CUser: src_components_c_user,
		UserList: src_components_UserList
	},
	data: function data() {
		return {
			latestpresentation: false,
			latestcustomer: false,
			nextappointment: false
		};
	},

	computed: {
		channel: function channel() {
			return this.$store.getters.channel;
		}
	},
	mounted: function mounted() {
		this.update();
	},

	methods: extends_default()({}, rest, {
		update: function update() {
			var self = this;

			this.restget(this.channel.urls.presentations + '?sort=-created', 'latestpresentation').then(function (message) {
				console.log('latestpresentation', message);
				self.latestpresentation = message || [];
			}).catch(function (error) {
				self.$store.commit('ADD_ERROR', error);
				console.error(error);
			});

			this.restget(this.channel.urls.presentations + '?sort=-appointment', 'nextappointment').then(function (message) {
				console.log('nextappointment', message);
				self.nextappointment = message || [];
			}).catch(function (error) {
				self.$store.commit('ADD_ERROR', error);
				console.error(error);
			});
		}
	})
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-677ccdff","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageDashboard.vue
var PageDashboard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageDashboard"},[_c('transition',{attrs:{"name":"PageGroupTranstion","enter-active-class":"animated PageGroupFadeIn"}},[_c('div',[_c('div',{staticClass:"row margin-bottom-xlarge"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"st-headline st-headline--1"},[_vm._v(_vm._s(_vm.$t('Dashboard')))])])]),_vm._v(" "),_c('div',{staticClass:"row margin-bottom-xlarge"},[(_vm.channel.pages.presentations)?_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('h2',{staticClass:"st-headline st-headline--2"},[_vm._v(_vm._s(_vm.$t('Latest presentation')))]),_vm._v(" "),_c('table',{staticClass:"st-table st-table--full"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('Name')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('Customer')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('Created by')))])])]),_vm._v(" "),_c('tbody',[(!_vm.latestpresentation)?_c('tr',[_c('td',{attrs:{"colspan":"3"}},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"inline-block spinner"})])])]):_vm._l((_vm.latestpresentation),function(entry){return _c('tr',{class:{
				            		'has-action': (entry.urls && Object.keys(entry.urls).length > 0)
				            	}},[_c('td',[_c('c-presentation',{attrs:{"data":entry,"simple":true}})],1),_vm._v(" "),_c('td',[_c('DynamicColumn',{attrs:{"simple":false,"reference":entry,"data":entry.customer,"row":entry}})],1),_vm._v(" "),_c('td',[(entry.createdUser)?_c('c-user',{attrs:{"data":entry.createdUser}}):_vm._e()],1)])})],2)])]):_vm._e(),_vm._v(" "),(_vm.channel.pages.customers)?_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('h2',{staticClass:"st-headline st-headline--2"},[_vm._v(_vm._s(_vm.$t('Latest customer')))]),_vm._v(" "),_c('UserList',{attrs:{"apiurl":'/api/v1/customers',"forcefilters":_vm._a(0,function(){return { limit: 5 }}),"justlist":true,"columns":_vm._a(1,function(){return ['customernumber', 'this', 'leader', 'partners']}),"listname":'latestcustomer'}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row margin-bottom-xlarge"},[(_vm.channel.pages.presentations)?_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('h2',{staticClass:"st-headline st-headline--2"},[_vm._v(_vm._s(_vm.$t('Next appointment')))]),_vm._v(" "),_c('table',{staticClass:"st-table st-table--full"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('Name')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('Customer')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('Appointment')))])])]),_vm._v(" "),_c('tbody',[(!_vm.nextappointment)?_c('tr',[_c('td',{attrs:{"colspan":"3"}},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"inline-block spinner"})])])]):_vm._l((_vm.nextappointment),function(entry){return _c('tr',{class:{
				            		'has-action': (entry.urls && Object.keys(entry.urls).length > 0)
				            	}},[_c('td',[_c('c-presentation',{attrs:{"data":entry,"simple":true}})],1),_vm._v(" "),_c('td',[_c('DynamicColumn',{attrs:{"simple":false,"reference":entry,"data":entry.customer,"row":entry}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(entry.appointment))])])})],2)])]):_vm._e()])])])],1)}
var PageDashboard_staticRenderFns = []
var PageDashboard_esExports = { render: PageDashboard_render, staticRenderFns: PageDashboard_staticRenderFns }
/* harmony default export */ var pages_PageDashboard = (PageDashboard_esExports);
// CONCATENATED MODULE: ./src/pages/PageDashboard.vue
function PageDashboard_injectStyle (ssrContext) {
  __webpack_require__("BYpH")
}
var PageDashboard_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageDashboard___vue_template_functional__ = false
/* styles */
var PageDashboard___vue_styles__ = PageDashboard_injectStyle
/* scopeId */
var PageDashboard___vue_scopeId__ = "data-v-677ccdff"
/* moduleIdentifier (server only) */
var PageDashboard___vue_module_identifier__ = null
var PageDashboard_Component = PageDashboard_normalizeComponent(
  PageDashboard,
  pages_PageDashboard,
  PageDashboard___vue_template_functional__,
  PageDashboard___vue_styles__,
  PageDashboard___vue_scopeId__,
  PageDashboard___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageDashboard = (PageDashboard_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/vue2-dropzone/dist/vue2Dropzone.js
var vue2Dropzone = __webpack_require__("KvPw");
var vue2Dropzone_default = /*#__PURE__*/__webpack_require__.n(vue2Dropzone);

// CONCATENATED MODULE: ./src/helpers/fieldvalidation.js



/* harmony default export */ var fieldvalidation = ({
	getFieldValidation: general.getFieldValidation,
	validate: function validate() {
		var self = this;
		return new promise_default.a(function (resolve, reject) {
			self.$validator.validateAll().then(function (result) {
				if (result) {
					resolve(result);
					return;
				}

				reject(result);
			});
		});
	}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/f-files.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var f_files = ({
	name: 'f-files',
	components: {
		vueDropzone: vue2Dropzone_default.a
	},
	computed: {
		systemdisable: function systemdisable() {
			var field = this.$store.getters.getEditFieldById(this.field.name);
			return field.disabled || this.$store.getters.loading || this.$store.getters.saveing;
		},

		value: {
			get: function get() {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				return field.value;
			},
			set: function set(value) {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				field.value = value;
			}
		}
	},
	props: {
		field: {
			type: Object,
			default: function _default() {
				return {};
			}
		}
	},
	data: function data() {
		var channel = this.$store.getters.channel;
		return {
			fileEl: null,
			dropzoneOptions: {
				acceptedFiles: "image/*",
				paramName: '',
				maxFiles: 1,
				addRemoveLinks: true,
				url: channel.urls.assets.replace(':fieldname:', 'asset'),
				thumbnailWidth: 400,
				thumbnailHeight: 300,
				maxFilesize: 5 // 5 MB
			}
		};
	},
	created: function created() {
		this.dropzoneOptions.paramName = this.field.name;
		if (this.field.action) this.dropzoneOptions.url = this.field.action;
	},
	mounted: function mounted() {
		var self = this;
		if (this.$refs.dropzone && this.field.value) {
			forEach_default()(this.field.value, function (file, index) {

				self.$refs.dropzone.manuallyAddFile({
					name: file.basename,
					size: file.size ? file.size : 0
				}, file.url);
			});

			// this.value = this.field.value;
			// const size = (file.size ? file.size.size : 0);

		}
	},

	methods: extends_default()({}, fieldvalidation),
	uploadSuccess: function uploadSuccess(file, response) {
		console.log('uploadSuccess', file, response);
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a99895a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/f-files.vue
var f_files_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-files inputfield inputfield--files"},[_c('div',{staticClass:"row"},_vm._l((_vm.field.value),function(file){return _c('div',{staticClass:"col-xs-12 col-sm-4 col-md-3"},[_c('div',{staticClass:"f-files__card"},[(file.type == 'image')?_c('img',{staticClass:"f-files__entry f-files__entry--image",attrs:{"src":file.url,"alt":file.description ? file.description : ' '}}):_c('div',{staticClass:"f-files__entry f-files__entry--file"},[(file.icon)?_c('i',{staticClass:"fa",class:'fa-' + file.icon}):_vm._e()]),_vm._v(" "),_c('a',{staticClass:"st-btn st-btn--highlight st-btn--small",attrs:{"download":"","href":file.url}},[_vm._v(_vm._s(_vm.$t('Download {name}', {name: file.basename})))])])])})),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('vue-dropzone',{ref:"dropzone",attrs:{"id":"dropzone","vdropzone-success":"uploadSuccess","options":_vm.dropzoneOptions}})],1)])])}
var f_files_staticRenderFns = []
var f_files_esExports = { render: f_files_render, staticRenderFns: f_files_staticRenderFns }
/* harmony default export */ var form_f_files = (f_files_esExports);
// CONCATENATED MODULE: ./src/components/form/f-files.vue
function f_files_injectStyle (ssrContext) {
  __webpack_require__("OLMQ")
}
var f_files_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var f_files___vue_template_functional__ = false
/* styles */
var f_files___vue_styles__ = f_files_injectStyle
/* scopeId */
var f_files___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var f_files___vue_module_identifier__ = null
var f_files_Component = f_files_normalizeComponent(
  f_files,
  form_f_files,
  f_files___vue_template_functional__,
  f_files___vue_styles__,
  f_files___vue_scopeId__,
  f_files___vue_module_identifier__
)

/* harmony default export */ var components_form_f_files = (f_files_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/f-email_domain.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var f_email_domain = ({
	name: 'f-email-domain',
	computed: {
		systemdisable: function systemdisable() {
			var field = this.$store.getters.getEditFieldById(this.field.name);
			return field.disabled || this.$store.getters.loading || this.$store.getters.saveing;
		},

		value: {
			get: function get() {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				return field.value;
			},
			set: function set(value) {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				field.value = value;
			}
		}
	},
	props: {
		field: {
			type: Object,
			default: function _default() {
				return {};
			}
		}
	},
	methods: extends_default()({}, fieldvalidation)
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc6c4e1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/f-email_domain.vue
var f_email_domain_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.field.name)?_c('div',{staticClass:"f-email-domain inputfield inputfield--email-domain"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.getFieldValidation(_vm.field)),expression:"getFieldValidation(field)"},{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"st-input st-input--full",class:{'st-input--error': _vm.errors.has(_vm.field.name)},attrs:{"type":"text","disabled":_vm.systemdisable,"id":_vm.field.name,"name":_vm.field.name,"autocomplete":_vm.field.autocomplete,"placeholder":(_vm.field.placeholder ? _vm.$t(_vm.field.placeholder) : '')},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.field.name)),expression:"errors.has(field.name)"}],staticClass:"error"},[_vm._v("\n\t\t"+_vm._s(_vm.errors.first(_vm.field.name))+"\n\t")])]):_vm._e()}
var f_email_domain_staticRenderFns = []
var f_email_domain_esExports = { render: f_email_domain_render, staticRenderFns: f_email_domain_staticRenderFns }
/* harmony default export */ var form_f_email_domain = (f_email_domain_esExports);
// CONCATENATED MODULE: ./src/components/form/f-email_domain.vue
var f_email_domain_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var f_email_domain___vue_template_functional__ = false
/* styles */
var f_email_domain___vue_styles__ = null
/* scopeId */
var f_email_domain___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var f_email_domain___vue_module_identifier__ = null
var f_email_domain_Component = f_email_domain_normalizeComponent(
  f_email_domain,
  form_f_email_domain,
  f_email_domain___vue_template_functional__,
  f_email_domain___vue_styles__,
  f_email_domain___vue_scopeId__,
  f_email_domain___vue_module_identifier__
)

/* harmony default export */ var components_form_f_email_domain = (f_email_domain_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/f-checkbox.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var f_checkbox = ({
	name: 'f-checkbox',
	computed: {
		systemdisable: function systemdisable() {
			var field = this.$store.getters.getEditFieldById(this.field.name);
			return field.disabled || this.$store.getters.loading || this.$store.getters.saveing;
		},

		value: {
			get: function get() {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				return field.value;
			},
			set: function set(value) {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				field.value = value;
			}
		}
	},
	props: {
		field: {
			type: Object,
			default: function _default() {
				return {};
			}
		},
		autocommit: {
			type: Boolean,
			default: true
		}
	},
	methods: extends_default()({}, fieldvalidation)
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-398f109d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/f-checkbox.vue
var f_checkbox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.field.name)?_c('div',{staticClass:"f-checkbox"},[_c('div',{staticClass:"st-checkbox"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.getFieldValidation(_vm.field)),expression:"getFieldValidation(field)"},{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"st-checkbox__input",class:{'st-checkbox__input': _vm.errors.has(_vm.field.name)},attrs:{"type":"checkbox","autocomplete":_vm.field.autocomplete,"disabled":_vm.systemdisable,"id":_vm.field.name,"name":_vm.field.name},domProps:{"checked":Array.isArray(_vm.value)?_vm._i(_vm.value,null)>-1:(_vm.value)},on:{"change":function($event){var $$a=_vm.value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.value=$$a.concat([$$v]))}else{$$i>-1&&(_vm.value=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.value=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"st-checkbox__label",attrs:{"for":_vm.field.name}})])]):_vm._e()}
var f_checkbox_staticRenderFns = []
var f_checkbox_esExports = { render: f_checkbox_render, staticRenderFns: f_checkbox_staticRenderFns }
/* harmony default export */ var form_f_checkbox = (f_checkbox_esExports);
// CONCATENATED MODULE: ./src/components/form/f-checkbox.vue
function f_checkbox_injectStyle (ssrContext) {
  __webpack_require__("+/Q5")
}
var f_checkbox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var f_checkbox___vue_template_functional__ = false
/* styles */
var f_checkbox___vue_styles__ = f_checkbox_injectStyle
/* scopeId */
var f_checkbox___vue_scopeId__ = "data-v-398f109d"
/* moduleIdentifier (server only) */
var f_checkbox___vue_module_identifier__ = null
var f_checkbox_Component = f_checkbox_normalizeComponent(
  f_checkbox,
  form_f_checkbox,
  f_checkbox___vue_template_functional__,
  f_checkbox___vue_styles__,
  f_checkbox___vue_scopeId__,
  f_checkbox___vue_module_identifier__
)

/* harmony default export */ var components_form_f_checkbox = (f_checkbox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/f-contact-repeater.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var f_contact_repeater = ({
	name: 'f-contact-repeater',
	computed: {
		systemdisable: function systemdisable() {
			var field = this.$store.getters.getEditFieldById(this.field.name);
			return field.disabled || this.$store.getters.loading || this.$store.getters.saveing;
		},

		value: {
			get: function get() {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				field.value;
				return field.value;
			},
			set: function set(value) {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				field.value = value;
			}
		}
	},
	props: {
		field: {
			type: Object,
			default: function _default() {
				return {};
			}
		}
	},
	methods: {
		getFieldValidation: general.getFieldValidation,
		validate: function validate() {
			return new promise_default.a(function (resolve, reject) {
				resolve(true);
			});
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-529b3ed2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/f-contact-repeater.vue
var f_contact_repeater_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-contact-repeater"},[_c('table',{staticClass:"st-table st-table--full"},[_c('tr',[_c('th',{staticClass:"st-table__th st-table__th--position"}),_vm._v(" "),_c('th',{staticStyle:{"width":"150px"}},[_vm._v(_vm._s(_vm.$t('Contacts: Typ')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"40px"}},[_vm._v(_vm._s(_vm.$t('Contacts: Show')))]),_vm._v(" "),_c('th',[_vm._v("value")])]),_vm._v(" "),_c('draggable',{attrs:{"element":'tbody',"options":_vm._a(0,function(){return {forceFallback: true, animation: 150, handle:'.drag'}})},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.value),function(contact,index){return _c('tr',[_c('td',{staticClass:"st-table__td st-table__td--position"},[_c('i',{staticClass:"drag fa fa-bars"})]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa",class:'fa-'+(contact.icon ? contact.icon : contact.type)}),_vm._v(" "+_vm._s(_vm.$t((contact.title ? contact.title : contact.type)))+"\n\t\t\t\t")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"st-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(contact.checked),expression:"contact.checked"}],staticClass:"st-checkbox__input",attrs:{"id":index+'-'+contact.type,"type":"checkbox","disabled":_vm.systemdisable},domProps:{"checked":Array.isArray(contact.checked)?_vm._i(contact.checked,null)>-1:(contact.checked)},on:{"change":function($event){var $$a=contact.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(contact.checked=$$a.concat([$$v]))}else{$$i>-1&&(contact.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(contact, "checked", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"st-checkbox__label",attrs:{"for":index+'-'+contact.type}})])]),_vm._v(" "),_c('td',[(contact.type == 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(contact.value),expression:"contact.value"}],staticClass:"st-input st-input--sm st-input--full st-input--email",attrs:{"autocomplete":"email","type":"email","disabled":_vm.systemdisable},domProps:{"value":(contact.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(contact, "value", $event.target.value)}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(contact.value),expression:"contact.value"}],staticClass:"st-input st-input--sm st-input--full st-input--text",attrs:{"type":"text","autocomplete":"tel","disabled":_vm.systemdisable},domProps:{"value":(contact.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(contact, "value", $event.target.value)}}})])])}))],1)])}
var f_contact_repeater_staticRenderFns = []
var f_contact_repeater_esExports = { render: f_contact_repeater_render, staticRenderFns: f_contact_repeater_staticRenderFns }
/* harmony default export */ var form_f_contact_repeater = (f_contact_repeater_esExports);
// CONCATENATED MODULE: ./src/components/form/f-contact-repeater.vue
var f_contact_repeater_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var f_contact_repeater___vue_template_functional__ = false
/* styles */
var f_contact_repeater___vue_styles__ = null
/* scopeId */
var f_contact_repeater___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var f_contact_repeater___vue_module_identifier__ = null
var f_contact_repeater_Component = f_contact_repeater_normalizeComponent(
  f_contact_repeater,
  form_f_contact_repeater,
  f_contact_repeater___vue_template_functional__,
  f_contact_repeater___vue_styles__,
  f_contact_repeater___vue_scopeId__,
  f_contact_repeater___vue_module_identifier__
)

/* harmony default export */ var components_form_f_contact_repeater = (f_contact_repeater_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/f-email.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var f_email = ({
	name: 'f-email',
	computed: {
		systemdisable: function systemdisable() {
			var field = this.$store.getters.getEditFieldById(this.field.name);
			return field.disabled || this.$store.getters.loading || this.$store.getters.saveing;
		},

		value: {
			get: function get() {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				return field.value;
			},
			set: function set(value) {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				field.value = value;
			}
		}
	},
	props: {
		field: {
			type: Object,
			default: function _default() {
				return {};
			}
		}
	},
	methods: extends_default()({}, fieldvalidation)
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1370d28e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/f-email.vue
var f_email_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.field.name)?_c('div',{staticClass:"f-email inputfield inputfield--email"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.getFieldValidation(_vm.field)),expression:"getFieldValidation(field)"},{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"st-input st-input--full",class:{'st-input--error': _vm.errors.has(_vm.field.name)},attrs:{"type":"email","disabled":_vm.systemdisable,"id":_vm.field.name,"name":_vm.field.name,"autocomplete":_vm.field.autocomplete,"placeholder":(_vm.field.placeholder ? _vm.$t(_vm.field.placeholder) : '')},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.field.name)),expression:"errors.has(field.name)"}],staticClass:"error"},[_vm._v("\n\t\t"+_vm._s(_vm.errors.first(_vm.field.name))+"\n\t")])]):_vm._e()}
var f_email_staticRenderFns = []
var f_email_esExports = { render: f_email_render, staticRenderFns: f_email_staticRenderFns }
/* harmony default export */ var form_f_email = (f_email_esExports);
// CONCATENATED MODULE: ./src/components/form/f-email.vue
var f_email_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var f_email___vue_template_functional__ = false
/* styles */
var f_email___vue_styles__ = null
/* scopeId */
var f_email___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var f_email___vue_module_identifier__ = null
var f_email_Component = f_email_normalizeComponent(
  f_email,
  form_f_email,
  f_email___vue_template_functional__,
  f_email___vue_styles__,
  f_email___vue_scopeId__,
  f_email___vue_module_identifier__
)

/* harmony default export */ var components_form_f_email = (f_email_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CroppableImage.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// getMetadata
// applyMetadata

/* harmony default export */ var CroppableImage = ({
	name: 'CroppableImage',
	props: {
		fieldname: {
			type: String,
			default: 'image'
		},
		id: {
			type: Number,
			default: 0
		},
		pid: {
			type: Number,
			default: 0
		},
		cid: {
			type: Number,
			default: 0
		},
		type: {
			type: String,
			default: 'assets'
		},
		quality: {
			type: Number,
			default: 1
		},

		height: {
			type: Number,
			default: 320
		},
		width: {
			type: Number,
			default: 640
		},
		showStaticPreview: {
			type: Boolean,
			default: false
		}
	},
	data: function data() {
		return {
			isPreviewActive: false,
			showWidth: 0,
			showHeight: 0,
			original: false,
			asset: {},
			loading: false
		};
	},

	watch: {
		'fieldname': function fieldname() {
			this.init();
		},
		'id': function id() {
			this.init();
		},
		'type': function type() {
			this.init();
		},
		'width': function width() {
			this.init();
		},
		'height': function height() {
			this.init();
		},
		'quality': function quality() {
			this.$refs.image.refresh();
		}
	},
	mounted: function mounted() {
		this.init();
	},

	methods: extends_default()({}, rest, {
		croppaOnFileChoose: function croppaOnFileChoose(file) {
			this.original = file;
		},
		croppaOnInit: function croppaOnInit(croppa) {},
		save: function save() {
			var _this = this;

			var channel = this.$store.getters.channel,
			    self = this;

			var image = this.$refs.image,
			    imageID = self.id,
			    imageName = '';

			image.promisedBlob('image/png', this.quality).then(function (blob) {
				// '/assets/{aid}/{format}'
				var newImage = self.original;
				if (newImage) {
					var org_image_url = channel.urls.base + self.type + '/' + imageID;
					imageName = newImage.name;

					if (imageID <= 0) {
						org_image_url = channel.urls.postAsset.replace(':aid:', imageName);
					}
					if (self.pid > 0 && self.cid > 0) {
						org_image_url = channel.urls.base + 'presentations/' + self.pid + '/' + self.cid;
					}

					var formData = new FormData();
					formData.append(_this.fieldname, newImage, imageName);
					return self.restpost(org_image_url, formData, 'async').then(function (message) {
						var asset = asset = typeof message[self.fieldname] === 'undefined' ? message : message[self.fieldname];
						if (asset) {
							imageID = asset.id;
							self.original = false;
							self.$emit('input', imageID);
						}

						return blob;
					}).catch(function (err) {
						console.error(err);
					});
				} else {
					imageName = self.asset.basename;
					return blob;
				}
			}).then(function (blob) {
				if (imageID && self.width && self.height) {
					// '/assets/{aid}/{format}'
					var formData = new FormData();
					formData.append('metadata', stringify_default()(self.$refs.image.getMetadata()));
					formData.append(_this.fieldname, blob, imageName);

					return self.restpost(channel.urls.base + self.type + '/' + imageID + '/' + self.width + 'x' + self.height, formData, 'async').then(function (resp) {
						return resp;
					}).catch(function (err) {
						console.error(err);
					});
				}
			}).then(function (response) {
				self.$emit('saved', response);
			});
		},
		applyMeta: function applyMeta() {
			var _this2 = this;

			var self = this;
			if (this.asset.metadata) {
				self.$refs.image.applyMetadata(self.asset.metadata);
			} else if (self.asset.variations) {
				forEach_default()(self.asset.variations, function (variation) {
					if (variation.width == _this2.width && variation.height == _this2.height) {
						self.$refs.image.applyMetadata(variation.metadata);
					}
				});
			}
		},
		init: function init() {
			var channel = this.$store.getters.channel;
			var self = this,
			    reacts = this.$el.getBoundingClientRect();

			var scale = Math.min(reacts.width / this.width, (reacts.height > 150 ? reacts.height : window.innerHeight / 2) / this.height);

			this.showWidth = this.width * (scale <= 1 ? scale : 1);
			this.showHeight = this.height * (scale <= 1 ? scale : 1);

			if (self.id > 0) {
				self.loading = true;
				self.restget(channel.urls.base + self.type + '/' + self.id, 'async').then(function (message) {
					if (!message) return;
					var asset = false;
					if (asset = typeof message[self.fieldname] === 'undefined' ? message : message[self.fieldname]) {
						self.asset = asset;
						self.$emit('input', self.asset);
					}

					self.loading = false;
				});
			}
		}
	})
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e280c4b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CroppableImage.vue
var CroppableImage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CroppableImage"},[(_vm.loading)?_c('div',{staticClass:"CroppableImage__loading",style:('width:'+ _vm.showWidth + 'px; height:' + _vm.showHeight + 'px;')},[_c('div',{staticClass:"spinner"})]):(_vm.showStaticPreview && !_vm.isPreviewActive)?_c('div',[_c('img',{attrs:{"src":(_vm.asset ? (_vm.asset.original ? _vm.asset.original.url : _vm.asset.url) : ''),"alt":" "},on:{"click":function($event){_vm.isPreviewActive = !_vm.isPreviewActive}}})]):(_vm.showWidth > 0 && _vm.showHeight > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"CroppableImage__wrapper"},[_c('croppa',{ref:"image",class:{ 'CroppableImage__img': true, 'CroppableImage__img--round': _vm.type == 'users' },attrs:{"placeholder":_vm.$t('Choose an image'),"disable-drag-and-drop":false,"initial-image":(_vm.asset ? (_vm.asset.original ? _vm.asset.original.url : _vm.asset.url) : false),"initial-size":'contain',"replace-drop":true,"quality":_vm.width / _vm.showWidth,"width":_vm.showWidth,"height":_vm.showHeight,"disable-rotation":true,"remove-button-size":32,"remove-button-color":'#a3248f'},on:{"init":_vm.croppaOnInit,"file-choose":_vm.croppaOnFileChoose,"initial-image-loaded":_vm.applyMeta}})],1),_vm._v(" "),_c('div',[_c('button',{staticClass:"st-btn st-btn--primary st-btn--small",attrs:{"type":"button"},on:{"click":_vm.save}},[_vm._v("Save Image")]),_vm._v(" "),(_vm.showStaticPreview)?_c('button',{staticClass:"st-btn st-btn--error st-btn--small",attrs:{"type":"button"},on:{"click":function($event){_vm.isPreviewActive = !_vm.isPreviewActive}}},[_vm._v("Cancel")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"margin-top-medium margin-bottom-medium"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.$t('Hold left mouse button to move picture. Use Mousewheel to zoom in & out.'))+"\n\t\t\t\t")])])]):_vm._e()])}
var CroppableImage_staticRenderFns = []
var CroppableImage_esExports = { render: CroppableImage_render, staticRenderFns: CroppableImage_staticRenderFns }
/* harmony default export */ var components_CroppableImage = (CroppableImage_esExports);
// CONCATENATED MODULE: ./src/components/CroppableImage.vue
function CroppableImage_injectStyle (ssrContext) {
  __webpack_require__("JMQ1")
}
var CroppableImage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CroppableImage___vue_template_functional__ = false
/* styles */
var CroppableImage___vue_styles__ = CroppableImage_injectStyle
/* scopeId */
var CroppableImage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CroppableImage___vue_module_identifier__ = null
var CroppableImage_Component = CroppableImage_normalizeComponent(
  CroppableImage,
  components_CroppableImage,
  CroppableImage___vue_template_functional__,
  CroppableImage___vue_styles__,
  CroppableImage___vue_scopeId__,
  CroppableImage___vue_module_identifier__
)

/* harmony default export */ var src_components_CroppableImage = (CroppableImage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/f-image.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var f_image = ({
	name: 'f-image',
	components: {
		vueDropzone: vue2Dropzone_default.a,
		CroppableImage: src_components_CroppableImage
	},
	props: {
		field: {
			type: Object,
			default: function _default() {
				return {};
			}
		}
	},
	data: function data() {
		var channel = this.$store.getters.channel;
		return {
			fileEl: null,
			value: '',
			croppa: {},
			dropzoneOptions: {
				acceptedFiles: "image/*",
				paramName: '',
				maxFiles: 1,
				addRemoveLinks: true,
				url: channel.urls.assets.replace(':fieldname:', 'asset'),
				thumbnailWidth: 400,
				thumbnailHeight: 300,
				maxFilesize: 5 // 5 MB
			}
		};
	},
	created: function created() {
		this.dropzoneOptions.paramName = this.field.name;
		if (this.field.action) this.dropzoneOptions.url = this.field.action;
	},
	mounted: function mounted() {
		if (this.$refs.dropzone && this.field.value) {
			this.value = this.field.value;
			var size = this.field.size ? this.field.size : 0;

			var mockFile = { name: general.basename(this.field.value), size: size };
			this.$refs.dropzone.manuallyAddFile(mockFile, this.field.value);
		}
	},

	methods: extends_default()({}, fieldvalidation, {
		uploadSuccess: function uploadSuccess(file, response) {
			console.log('uploadSuccess', file, response);
		}
	})
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e5293be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/f-image.vue
var f_image_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.field)?_c('div',{staticClass:"f-image"},[(_vm.field.disabled && _vm.field.value)?_c('div',[_c('img',{staticStyle:{"max-height":"450px"},attrs:{"src":_vm.field.value,"alt":_vm.field.title}})]):(_vm.$store.getters['features/croppa'] && _vm.field.options && _vm.field.options.width && _vm.field.options.height)?_c('CroppableImage',{attrs:{"id":(_vm.field.options.id ? _vm.field.options.id : 0),"fieldname":(_vm.field.id ? _vm.field.id : 'image'),"type":(_vm.field.options.type ? _vm.field.options.type : 'assets'),"width":_vm.field.options.width,"height":_vm.field.options.height}}):_c('vue-dropzone',{ref:"dropzone",attrs:{"id":"dropzone","vdropzone-success":"uploadSuccess","options":_vm.dropzoneOptions}})],1):_vm._e()}
var f_image_staticRenderFns = []
var f_image_esExports = { render: f_image_render, staticRenderFns: f_image_staticRenderFns }
/* harmony default export */ var form_f_image = (f_image_esExports);
// CONCATENATED MODULE: ./src/components/form/f-image.vue
function f_image_injectStyle (ssrContext) {
  __webpack_require__("aDG2")
}
var f_image_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var f_image___vue_template_functional__ = false
/* styles */
var f_image___vue_styles__ = f_image_injectStyle
/* scopeId */
var f_image___vue_scopeId__ = "data-v-6e5293be"
/* moduleIdentifier (server only) */
var f_image___vue_module_identifier__ = null
var f_image_Component = f_image_normalizeComponent(
  f_image,
  form_f_image,
  f_image___vue_template_functional__,
  f_image___vue_styles__,
  f_image___vue_scopeId__,
  f_image___vue_module_identifier__
)

/* harmony default export */ var components_form_f_image = (f_image_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/f-password.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 Password Confirmation
password_confirmation
 */



/* harmony default export */ var f_password = ({
	name: 'f-password',
	computed: {
		systemdisable: function systemdisable() {
			var field = this.$store.getters.getEditFieldById(this.field.name);
			return field.disabled || this.$store.getters.loading || this.$store.getters.saveing;
		},

		value: {
			get: function get() {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				return field.value;
			},
			set: function set(value) {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				field.value = value;
			}
		}
	},
	data: function data() {
		return {
			password_confirmation: ''
		};
	},

	props: {
		field: {
			type: Object,
			default: function _default() {
				return {};
			}
		}
	},
	methods: extends_default()({}, fieldvalidation)
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-441668bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/f-password.vue
var f_password_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.field)?_c('div',{staticClass:"f-text inputfield inputfield--password"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.getFieldValidation(_vm.field)),expression:"getFieldValidation(field)"},{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"st-input st-input--full",class:{'st-input--error': _vm.errors.has(_vm.field.name)},attrs:{"type":"password","new-password":"true","autocomplete":_vm.field.autocomplete,"disabled":_vm.systemdisable,"id":_vm.field.name,"name":_vm.field.name,"placeholder":(_vm.field.placeholder ? _vm.$t(_vm.field.placeholder) : '')},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password_confirmation),expression:"password_confirmation"}],staticClass:"st-input st-input--full",class:{'st-input--error': _vm.errors.has(_vm.field.name)},attrs:{"type":"password","id":"password_confirmation","name":"password_confirmation","new-password":"true","autocomplete":_vm.field.autocomplete,"disabled":_vm.systemdisable,"placeholder":_vm.$t('Password Confirmation')},domProps:{"value":(_vm.password_confirmation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password_confirmation=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.field.name)),expression:"errors.has(field.name)"}],staticClass:"error"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.errors.first(_vm.field.name))+"\n\t\t\t")])])])]):_vm._e()}
var f_password_staticRenderFns = []
var f_password_esExports = { render: f_password_render, staticRenderFns: f_password_staticRenderFns }
/* harmony default export */ var form_f_password = (f_password_esExports);
// CONCATENATED MODULE: ./src/components/form/f-password.vue
function f_password_injectStyle (ssrContext) {
  __webpack_require__("eRPj")
}
var f_password_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var f_password___vue_template_functional__ = false
/* styles */
var f_password___vue_styles__ = f_password_injectStyle
/* scopeId */
var f_password___vue_scopeId__ = "data-v-441668bc"
/* moduleIdentifier (server only) */
var f_password___vue_module_identifier__ = null
var f_password_Component = f_password_normalizeComponent(
  f_password,
  form_f_password,
  f_password___vue_template_functional__,
  f_password___vue_styles__,
  f_password___vue_scopeId__,
  f_password___vue_module_identifier__
)

/* harmony default export */ var components_form_f_password = (f_password_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/f-select.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var f_select = ({
	name: 'f-select',
	components: {
		Selectize: vue2_selectize_default.a,
		MultiSelect: src_components_MultiSelect
	},
	data: function data() {
		return {
			selected: ''
		};
	},

	computed: {
		systemdisable: function systemdisable() {
			var field = this.$store.getters.getEditFieldById(this.field.name);
			return field.disabled || this.$store.getters.loading || this.$store.getters.saveing;
		},

		value: {
			get: function get() {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				return field.value;
			},
			set: function set(value) {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				field.value = value;
			}
		}
	},
	mounted: function mounted() {
		if (this.field.value) {
			this.selected = this.field.value;
		} else {
			this.selected = this.field.options[0].value;
		}
	},

	props: {
		field: {
			type: Object,
			default: function _default() {
				return {};
			}
		}
	},
	methods: extends_default()({}, fieldvalidation)
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6077dfe6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/f-select.vue
var f_select_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.field)?_c('div',{staticClass:"f-select inputfield inputfield--select"},[(_vm.field.multiple)?_c('MultiSelect',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.getFieldValidation(_vm.field)),expression:"getFieldValidation(field)"}],attrs:{"options":_vm.field.options,"disabled":_vm.systemdisable,"defaultValue":_vm.value},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_c('selectize',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.getFieldValidation(_vm.field)),expression:"getFieldValidation(field)"}],attrs:{"multiple":false,"disabled":_vm.systemdisable,"autocomplete":_vm.field.autocomplete},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.field.options),function(opt){return _c('option',{key:opt.value,domProps:{"value":opt.value}},[_vm._v(_vm._s((opt.translate ? _vm.$t(opt.label).trim() : opt.label)))])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.field.name)),expression:"errors.has(field.name)"}],staticClass:"error"},[_vm._v("\n\t\t"+_vm._s(_vm.errors.first(_vm.field.name))+"\n\t")])],1):_vm._e()}
var f_select_staticRenderFns = []
var f_select_esExports = { render: f_select_render, staticRenderFns: f_select_staticRenderFns }
/* harmony default export */ var form_f_select = (f_select_esExports);
// CONCATENATED MODULE: ./src/components/form/f-select.vue
var f_select_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var f_select___vue_template_functional__ = false
/* styles */
var f_select___vue_styles__ = null
/* scopeId */
var f_select___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var f_select___vue_module_identifier__ = null
var f_select_Component = f_select_normalizeComponent(
  f_select,
  form_f_select,
  f_select___vue_template_functional__,
  f_select___vue_styles__,
  f_select___vue_scopeId__,
  f_select___vue_module_identifier__
)

/* harmony default export */ var components_form_f_select = (f_select_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/f-text.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var f_text = ({
	name: 'f-text',
	computed: {
		systemdisable: function systemdisable() {
			var field = this.$store.getters.getEditFieldById(this.field.name);
			return field.disabled || this.$store.getters.loading || this.$store.getters.saveing;
		},

		value: {
			get: function get() {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				return field.value;
			},
			set: function set(value) {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				field.value = value;
			}
		}
	},
	props: {
		field: {
			type: Object,
			default: function _default() {
				return {};
			}
		}
	},
	methods: extends_default()({}, fieldvalidation)
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a91e703","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/f-text.vue
var f_text_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.field.name)?_c('div',{staticClass:"f-text inputfield inputfield--text"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.getFieldValidation(_vm.field)),expression:"getFieldValidation(field)"},{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"st-input st-input--full",class:{'st-input--error': _vm.errors.has(_vm.field.name)},attrs:{"type":"text","autocomplete":_vm.field.autocomplete,"disabled":_vm.systemdisable,"id":_vm.field.name,"name":_vm.field.name,"placeholder":(_vm.field.placeholder ? _vm.$t(_vm.field.placeholder) : '')},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.field.name)),expression:"errors.has(field.name)"}],staticClass:"error"},[_vm._v("\n\t\t"+_vm._s(_vm.errors.first(_vm.field.name))+"\n\t")])]):_vm._e()}
var f_text_staticRenderFns = []
var f_text_esExports = { render: f_text_render, staticRenderFns: f_text_staticRenderFns }
/* harmony default export */ var form_f_text = (f_text_esExports);
// CONCATENATED MODULE: ./src/components/form/f-text.vue
var f_text_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var f_text___vue_template_functional__ = false
/* styles */
var f_text___vue_styles__ = null
/* scopeId */
var f_text___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var f_text___vue_module_identifier__ = null
var f_text_Component = f_text_normalizeComponent(
  f_text,
  form_f_text,
  f_text___vue_template_functional__,
  f_text___vue_styles__,
  f_text___vue_scopeId__,
  f_text___vue_module_identifier__
)

/* harmony default export */ var components_form_f_text = (f_text_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/f-textarea.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var f_textarea = ({
	name: 'f-textarea',
	computed: {
		systemdisable: function systemdisable() {
			var field = this.$store.getters.getEditFieldById(this.field.name);
			return field.disabled || this.$store.getters.loading || this.$store.getters.saveing;
		},

		value: {
			get: function get() {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				return field.value;
			},
			set: function set(value) {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				field.value = value;
			}
		}
	},
	props: {
		field: {
			type: Object,
			default: function _default() {
				return {};
			}
		}
	},
	methods: extends_default()({}, fieldvalidation)
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f1e0a40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/f-textarea.vue
var f_textarea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.field)?_c('div',{staticClass:"f-textarea inputfield inputfield--textarea"},[_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.getFieldValidation(_vm.field)),expression:"getFieldValidation(field)"},{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"st-input st-input--full st-input--textarea",class:{'st-input--error': _vm.errors.has(_vm.field.name)},attrs:{"rows":"3","autocomplete":_vm.field.autocomplete,"disabled":_vm.systemdisable,"id":_vm.field.name,"name":_vm.field.name,"placeholder":(_vm.field.placeholder ? _vm.$t(_vm.field.placeholder) : '')},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.field.name)),expression:"errors.has(field.name)"}],staticClass:"error"},[_vm._v("\n\t\t"+_vm._s(_vm.errors.first(_vm.field.name))+"\n\t")])]):_vm._e()}
var f_textarea_staticRenderFns = []
var f_textarea_esExports = { render: f_textarea_render, staticRenderFns: f_textarea_staticRenderFns }
/* harmony default export */ var form_f_textarea = (f_textarea_esExports);
// CONCATENATED MODULE: ./src/components/form/f-textarea.vue
var f_textarea_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var f_textarea___vue_template_functional__ = false
/* styles */
var f_textarea___vue_styles__ = null
/* scopeId */
var f_textarea___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var f_textarea___vue_module_identifier__ = null
var f_textarea_Component = f_textarea_normalizeComponent(
  f_textarea,
  form_f_textarea,
  f_textarea___vue_template_functional__,
  f_textarea___vue_styles__,
  f_textarea___vue_scopeId__,
  f_textarea___vue_module_identifier__
)

/* harmony default export */ var components_form_f_textarea = (f_textarea_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-flatpickr-component/dist/vue-flatpickr.js
var vue_flatpickr = __webpack_require__("QKlT");
var vue_flatpickr_default = /*#__PURE__*/__webpack_require__.n(vue_flatpickr);

// EXTERNAL MODULE: ./node_modules/flatpickr/dist/l10n/de.js
var de = __webpack_require__("F306");
var de_default = /*#__PURE__*/__webpack_require__.n(de);

// EXTERNAL MODULE: ./node_modules/flatpickr/dist/flatpickr.css
var flatpickr = __webpack_require__("K4gw");
var flatpickr_default = /*#__PURE__*/__webpack_require__.n(flatpickr);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/f-datetime-local.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var f_datetime_local = ({
	name: 'f-datetime-local',
	components: {
		flatPickr: vue_flatpickr_default.a
	},
	computed: {
		systemdisable: function systemdisable() {
			var field = this.$store.getters.getEditFieldById(this.field.name);
			return field.disabled || this.$store.getters.loading || this.$store.getters.saveing;
		},

		value: {
			get: function get() {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				return field ? field.value : '';
			},
			set: function set(value) {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				if (field) {
					field.value = value;
				} else {
					console.error('field not defined');
				}
			}
		}
	},
	data: function data() {
		var val = this.value;
		if (!val) val = new Date().getTime();

		return {
			flatPickrConfig: {
				dateFormat: "l, d.m.Y H:i",
				defaultDate: [val],
				minuteIncrement: 30,
				time_24hr: true,
				enableTime: true,
				locale: de["German"]
			}
		};
	},

	props: {
		field: {
			type: Object,
			default: function _default() {
				return {};
			}
		}
	},
	methods: extends_default()({}, fieldvalidation)
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b0cc2c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/f-datetime-local.vue
var f_datetime_local_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.field.name)?_c('div',{staticClass:"f-datetime-local inputfield inputfield--text"},[_c('flat-pickr',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.getFieldValidation(_vm.field)),expression:"getFieldValidation(field)"}],staticClass:"st-input",attrs:{"disabled":_vm.systemdisable,"config":_vm.flatPickrConfig,"id":_vm.field.name,"name":_vm.field.name,"autocomplete":_vm.field.autocomplete,"placeholder":(_vm.field.placeholder ? _vm.$t(_vm.field.placeholder) : '')},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.field.name)),expression:"errors.has(field.name)"}],staticClass:"error"},[_vm._v("\n\t\t"+_vm._s(_vm.errors.first(_vm.field.name))+"\n\t")])],1):_vm._e()}
var f_datetime_local_staticRenderFns = []
var f_datetime_local_esExports = { render: f_datetime_local_render, staticRenderFns: f_datetime_local_staticRenderFns }
/* harmony default export */ var form_f_datetime_local = (f_datetime_local_esExports);
// CONCATENATED MODULE: ./src/components/form/f-datetime-local.vue
var f_datetime_local_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var f_datetime_local___vue_template_functional__ = false
/* styles */
var f_datetime_local___vue_styles__ = null
/* scopeId */
var f_datetime_local___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var f_datetime_local___vue_module_identifier__ = null
var f_datetime_local_Component = f_datetime_local_normalizeComponent(
  f_datetime_local,
  form_f_datetime_local,
  f_datetime_local___vue_template_functional__,
  f_datetime_local___vue_styles__,
  f_datetime_local___vue_scopeId__,
  f_datetime_local___vue_module_identifier__
)

/* harmony default export */ var components_form_f_datetime_local = (f_datetime_local_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-context/dist/vue-context.js
var vue_context = __webpack_require__("Zc2/");
var vue_context_default = /*#__PURE__*/__webpack_require__.n(vue_context);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/p-editor/c-chart-preview.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var c_chart_preview = ({
	name: 'c-chart-preview',
	components: {
		VueContext: vue_context["VueContext"]
	},

	computed: {
		backgroundImage: function backgroundImage() {
			return this.$store.getters.getBackgroundImageByChartId(this.data.id);
		},
		presentation: function presentation() {
			return this.$store.getters.presentation;
		},
		chart: function chart() {
			return this.$store.getters.getChartById(this.data.id);
		}
	},

	props: {
		data: {
			type: Object,
			default: function _default() {
				return {};
			}
		},

		child: {
			type: Boolean,
			default: false
		},

		small: {
			type: Boolean,
			default: false
		},

		visible: {
			type: Boolean,
			default: true
		},

		onlymaster: {
			type: Boolean,
			default: false
		},

		trashed: {
			type: Boolean,
			default: false
		},

		locked: {
			type: Boolean,
			default: false
		},
		refreshing: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		chart_component_exists: function chart_component_exists(chartname) {
			var ccexists = this.$store.getters.chartcomponents.indexOf(chartname) >= 0;
			if (!ccexists) console.info('chart component dosent exists', chartname);
			return ccexists;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3d3f9c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p-editor/c-chart-preview.vue
var c_chart_preview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"no-btn c-chart-preview st-chart-preview",class:{'st-chart-preview--active': _vm.$route.params.chartid == _vm.data.id, 'st-chart-preview--child': _vm.child,'st-chart-preview--locked': _vm.locked, 'st-chart-preview--hidden': !_vm.visible,  'st-chart-preview--trashed': _vm.trashed, 'st-chart-preview--small': _vm.small },attrs:{"type":"button"},on:{"contextmenu":function($event){$event.preventDefault();_vm.$refs.menu.open($event)},"click":function($event){_vm.$emit('click')}}},[_c('div',{staticClass:"st-chart-preview__img",style:((_vm.backgroundImage ? 'background-image: url(' + _vm.backgroundImage + ')' : ''))},[(_vm.chart_component_exists('v-chart-' + _vm.chart.component) && _vm.$store.getters['features/livepreview'])?_c('v-chart-' + _vm.chart.component,{key:_vm.chart.id,tag:"div",staticStyle:{"pointer-events":"none","position":"absolute","top":"0","right":"0","left":"0","bottom":"0"},attrs:{"preview":true,"data":_vm.chart}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"st-chart-preview__wrap"},[(!_vm.data.image)?_c('div',{staticClass:"st-chart-preview__alttext"},[(_vm.data.fields && _vm.data.fields.title)?_c('strong',[_vm._v(_vm._s(_vm.data.fields.title.value))]):_c('strong',[_vm._v(_vm._s(_vm.data.template))])]):_vm._e()]),_vm._v(" "),(!_vm.visible || _vm.trashed || _vm.locked || _vm.refreshing)?_c('div',{staticClass:"st-chart-preview__overlay"},[(_vm.trashed)?_c('div',{staticClass:"st-chart-preview__oicon"},[_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}})]):(_vm.locked)?_c('div',{staticClass:"st-chart-preview__oicon"},[_c('i',{staticClass:"fa fa-lock",attrs:{"aria-hidden":"true"}})]):(!_vm.visible)?_c('div',{staticClass:"st-chart-preview__oicon"},[_c('i',{staticClass:"fa fa-eye-slash",attrs:{"aria-hidden":"true"}})]):(!_vm.refreshing)?_c('div',{staticClass:"st-chart-preview__oicon"},[_c('i',{staticClass:"fa fa-refresh",attrs:{"aria-hidden":"true"}})]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('vue-context',{ref:"menu"},[_c('ul',[((_vm.presentation.addablecharts && _vm.presentation.addablecharts.length > 0))?_c('li',{on:{"click":function($event){_vm.$store.commit('START_ADDCHART', {
					position: _vm.chart.position
				})}}},[_vm._v(_vm._s(_vm.$t('new Slide')))]):_vm._e(),_vm._v(" "),((_vm.chart.addablecharts && _vm.chart.addablecharts.length > 0))?_c('li',{on:{"click":function($event){_vm.$store.commit('START_ADDCHART', {
					parent: _vm.chart.id
				})}}},[_vm._v(_vm._s(_vm.$t('new Child Slide')))]):_vm._e(),_vm._v(" "),(!_vm.chart.visible && _vm.chart.permissions.can_change_visible && _vm.chart.permissions && _vm.chart.permissions.can_edit)?_c('li',{on:{"click":function($event){_vm.$store.commit('TOGGLE_CHART_VISIBILITY', _vm.chart.id)}}},[_vm._v(_vm._s(_vm.$t('show Chart')))]):_vm._e(),_vm._v(" "),(_vm.chart.visible && _vm.chart.permissions.can_change_visible && _vm.chart.permissions && _vm.chart.permissions.can_edit)?_c('li',{on:{"click":function($event){_vm.$store.commit('TOGGLE_CHART_VISIBILITY', _vm.chart.id)}}},[_vm._v(_vm._s(_vm.$t('hide Chart')))]):_vm._e(),_vm._v(" "),(_vm.chart.permissions.can_delete && _vm.chart.permissions && _vm.chart.permissions.can_edit)?_c('li',{staticClass:"delete",on:{"click":function($event){_vm.$store.commit('TOGGLE_CHART_TRASHED', _vm.chart.id)}}},[_vm._v(_vm._s(_vm.$t('delete Chart')))]):_vm._e()])])],1)}
var c_chart_preview_staticRenderFns = []
var c_chart_preview_esExports = { render: c_chart_preview_render, staticRenderFns: c_chart_preview_staticRenderFns }
/* harmony default export */ var p_editor_c_chart_preview = (c_chart_preview_esExports);
// CONCATENATED MODULE: ./src/components/p-editor/c-chart-preview.vue
function c_chart_preview_injectStyle (ssrContext) {
  __webpack_require__("4f9P")
}
var c_chart_preview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var c_chart_preview___vue_template_functional__ = false
/* styles */
var c_chart_preview___vue_styles__ = c_chart_preview_injectStyle
/* scopeId */
var c_chart_preview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var c_chart_preview___vue_module_identifier__ = null
var c_chart_preview_Component = c_chart_preview_normalizeComponent(
  c_chart_preview,
  p_editor_c_chart_preview,
  c_chart_preview___vue_template_functional__,
  c_chart_preview___vue_styles__,
  c_chart_preview___vue_scopeId__,
  c_chart_preview___vue_module_identifier__
)

/* harmony default export */ var components_p_editor_c_chart_preview = (c_chart_preview_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/f-user-slides.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var f_user_slides = ({
	name: 'f-user-slides',
	components: {
		CChartPreview: components_p_editor_c_chart_preview
	},
	computed: {
		caneditor: function caneditor() {
			return (!this.edituser.addablecharts || keys_default()(this.edituser.addablecharts).length <= 0) && (!this.edituser.charts || keys_default()(this.edituser.charts).length <= 0);
		},
		presentation: function presentation() {
			return this.$store.getters.presentation;
		},
		edituser: function edituser() {
			return this.$store.getters.edituser;
		}
	},
	props: {
		field: {
			type: Object,
			default: function _default() {
				return {};
			}
		}
	},
	data: function data() {
		return {
			hide: false,
			small: false,
			trashed: false
		};
	},

	methods: extends_default()({}, fieldvalidation)
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29683cd6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/f-user-slides.vue
var f_user_slides_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-user-slides"},[(_vm.edituser.presentation && _vm.edituser.presentation.charts)?_c('div',{staticClass:"row"},_vm._l((_vm.presentation.charts),function(data){return _c('div',{key:data.id,staticClass:"col-xs-6 col-sm-4 col-md-3"},[(data.id > 0)?_c('router-link',{staticClass:"router-link st-chart-preview",class:{ 'c-chart-list-item--trashed': data.id <= 0, 'st-chart-preview--show': !_vm.hide, 'st-chart-preview--hide': _vm.hide, 'st-chart-preview--small': _vm.small },attrs:{"to":_vm._a(0,function(){return { name: _vm.field.namespace + '-chart', params: { chartid : data.id }}})}},[_c('c-chart-preview',{attrs:{"data":data,"visible":data.visible,"trashed":data.trashed,"locked":(!data.permissions.can_edit && !data.permissions.can_change_edit)}})],1):_vm._e()],1)})):_vm._e(),_vm._v(" "),(_vm.caneditor)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('router-link',{staticClass:"inline-block st-btn st-btn--small",attrs:{"type":"button","to":_vm._a(1,function(){return { name: _vm.field.namespace + '-editor' }})}},[_vm._v(_vm._s(_vm.$t('to the editor')))])],1)]):_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_vm._v("\n\t\t\t"+_vm._s(_vm.$t('no Presentation'))+"\n\t\t")])])])}
var f_user_slides_staticRenderFns = []
var f_user_slides_esExports = { render: f_user_slides_render, staticRenderFns: f_user_slides_staticRenderFns }
/* harmony default export */ var form_f_user_slides = (f_user_slides_esExports);
// CONCATENATED MODULE: ./src/components/form/f-user-slides.vue
function f_user_slides_injectStyle (ssrContext) {
  __webpack_require__("wBQz")
}
var f_user_slides_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var f_user_slides___vue_template_functional__ = false
/* styles */
var f_user_slides___vue_styles__ = f_user_slides_injectStyle
/* scopeId */
var f_user_slides___vue_scopeId__ = "data-v-29683cd6"
/* moduleIdentifier (server only) */
var f_user_slides___vue_module_identifier__ = null
var f_user_slides_Component = f_user_slides_normalizeComponent(
  f_user_slides,
  form_f_user_slides,
  f_user_slides___vue_template_functional__,
  f_user_slides___vue_styles__,
  f_user_slides___vue_scopeId__,
  f_user_slides___vue_module_identifier__
)

/* harmony default export */ var components_form_f_user_slides = (f_user_slides_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VueGoogleAutocomplete.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var VueGoogleAutocomplete = ({
	name: 'VueGoogleAutocomplete',

	props: {
		id: {
			type: String,
			required: true
		},

		classname: String,

		placeholder: {
			type: String,
			default: ''
		},

		types: {
			type: String,
			default: 'address'
		},

		defaultvalue: {
			type: String,
			default: ''
		},

		country: {
			type: [String, Array],
			default: null
		},

		enableGeolocation: {
			type: Boolean,
			default: false
		}
	},

	data: function data() {
		return {
			/**
    * The Autocomplete object.
    *
    * @type {Autocomplete}
    * @link https://developers.google.com/maps/documentation/javascript/reference#Autocomplete
    */
			autocomplete: null,

			/**
    * Autocomplete input text
    * @type {String}
    */
			autocompleteText: ''
		};
	},

	watch: {
		autocompleteText: function autocompleteText(newVal, oldVal) {
			this.$emit('inputChange', { newVal: newVal, oldVal: oldVal }, this.id);
			this.$emit('input', newVal);
		},
		country: function country(newVal, oldVal) {
			this.autocomplete.setComponentRestrictions({
				country: this.country === null ? [] : this.country
			});
		}
	},

	mounted: function mounted() {
		var _this = this;

		var options = {};

		if (this.types) {
			options.types = [this.types];
		}

		if (this.country) {
			options.componentRestrictions = {
				country: this.country
			};
		}
		if (this.defaultvalue) {
			this.update(this.defaultvalue);
		}

		this.autocomplete = new google.maps.places.Autocomplete(document.getElementById(this.id), options);

		this.autocomplete.addListener('place_changed', function () {

			var place = _this.autocomplete.getPlace();

			if (!place.geometry) {
				// User entered the name of a Place that was not suggested and
				// pressed the Enter key, or the Place Details request failed.
				_this.$emit('no-results-found', place, _this.id);
				return;
			}

			var addressComponents = {
				street_number: 'short_name',
				route: 'long_name',
				locality: 'long_name',
				administrative_area_level_1: 'short_name',
				administrative_area_level_2: 'county',
				country: 'long_name',
				postal_code: 'short_name'
			};

			var returnData = {};

			if (place.address_components !== undefined) {
				// Get each component of the address from the place details
				for (var i = 0; i < place.address_components.length; i++) {
					var addressType = place.address_components[i].types[0];

					if (addressComponents[addressType]) {
						var val = place.address_components[i][addressComponents[addressType]];
						returnData[addressType] = val;
					}
				}

				returnData['latitude'] = place.geometry.location.lat();
				returnData['longitude'] = place.geometry.location.lng();

				// return returnData object and PlaceResult object
				_this.$emit('placechanged', returnData, place, _this.id);

				// update autocompleteText then emit change event
				_this.autocompleteText = document.getElementById(_this.id).value;
				_this.onChange();
				_this.$emit('input', _this.autocompleteText);
			}
		});
	},

	methods: {
		/**
   * When the input gets focus
   */
		onFocus: function onFocus() {
			this.geolocate();
			this.$emit('focus');
		},


		/**
   * When the input loses focus
   */
		onBlur: function onBlur() {
			this.$emit('blur');
		},


		/**
   * When the input got changed
   */
		onChange: function onChange() {
			this.$emit('change', this.autocompleteText);
		},


		/**
   * When a key gets pressed
   * @param  {Event} event A keypress event
   */
		onKeyPress: function onKeyPress(event) {
			this.$emit('keypress', event);
		},


		/**
   * When a keyup occurs
   * @param  {Event} event A keyup event
   */
		onKeyUp: function onKeyUp(event) {
			this.$emit('keyup', event);
		},


		/**
   * Clear the input
   */
		clear: function clear() {
			this.autocompleteText = '';
		},


		/**
   * Focus the input
   */
		focus: function focus() {
			this.$refs.autocomplete.focus();
		},


		/**
   * Blur the input
   */
		blur: function blur() {
			this.$refs.autocomplete.blur();
		},


		/**
   * Update the value of the input
   * @param  {String} value
   */
		update: function update(value) {
			this.autocompleteText = value;
		},


		// Bias the autocomplete object to the user's geographical location,
		// as supplied by the browser's 'navigator.geolocation' object.
		geolocate: function geolocate() {
			var _this2 = this;

			if (this.enableGeolocation) {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(function (position) {
						var geolocation = {
							lat: position.coords.latitude,
							lng: position.coords.longitude
						};
						var circle = new google.maps.Circle({
							center: geolocation,
							radius: position.coords.accuracy
						});
						_this2.autocomplete.setBounds(circle.getBounds());
					});
				}
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-113a2f41","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueGoogleAutocomplete.vue
var VueGoogleAutocomplete_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.autocompleteText),expression:"autocompleteText"}],ref:"autocomplete",class:_vm.classname,attrs:{"type":"text","id":_vm.id,"placeholder":_vm.placeholder},domProps:{"value":(_vm.autocompleteText)},on:{"focus":function($event){_vm.onFocus()},"blur":function($event){_vm.onBlur()},"change":_vm.onChange,"keypress":_vm.onKeyPress,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.autocompleteText=$event.target.value}}})}
var VueGoogleAutocomplete_staticRenderFns = []
var VueGoogleAutocomplete_esExports = { render: VueGoogleAutocomplete_render, staticRenderFns: VueGoogleAutocomplete_staticRenderFns }
/* harmony default export */ var components_VueGoogleAutocomplete = (VueGoogleAutocomplete_esExports);
// CONCATENATED MODULE: ./src/components/VueGoogleAutocomplete.vue
var VueGoogleAutocomplete_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var VueGoogleAutocomplete___vue_template_functional__ = false
/* styles */
var VueGoogleAutocomplete___vue_styles__ = null
/* scopeId */
var VueGoogleAutocomplete___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VueGoogleAutocomplete___vue_module_identifier__ = null
var VueGoogleAutocomplete_Component = VueGoogleAutocomplete_normalizeComponent(
  VueGoogleAutocomplete,
  components_VueGoogleAutocomplete,
  VueGoogleAutocomplete___vue_template_functional__,
  VueGoogleAutocomplete___vue_styles__,
  VueGoogleAutocomplete___vue_scopeId__,
  VueGoogleAutocomplete___vue_module_identifier__
)

/* harmony default export */ var src_components_VueGoogleAutocomplete = (VueGoogleAutocomplete_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/f-map-marker.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var f_map_marker = ({
	name: 'f-map-marker',
	components: {
		VueGoogleAutocomplete: src_components_VueGoogleAutocomplete
	},
	computed: {
		systemdisable: function systemdisable() {
			var field = this.$store.getters.getEditFieldById(this.field.name);
			return field.disabled || this.$store.getters.loading || this.$store.getters.saveing;
		},

		value: {
			get: function get() {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				return field.value;
			},
			set: function set(value) {
				var field = this.$store.getters.getEditFieldById(this.field.name);
				field.value = value;
			}
		}
	},
	props: {
		field: {
			type: Object,
			default: function _default() {
				return {};
			}
		}
	},
	mounted: function mounted() {
		if (typeof google.maps.places.Autocomplete == 'undefined') {
			console.error('Google Maps Autocomplete is not installed or ready!');
		}
	},

	methods: extends_default()({}, fieldvalidation, {
		addMapMarker: function addMapMarker(ev) {
			if (typeof_default()(this.value) !== 'object') this.value = [];
			this.value.push({
				address: '',
				title: ''
			});
		},
		removeMapMarker: function removeMapMarker(index) {
			this.value.splice(index, 1);
		},
		getMarkerUrl: function getMarkerUrl(markers) {
			var out = 'http://sales-tool.linienflug.design/map.html?',
			    first = true;

			forEach_default()(markers, function (value, key) {
				if (!first) out += '&';
				out += 'markers[]=' + encodeURI(value.address);
				first = false;
			});

			return out;
		}
	})
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61c23b7b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/f-map-marker.vue
var f_map_marker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-map-marker"},[_c('table',{staticClass:"st-table st-table--full"},[_vm._m(0),_vm._v(" "),_c('draggable',{attrs:{"element":'tbody',"options":_vm._a(0,function(){return {forceFallback: true, animation: 150, handle:'.drag'}})},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.value),function(marker,index){return _c('tr',[_c('td',{staticClass:"st-table__td st-table__td--position"},[_c('i',{staticClass:"drag fa fa-bars"})]),_vm._v(" "),_c('td',[_c('vue-google-autocomplete',{ref:"address",refInFor:true,staticClass:"st-input st-input--sm st-input--full st-input--text",attrs:{"defaultvalue":marker.address,"id":'marker-'+index,"placeholder":"","disabled":_vm.systemdisable},model:{value:(marker.address),callback:function ($$v) {_vm.$set(marker, "address", $$v)},expression:"marker.address"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(marker.title),expression:"marker.title"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"st-input st-input--sm st-input--full st-input--text",attrs:{"type":"text","name":'map-marker',"disabled":_vm.systemdisable},domProps:{"value":(marker.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(marker, "title", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"st-table__td st-table__td--remove"},[_c('button',{staticClass:"st-btn st-btn--small",attrs:{"type":"button"},on:{"click":function($event){_vm.removeMapMarker(index)}}},[_vm._v("x")])])])})),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"4"}},[_c('button',{staticClass:"st-btn st-btn--small",attrs:{"type":"button"},on:{"click":_vm.addMapMarker}},[_vm._v("+")])])])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.field.name)),expression:"errors.has(field.name)"}],staticClass:"error"},[_vm._v("\n\t\t"+_vm._s(_vm.errors.first(_vm.field.name))+"\n\t")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":_vm.getMarkerUrl(_vm.value)}},[_vm._v("Google Maps")])])}
var f_map_marker_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"st-table__th st-table__th--position"}),_vm._v(" "),_c('th',[_vm._v("Address")]),_vm._v(" "),_c('th',[_vm._v("Title")]),_vm._v(" "),_c('th',{staticClass:"st-table__th st-table__th--remove"})])}]
var f_map_marker_esExports = { render: f_map_marker_render, staticRenderFns: f_map_marker_staticRenderFns }
/* harmony default export */ var form_f_map_marker = (f_map_marker_esExports);
// CONCATENATED MODULE: ./src/components/form/f-map-marker.vue
var f_map_marker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var f_map_marker___vue_template_functional__ = false
/* styles */
var f_map_marker___vue_styles__ = null
/* scopeId */
var f_map_marker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var f_map_marker___vue_module_identifier__ = null
var f_map_marker_Component = f_map_marker_normalizeComponent(
  f_map_marker,
  form_f_map_marker,
  f_map_marker___vue_template_functional__,
  f_map_marker___vue_styles__,
  f_map_marker___vue_scopeId__,
  f_map_marker___vue_module_identifier__
)

/* harmony default export */ var components_form_f_map_marker = (f_map_marker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/f-fieldset.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// Vue.component('f-checkbox', 		FCheckbox);

// Vue.component('f-contact-repeater', FContactRepeater);

// Vue.component('f-email', 			FEmail);

// Vue.component('f-image', 			FImage);

// Vue.component('f-password', 		FPassword);

// Vue.component('f-select', 			FSelect);

// Vue.component('f-text', 			FText);

// Vue.component('f-textarea', 		FTextarea);

// Vue.component('f-datetime-local', 	FDatetimeLocal);

// Vue.component('f-user-slides', 		FUserSlides);

// Vue.component('f-map-marker', 		FMapMarker);

/* harmony default export */ var f_fieldset = ({
	name: 'f-fieldset',
	components: {
		FFiles: components_form_f_files,
		FEmailDomain: components_form_f_email_domain,
		FCheckbox: components_form_f_checkbox,
		FContactRepeater: components_form_f_contact_repeater,
		FEmail: components_form_f_email,
		FImage: components_form_f_image,
		FPassword: components_form_f_password,
		FSelect: components_form_f_select,
		FText: components_form_f_text,
		FTextarea: components_form_f_textarea,
		FDatetimeLocal: components_form_f_datetime_local,
		FUserSlides: components_form_f_user_slides,
		FMapMarker: components_form_f_map_marker
	},
	props: {
		level: {
			type: Number,
			default: 0
		},
		field: {
			type: Object,
			default: function _default() {
				return {};
			}
		}
	},
	methods: {
		validateErrors: function validateErrors(errors) {
			var _this = this;

			var success = true;
			errors.forEach(function (result) {
				if ((typeof result === 'undefined' ? 'undefined' : typeof_default()(result)) === 'object') {
					var childres = _this.validateErrors(result);
					if (childres !== true) success = false;
				} else {
					if (result !== true) success = false;
				}
			});

			return success;
		},
		validate: function validate() {
			var self = this;
			return new promise_default.a(function (resolve, reject) {

				var promises = [];
				for (var child in self.$refs.fields) {
					promises.push(self.$refs.fields[child].validate());
				}

				promise_default.a.all(promises).then(function (errors) {
					var success = self.validateErrors(errors);

					if (success) {
						resolve(errors);
					} else {
						reject(errors);
					}
				}).catch(function (err) {
					reject(err);
				});
			});
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a001530","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/f-fieldset.vue
var f_fieldset_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.field)?_c('div',{staticClass:"f-fieldset"},[_c('fieldset',{staticClass:"st-form__fieldset st-form__fieldset",class:'st-form__fieldset--'+_vm.level,attrs:{"name":(_vm.field.name ? _vm.field.name : '')}},[(_vm.level == 0)?_c('div',[(_vm.field.title)?_c('legend',{staticClass:"st-form__legend"},[_vm._v(_vm._s(_vm.$t(_vm.field.title)))]):_vm._e(),_vm._v(" "),_vm._l((_vm.field.fields),function(field){return _c('div',{key:field.name,staticClass:"row st-form__row"},[_c('div',{staticClass:"col-xs-12 col-md-4 col-lg-3"},[_c('label',{staticClass:"st-label st-label--image",class:{ 'st-label--required': field.required},attrs:{"for":"image"}},[_vm._v(_vm._s(_vm.$t(field.title)))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-8 col-lg-9"},[_c('f-' + field.type,{ref:"fields",refInFor:true,tag:"div",attrs:{"level":_vm.level+1,"field":field}}),_vm._v(" "),(field.description)?_c('div',{staticClass:"st-form__description"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.$t(field.description))+"\n\t\t\t\t\t")]):_vm._e()])])})],2):_c('div',{staticClass:"row"},_vm._l((_vm.field.fields),function(field){return _c('div',{key:field.name,staticClass:"col-xs-12 col-sm-6"},[_c('f-' + field.type,{ref:"fields",refInFor:true,tag:"div",attrs:{"level":_vm.level+1,"field":field}})])}))])]):_vm._e()}
var f_fieldset_staticRenderFns = []
var f_fieldset_esExports = { render: f_fieldset_render, staticRenderFns: f_fieldset_staticRenderFns }
/* harmony default export */ var form_f_fieldset = (f_fieldset_esExports);
// CONCATENATED MODULE: ./src/components/form/f-fieldset.vue
function f_fieldset_injectStyle (ssrContext) {
  __webpack_require__("hekq")
}
var f_fieldset_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var f_fieldset___vue_template_functional__ = false
/* styles */
var f_fieldset___vue_styles__ = f_fieldset_injectStyle
/* scopeId */
var f_fieldset___vue_scopeId__ = "data-v-7a001530"
/* moduleIdentifier (server only) */
var f_fieldset___vue_module_identifier__ = null
var f_fieldset_Component = f_fieldset_normalizeComponent(
  f_fieldset,
  form_f_fieldset,
  f_fieldset___vue_template_functional__,
  f_fieldset___vue_styles__,
  f_fieldset___vue_scopeId__,
  f_fieldset___vue_module_identifier__
)

/* harmony default export */ var components_form_f_fieldset = (f_fieldset_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/FieldForm.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var FieldForm = ({
	name: 'FieldForm',
	components: {
		FFieldset: components_form_f_fieldset
	},
	computed: {
		saveing: function saveing() {
			return this.$store.getters.saveing;
		}
	},
	props: {
		formtype: {
			default: 'user'
		},
		formfields: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		cancelable: {
			type: Boolean,
			default: false
		},
		usernotice: {
			type: Boolean,
			default: false
		},
		isnew: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		getSaveableFields: function getSaveableFields(fields) {
			var self = this;
			var out = {};
			fields.forEach(function (item) {
				if (item.type == "files") return; //weiter
				if (item.type == "image") return; //weiter
				if (item.type == "user-slides") return; //weiter

				if (typeof item.value !== 'undefined') {
					out[item.name] = item.value;
				}

				if (item.fields) {
					out = assign_default()({}, out, self.getSaveableFields(item.fields));
				}
			});
			return out;
		},
		getAndValid: function getAndValid() {
			var self = this;
			return new promise_default.a(function (resolve, reject) {

				var promises = [];
				for (var child in self.$refs.fieldset) {
					promises.push(self.$refs.fieldset[child].validate());
				}

				promise_default.a.all(promises).then(function (result) {
					var payload = self.getSaveableFields(self.formfields);
					resolve(payload);
				}).catch(function (errors) {
					reject(errors);
				});
			});
		},
		create: function create(ev) {
			var self = this;
			ev.preventDefault();

			this.getAndValid().then(function (payload) {
				self.$emit('create', payload);
			}).catch(function (errors) {
				console.error(errors);
				self.$store.commit('ADD_NOTICE', {
					'text': 'There are errors in the Form',
					'type': 'error'
				});
			});
		},
		save: function save(ev) {
			var self = this;
			ev.preventDefault();

			this.getAndValid().then(function (payload) {
				self.$emit('save', payload);
			}).catch(function (errors) {
				console.error(errors);
				self.$store.commit('ADD_NOTICE', {
					'text': 'There are errors in the Form',
					'type': 'error'
				});
			});
		},
		cancel: function cancel(ev) {
			this.$emit('cancel');
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aacd4e6c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/FieldForm.vue
var FieldForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formfields.length > 0)?_c('form',{staticClass:"FieldForm",attrs:{"action":_vm.$route.path},on:{"submit":function($event){$event.preventDefault();}}},[_vm._l((_vm.formfields),function(field){return (field.fields.length > 0)?_c('f-' + field.type,{key:field.name,ref:"fieldset",refInFor:true,tag:"div",attrs:{"field":field}}):_vm._e()}),_vm._v(" "),(_vm.usernotice)?_c('div',{staticClass:"st-form__fieldset"},[_c('div',{staticClass:"st-notice"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-11"},[_c('div',{staticClass:"user-content-wrapper"},[_vm._v("\n\t                    "+_vm._s(_vm.$t("After submitting this form, an automatic e-mail will be sent with login information to the specified address."))+"\n\t                ")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"st-form__fieldset"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[(_vm.cancelable)?_c('button',{staticClass:"no-btn inline-nav",attrs:{"type":"button","title":_vm.$t('Cancel')},on:{"click":function($event){_vm.$emit('cancel')}}},[_vm._v(_vm._s(_vm.$t('Cancel')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 text-sm-right"},[(!_vm.isnew && _vm.formtype == 'präsentation')?_c('router-link',{staticClass:"inline-block st-btn",attrs:{"type":"button","to":_vm._a(0,function(){return { name: 'editor' }})}},[_vm._v(_vm._s(_vm.$t('to the editor')))]):_vm._e(),_vm._v(" "),(_vm.isnew)?_c('button',{staticClass:"st-btn st-btn--submit",class:{'st-btn--loading':_vm.saveing},attrs:{"type":"button","disabled":_vm.saveing},on:{"click":_vm.create}},[_vm._v(_vm._s(_vm.$t('Create')))]):_c('button',{staticClass:"st-btn st-btn--submit",class:{'st-btn--loading':_vm.saveing},attrs:{"type":"button","disabled":_vm.saveing},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('Save')))])],1)])])],2):_vm._e()}
var FieldForm_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-sm-1"},[_c('i',{staticClass:"fa fa-hand-o-right",attrs:{"aria-hidden":"true"}})])}]
var FieldForm_esExports = { render: FieldForm_render, staticRenderFns: FieldForm_staticRenderFns }
/* harmony default export */ var form_FieldForm = (FieldForm_esExports);
// CONCATENATED MODULE: ./src/components/form/FieldForm.vue
function FieldForm_injectStyle (ssrContext) {
  __webpack_require__("Xp6x")
}
var FieldForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FieldForm___vue_template_functional__ = false
/* styles */
var FieldForm___vue_styles__ = FieldForm_injectStyle
/* scopeId */
var FieldForm___vue_scopeId__ = "data-v-aacd4e6c"
/* moduleIdentifier (server only) */
var FieldForm___vue_module_identifier__ = null
var FieldForm_Component = FieldForm_normalizeComponent(
  FieldForm,
  form_FieldForm,
  FieldForm___vue_template_functional__,
  FieldForm___vue_styles__,
  FieldForm___vue_scopeId__,
  FieldForm___vue_module_identifier__
)

/* harmony default export */ var components_form_FieldForm = (FieldForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PagePresentationSettings.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Base


// Componenets

// funktion

// helper



/* harmony default export */ var PagePresentationSettings = ({
	name: 'PagePresentationSettings',
	components: {
		FieldForm: components_form_FieldForm
	},
	computed: {
		presentation: function presentation() {
			return this.$store.getters.presentation;
		}
	},
	props: {
		pid: {
			type: String,
			default: 'new'
		}
	},

	created: function created() {
		this.update();
	},
	mounted: function mounted() {
		this.update();
	},
	updated: function updated() {

		if (!this.$store.getters.loadings.presentationform && this.$store.getters.presentation && this.$store.getters.presentation.id != this.pid) {
			this.update();
		}
	},

	methods: extends_default()({}, rest, {
		reset: function reset() {
			this.$store.commit('RESET_EDITUSER');
			this.$store.commit('RESET_ACTIVE_FIELD');
			this.$store.commit('RESET_PRESENTATIONID');
			this.$store.commit('UNSET_PRESENTATION');
			this.$store.commit('UNSET_ADDABLECHARTS');
			this.$store.commit('UNSET_CHARTS');
		},
		save: function save(payload) {
			var self = this;
			if (self.id && self.id == 'new') return this.create(payload);
			self.restpatch(self.$store.getters.channel.urls.presentation.replace(':id:', self.pid), payload, 'presentationform').catch(function (errors) {
				console.error(errors);
				self.$store.commit('ADD_NOTICE', {
					'text': 'There are errors in the Form',
					'type': 'error'
				});
			});
		},
		create: function create(payload) {
			var self = this;
			if (self.id && self.id != 'new') return this.save(payload);
			self.restput(self.$store.getters.channel.urls.presentations, payload, 'presentationform').catch(function (errors) {
				console.error(errors);
				self.$store.commit('ADD_NOTICE', {
					'text': 'There are errors in the Form',
					'type': 'error'
				});
			});
		},

		update: function update() {
			var self = this;

			if (this.$store.getters.loadings.presentationform) return;
			if (this.$store.getters.loadings.presentation) return;
			if (this.$store.getters.presentation.id == this.pid) return;

			if (this.pid == 'new') {
				self.$store.commit('UNSET_PRESENTATION');
				self.$store.commit('SET_PRESENTATIONID', this.pid);
				this.restoptions(this.$store.getters.channel.urls.presentation.replace(':id:', ''), 'presentationform').then(function (data) {

					if (data) self.$store.dispatch('SET_PRESENTATION', data);
					self.data = data;
				});
			} else {
				if (this.$store.getters.presentation && this.pid && this.$store.getters.presentation.id == this.pid) {
					self.$store.commit('SET_PRESENTATIONID', this.pid);
					return; // brauch kein update
				}

				self.$store.commit('UNSET_PRESENTATION');
				this.restget(this.$store.getters.channel.urls.presentation.replace(':id:', this.pid), 'presentationform').then(function (data) {
					if (data) self.$store.dispatch('SET_PRESENTATION', data);
					self.$store.commit('SET_PRESENTATIONID', data.pid);
				});
			}
		}
	})
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07b7d2e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PagePresentationSettings.vue
var PagePresentationSettings_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PagePresentationSettings"},[(!(_vm.$route.name.match(/-chart/) || _vm.$route.name.match(/-editor/)))?_c('div',[(_vm.presentation && _vm.presentation.form_fields)?_c('div',[_c('FieldForm',{attrs:{"formtype":'präsentation',"isnew":_vm.pid == 'new',"pid":_vm.pid,"formfields":_vm.presentation.form_fields},on:{"save":_vm.save,"create":_vm.create,"cancel":function($event){_vm.$router.push({ name: 'presentation-list' })}}})],1):_vm._e()]):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var PagePresentationSettings_staticRenderFns = []
var PagePresentationSettings_esExports = { render: PagePresentationSettings_render, staticRenderFns: PagePresentationSettings_staticRenderFns }
/* harmony default export */ var pages_PagePresentationSettings = (PagePresentationSettings_esExports);
// CONCATENATED MODULE: ./src/pages/PagePresentationSettings.vue
var PagePresentationSettings_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PagePresentationSettings___vue_template_functional__ = false
/* styles */
var PagePresentationSettings___vue_styles__ = null
/* scopeId */
var PagePresentationSettings___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PagePresentationSettings___vue_module_identifier__ = null
var PagePresentationSettings_Component = PagePresentationSettings_normalizeComponent(
  PagePresentationSettings,
  pages_PagePresentationSettings,
  PagePresentationSettings___vue_template_functional__,
  PagePresentationSettings___vue_styles__,
  PagePresentationSettings___vue_scopeId__,
  PagePresentationSettings___vue_module_identifier__
)

/* harmony default export */ var src_pages_PagePresentationSettings = (PagePresentationSettings_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/p-presentations.vue
//
//
//
//
//
//
//
//

// Base

// Componenets

// funktion

// helper

/* harmony default export */ var p_presentations = ({
	name: 'p-presentations',
	props: ['pid']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81c9313e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/p-presentations.vue
var p_presentations_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('v-presentationtable',{attrs:{"pid":_vm.pid}})],1)])}
var p_presentations_staticRenderFns = []
var p_presentations_esExports = { render: p_presentations_render, staticRenderFns: p_presentations_staticRenderFns }
/* harmony default export */ var pages_p_presentations = (p_presentations_esExports);
// CONCATENATED MODULE: ./src/pages/p-presentations.vue
var p_presentations_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var p_presentations___vue_template_functional__ = false
/* styles */
var p_presentations___vue_styles__ = null
/* scopeId */
var p_presentations___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var p_presentations___vue_module_identifier__ = null
var p_presentations_Component = p_presentations_normalizeComponent(
  p_presentations,
  pages_p_presentations,
  p_presentations___vue_template_functional__,
  p_presentations___vue_styles__,
  p_presentations___vue_scopeId__,
  p_presentations___vue_module_identifier__
)

/* harmony default export */ var src_pages_p_presentations = (p_presentations_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__("KBYM");
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// CONCATENATED MODULE: ./src/helpers/storeutilis.js



var storeutilis = {
	isCacheValid: function isCacheValid(statetime) {
		var cachetime = new Date();
		cachetime.setDate(cachetime.getHours() - 4);

		return statetime > cachetime.getTime();
	},
	orderCharts: function orderCharts(charts) {
		var self = this;
		var out = [];

		forEach_default()(charts, function (chart, key) {
			var outchart = {
				id: chart.id,
				position: chart.position
			};

			if (chart.charts) outchart.charts = self.orderCharts(chart.charts);

			out.push(outchart);
		});

		return sortBy_default()(out, ['position']);
	},
	findChart: function findChart(charts, id, getWithParent) {
		var self = this;
		var out = false;

		forEach_default()(charts, function (chart, key) {
			if (out) return;

			if (chart.id == id) {
				chart._index = key;
				out = chart;
				return;
			}

			if (chart.charts) {
				var childout = self.findChart(chart.charts, id, getWithParent);

				if (childout) {
					if (getWithParent) {
						childout.parent = chart;
					}
					childout._index = key;
					out = childout;
					return;
				}
			}
		});
		return out;
	},
	getUsereditFieldById: function getUsereditFieldById(fields, name) {
		var self = this;
		var out = false;
		forEach_default()(fields, function (field, key) {
			if (out) {
				return;
			}

			if (field.name == name) {
				out = field;
				return;
			}

			if (field.fields) {
				var childout = self.getUsereditFieldById(field.fields, name);
				if (childout) {
					out = childout;
					return out;
				}
			}
		});

		return out;
	}
};

/* harmony default export */ var helpers_storeutilis = (storeutilis);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/p-editor/c-chart-list-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var c_chart_list_item = ({
	name: 'c-chart-list-item',
	data: function data() {
		return {
			collapsed: false
		};
	},


	components: {
		CChartPreview: components_p_editor_c_chart_preview
	},

	computed: {
		presentation_type: function presentation_type() {
			return this.$store.getters.presentation.type;
		},
		presentation_prefix: function presentation_prefix() {
			if (this.$store.getters.presentation && this.$store.getters.presentation.type) return this.$store.getters.presentation.type + '-';
			if (this.$store.getters.presentation.role) return 'user-';
			return '';
		},
		isMaster: function isMaster() {
			return this.$store.getters.active_presentation == 'master' ? true : false;
		},
		chart: function chart() {
			return this.$store.getters.getChartById(this.data.id);
		},
		parent: function parent() {
			if (this.parentid == 0) return false;
			return this.$store.getters.getChartById(this.parentid);
		}
	},

	props: {
		parentid: {
			type: Number,
			default: 0
		},
		data: {
			type: Object,
			default: function _default() {
				return {};
			}
		},
		child: {
			type: Boolean,
			default: false
		}
	}

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-475b4642","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p-editor/c-chart-list-item.vue
var c_chart_list_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chart && _vm.chart.fields && !_vm.chart.deleted)?_c('div',{staticClass:"c-chart-list-item",class:{ 'fixed': _vm.chart.permissions.is_fixed, 'c-chart-list-item--hidden': !_vm.chart.visible,  'c-chart-list-item--locked': !_vm.chart.permissions.can_edit && _vm.chart.permissions.is_fixed,'c-chart-list-item--trashed': _vm.chart.trashed, 'c-chart-list-item--child': _vm.child }},[_c('div',{staticClass:"c-chart-list-item__topbar"},[(!_vm.child && _vm.chart.fields.title && _vm.chart.fields.title.value)?_c('span',{staticClass:"c-chart-list-item__title"},[_vm._v("\n\t\t\t"+_vm._s(_vm.chart.fields.title.value)+"\n\t\t")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"c-chart-list-item__actions"},[((!_vm.collapsed) && _vm.chart.permissions.can_delete && _vm.chart.permissions)?_c('button',{staticClass:"no-btn c-chart-list-item__btn c-chart-list-item__btn--delete",attrs:{"title":_vm.$t('delete Chart')},on:{"click":function($event){_vm.$store.commit('TOGGLE_CHART_TRASHED', _vm.chart.id)}}},[_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),((!_vm.collapsed) && !_vm.chart.visible && _vm.chart.permissions && _vm.chart.permissions.can_change_visible)?_c('button',{staticClass:"no-btn c-chart-list-item__btn c-chart-list-item__btn--show",attrs:{"title":_vm.$t('show Chart')},on:{"click":function($event){_vm.$store.commit('TOGGLE_CHART_VISIBILITY', _vm.chart.id)}}},[_c('i',{staticClass:"fa fa-eye",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),((!_vm.collapsed) && _vm.chart.visible && _vm.chart.permissions && _vm.chart.permissions.can_change_visible)?_c('button',{staticClass:"no-btn c-chart-list-item__btn c-chart-list-item__btn--hide",attrs:{"title":_vm.$t('hide Chart')},on:{"click":function($event){_vm.$store.commit('TOGGLE_CHART_VISIBILITY', _vm.chart.id)}}},[_c('i',{staticClass:"fa fa-eye-slash",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),((!_vm.collapsed) && _vm.chart.permissions.is_fixed)?_c('button',{staticClass:"no-btn c-chart-list-item__btn c-chart-list-item__btn--hide",attrs:{"title":_vm.$t('Chart is fixed')},on:{"click":function($event){_vm.$store.commit('TOGGLE_CHART_FIXED', _vm.chart.id)}}},[_c('i',{staticClass:"fa fa-snowflake-o",attrs:{"aria-hidden":"true"}})]):_vm._e()])]),_vm._v(" "),_c('router-link',{staticClass:"router-link",attrs:{"to":_vm._a(0,function(){return { name: _vm.presentation_prefix + 'chart', params: { chartid : _vm.chart.id }}})}},[_c('c-chart-preview',{attrs:{"data":_vm.data,"refreshing":_vm.chart.refreshing,"small":_vm.collapsed,"visible":(_vm.parent && !_vm.parent.visible ? _vm.parent.visible : _vm.chart.visible),"trashed":(_vm.parent && _vm.parent.trashed ? _vm.parent.trashed : _vm.chart.trashed),"locked":(!_vm.chart.editable)}})],1),_vm._v(" "),(_vm.presentation_type != 'user')?_c('div',{staticClass:"ui-editor__chart-preview-childs"},[_c('c-chart-list',{attrs:{"parentid":_vm.chart.id,"data":_vm.data.charts,"child":true,"canHaveChilds":(_vm.chart.permissions && _vm.chart.permissions.can_have_childs) && (_vm.chart.addablecharts && _vm.chart.addablecharts.length > 0) && !(!_vm.chart.permissions.can_edit && !_vm.chart.permissions.can_change_edit)}})],1):_vm._e()],1):_vm._e()}
var c_chart_list_item_staticRenderFns = []
var c_chart_list_item_esExports = { render: c_chart_list_item_render, staticRenderFns: c_chart_list_item_staticRenderFns }
/* harmony default export */ var p_editor_c_chart_list_item = (c_chart_list_item_esExports);
// CONCATENATED MODULE: ./src/components/p-editor/c-chart-list-item.vue
function c_chart_list_item_injectStyle (ssrContext) {
  __webpack_require__("m2QC")
}
var c_chart_list_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var c_chart_list_item___vue_template_functional__ = false
/* styles */
var c_chart_list_item___vue_styles__ = c_chart_list_item_injectStyle
/* scopeId */
var c_chart_list_item___vue_scopeId__ = "data-v-475b4642"
/* moduleIdentifier (server only) */
var c_chart_list_item___vue_module_identifier__ = null
var c_chart_list_item_Component = c_chart_list_item_normalizeComponent(
  c_chart_list_item,
  p_editor_c_chart_list_item,
  c_chart_list_item___vue_template_functional__,
  c_chart_list_item___vue_styles__,
  c_chart_list_item___vue_scopeId__,
  c_chart_list_item___vue_module_identifier__
)

/* harmony default export */ var components_p_editor_c_chart_list_item = (c_chart_list_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/html2canvas/dist/npm/index.js
var npm = __webpack_require__("2Pnh");
var npm_default = /*#__PURE__*/__webpack_require__.n(npm);

// CONCATENATED MODULE: ./src/helpers/newChart.js







function newVueChart() {
	return {
		template: '<div></div>',
		computed: {
			presentation: function presentation() {
				return this.$store.getters.presentation;
			},
			saveing: function saveing() {
				return this.$store.getters.saveing;
			},
			loading: function loading() {
				return this.$store.getters.loading;
			},
			areas: function areas() {
				return this.$store.getters.getChartFields(this.data.id, true);
			}
		},
		data: function data() {
			return {
				hoverrect: false,
				rendering: false,
				content: null, //für den wysiwyg
				editing: false,
				resizehash: false
			};
		},
		props: {
			preview: {
				type: Boolean,
				default: false
			},
			editable: {
				type: Boolean,
				default: true
			},
			active: {
				type: Number,
				default: 0
			},
			data: {
				type: Object,
				default: function _default() {
					return {};
				}
			}
		},
		created: function created() {
			if (!this.preview) {
				if (app && app.evn && app.evn.subscribe) {
					app.evn.subscribe('resize', this.resize);
				} else {
					window.addEventListener('resize', this.resize, true);
				}
			}
			this.resize();
		},
		destroyed: function destroyed() {
			if (!this.preview) {
				if (app && app.evn && app.evn.unsubscribe) {
					app.evn.unsubscribe('resize', this.resize);
				} else {
					window.removeEventListener('resize', this.resize);
				}
			}
		},
		mounted: function mounted() {
			this.renderChart();
			this.resize();
		},

		methods: {
			onMove: helpers_chart.onMove,
			editableEvent: function editableEvent(event) {
				var target = event.target;
				switch (event.type) {
					case 'click':
						break;
					case 'mouseover':
						if (!this.hoverrect) {
							if (target.nodeName != 'g') {
								target = target.parentNode;
							}
							if (target.nodeName != 'g') {
								target = target.parentNode;
							}

							var bbox = target.getBBox(),
							    rect = document.createElementNS("http://www.w3.org/2000/svg", 'rect');

							rect.setAttribute('x', bbox.x);
							rect.setAttribute('y', bbox.y);
							rect.setAttribute('height', bbox.height);
							rect.setAttribute('width', bbox.width);

							rect.setAttribute('stroke', '#a3248f');
							rect.setAttribute('stroke-width', '4');
							rect.setAttribute('fill-rule', 'evenodd');

							target.appendChild(rect);
							this.hoverrect = rect;
						}
						break;
					case 'mouseleave':
						if (this.hoverrect) {
							this.hoverrect.remove();
							this.hoverrect = false;
						}
						break;
				}
			},
			renderChart: function renderChart() {
				var self = this;
				if (this.$store.getters['features/livepreview']) {
					return;
				}

				if (!this.$el) {
					if (self.$store.getters.devmode) console.debug('cant render chart without element');
					return;
				}
				if (!this.data.id) {
					return;
				}
				if (this.rendering) {
					return;
				}

				if (typeof window.running === 'undefined') window.running = false;
				if (window.running) {
					return;
				}

				var chartid = this.data.id;
				var chart = this.$store.getters.getChartById(chartid);
				if (!chart) return;
				if (typeof chart.changed === 'undefined') chart.changed = false;

				if (!chart.image || chart.changed) {
					if (window.innerHeight < 900 || window.innerWidth < 1907) {
						if (self.$store.getters.devmode) console.debug('cant start `renderChart` because your windows is to small');
						return;
					}
					if (self.$store.getters.devmode) console.debug('start renderChart');
					window.running = true;
					this.rendering = true;

					var el = this.$el.querySelector('section.st-chart');

					if (el) {
						var rect = el.getBoundingClientRect();

						var width = rect.width,
						    height = rect.height,
						    scale;

						if (scale = el.getAttribute('data-scale')) {
							width = react.width * scale;
							height = react.height * scale;
						}

						npm(el, {
							useCORS: true,
							allowTaint: true,
							letterRendering: true,
							logging: false,
							background: '#fff',
							width: width,
							height: height
						}).then(function (canvas) {
							var extra_canvas = document.createElement("canvas");
							extra_canvas.setAttribute('width', 300);
							extra_canvas.setAttribute('height', 180);
							var ctx = extra_canvas.getContext('2d');
							ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, 300, 180);
							var base = extra_canvas.toDataURL("image/png");

							// var base = canvas.toDataURL("image/png");
							if (self.$store.getters.devmode) console.debug('finsihed rendering');

							self.$store.commit('UPDATE_CHART', { 'id': chart.id, newImage: true, 'image': base });
							self.rendering = false;
							window.running = false;
						}).catch(function (err) {
							self.rendering = false;
							window.running = false;
							console.error('html2canvas', err);
						});
					} else {
						console.error('el nicht gefunden, section.st-chart');
					}
				}
			},
			resize: function resize() {
				if (this.$el) {
					var main = this.$el.parentNode || document.querySelector('.ui-editor__main'),
					    resizehash = this.resizehash;
					var parentRect = main.getBoundingClientRect(),
					    stChartEl = this.$el.querySelector('.st-chart');

					if (stChartEl) {
						var scale = Math.min(parentRect.width / 1600, (parentRect.height > window.innerHeight - 180 ? window.innerHeight - 180 : parentRect.height) / 900);
						if (scale != resizehash) {
							stChartEl.style.transform = 'scale(' + (scale > 1 ? 1 : scale) + ')';
							stChartEl.setAttribute('data-scale', scale);
							// stChartEl.style.zoom = scale;
							this.resizehash = scale;
						}
					}
				}
			}
		}
	};
}
// CONCATENATED MODULE: ./src/helpers/chart.js











/* harmony default export */ var helpers_chart = (extends_default()({}, rest, {
	onMove: function onMove(evt) {
		console.log(evt);
		if (evt.dragged && evt.dragged.classList.contains('fixed')) {
			return false;
		}
		if (evt.related) {
			return !evt.related.classList.contains('fixed');
		}
	},
	waitForCharts: function waitForCharts() {
		var self = this;
		return new promise_default.a(function (resolve) {
			var interval = window.setInterval(function () {
				if (!self.$store.getters.chartemplates_loading && self.$store.getters.chartemplates) {
					clearInterval(interval);
					resolve(self.$store.getters.chartemplates);
				}
			}, 100);
		});
	},
	setupChart: function setupChart(item) {
		var self = this;

		var chartname = 'v-chart-' + item.template.toLowerCase(),
		    charttemplates = this.$store.getters.chartemplates,
		    chartcomponents = this.$store.getters.chartcomponents;

		window.preloadedimages = window.preloadedimages || [];
		forEach_default()(item.addablecharts, function (aachart, key) {
			if (aachart.image.indexOf(window.preloadedimages)) {
				if (self.$store.getters.devmode) console.debug('PRELOAD', aachart.image);

				window.preloadedimages.push(aachart.image);
				new Image().src = aachart.image;
			}
		});

		if (chartcomponents.indexOf(chartname) >= 0) {
			return false;
		}

		var chart = newVueChart();

		if (charttemplates[chartname]) {
			chart.template = charttemplates[chartname];
			vue_esm["default"].component(chartname, chart);
			this.$store.commit('ADD_CHARTCOMPONENTS', chartname);
		} else {
			console.error('missing template for ' + chartname, charttemplates);
		}

		if (item.charts) {
			keys_default()(item.charts).forEach(function (k) {
				self.setupChart(item.charts[k]);
			});
		}
	},
	flatenCharts: function flatenCharts(charts) {
		var self = this;
		var out = {};
		keys_default()(charts).forEach(function (key) {
			var chart = charts[key];
			if (!out[chart.id]) vue_esm["default"].set(out, chart.id, chart);
			if (chart.charts) out = assign_default()({}, out, self.flatenCharts(chart.charts));
		});

		return out;
	},
	chartTemplatesHasMissingTemplate: function chartTemplatesHasMissingTemplate(templates, charts) {
		var chs = this.flatenCharts(charts),
		    missingTemplate = false;

		forEach_default()(chs, function (ch, keyid) {
			if (typeof templates['v-chart-' + ch.component] === 'undefined') missingTemplate = true;
		});

		return missingTemplate;
	},
	getChartTemplates: function getChartTemplates() {
		var _this = this;

		var self = this;
		return new promise_default.a(function (resolve, reject) {
			console.log('chartTemplatesHasMissingTemplate:', self.chartTemplatesHasMissingTemplate(self.$store.getters.chartemplates, self.$store.getters.charts));
			if (self.$store.getters.chartemplates && !self.chartTemplatesHasMissingTemplate(self.$store.getters.chartemplates, self.$store.getters.charts)) {
				resolve(self.$store.getters.chartemplates);
			} else if (self.$store.getters.chartemplates_loading) {
				resolve(_this.waitForCharts());
			} else {
				self.$store.commit('START_LOADING_CHARTTEMPLATES');
				_this.restget(self.$store.getters.channel.urls.charttemplates, 'charttemplates').then(function (message) {
					self.$store.commit('SET_CHARTTEMPLATES', message);
					self.$store.commit('STOP_LOADING_CHARTTEMPLATES');
					resolve(message);
				}).catch(function (error) {
					self.$store.commit('ADD_ERROR', error);
					reject(error);
				});
			}
		});
	}
}));
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/p-editor/c-chart-list.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var c_chart_list = ({
	name: 'c-chart-list',

	methods: {
		onMove: function onMove(evt) {

			if (evt.dragged && evt.dragged.classList.contains('fixed')) {
				return false;
			}
			if (evt.related) {
				return !evt.related.classList.contains('fixed');
			}
		},
		onEnd: function onEnd(ev) {
			var id = parseInt(ev.item.getAttribute('data-id')),
			    payload = {
				'id': id,
				'position': ev.newIndex,
				'event': ev
			};

			this.$store.commit('UPDATE_CHART', payload);
		}
	},

	computed: {
		devmode: function devmode() {
			return this.$store.getters.devmode;
		},
		isMaster: function isMaster() {
			return this.$store.getters.active_presentation == 'master' ? true : false;
		}
	},

	mounted: function mounted() {
		if (typeof this.$refs['active-chart'] !== 'undefined') {
			var pos = this.$refs['active-chart'][0].$el.offsetTop;
			this.$refs['chart-list-wrapper'].scrollTop = pos;
		}
		// chart-list-wrapper
		// active-chart
		// chart
	},
	data: function data() {
		return {
			charts: [],
			drag: false
		};
	},
	created: function created() {
		this.charts = this.data;
	},


	watch: {
		data: function data(newData) {
			this.charts = newData;
		}
	},

	updated: function updated() {
		this.charts = this.data;
	},


	props: {
		data: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		child: {
			type: Boolean,
			default: false
		},
		canHaveChilds: {
			type: Boolean,
			default: false
		},
		parentid: {
			type: Number,
			default: 0
		}
	},

	components: {
		CChartListItem: components_p_editor_c_chart_list_item
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56c7c22f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p-editor/c-chart-list.vue
var c_chart_list_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-chart-list"},[_c('draggable',{ref:'chart-list-wrapper',attrs:{"move":_vm.onMove,"options":_vm._a(0,function(){return {forceFallback: true, animation: 150}})},on:{"end":_vm.onEnd},model:{value:(_vm.charts),callback:function ($$v) {_vm.charts=$$v},expression:"charts"}},_vm._l((_vm.charts),function(chart){return _c('c-chart-list-item',{key:chart.id,ref:(_vm.$route.params.chartid == chart.id ? 'active-chart' : 'chart'),refInFor:true,attrs:{"child":_vm.child,"parentid":_vm.parentid,"data":chart,"data-id":chart.id}})})),_vm._v(" "),(_vm.canHaveChilds)?_c('button',{staticClass:"no-btn v-chart-preview st-chart-preview",on:{"click":function($event){_vm.$store.commit('START_ADDCHART', _vm.parentid)}}},[_c('div',{staticClass:"st-chart-preview__img"},[_c('div',{staticClass:"st-chart-preview__wrap"},[_c('div',{staticClass:"st-chart-preview__alttext"},[_c('strong',[_vm._v(_vm._s(_vm.$t('new Slide')))])])])])]):_vm._e()],1)}
var c_chart_list_staticRenderFns = []
var c_chart_list_esExports = { render: c_chart_list_render, staticRenderFns: c_chart_list_staticRenderFns }
/* harmony default export */ var p_editor_c_chart_list = (c_chart_list_esExports);
// CONCATENATED MODULE: ./src/components/p-editor/c-chart-list.vue
function c_chart_list_injectStyle (ssrContext) {
  __webpack_require__("XKnb")
}
var c_chart_list_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var c_chart_list___vue_template_functional__ = false
/* styles */
var c_chart_list___vue_styles__ = c_chart_list_injectStyle
/* scopeId */
var c_chart_list___vue_scopeId__ = "data-v-56c7c22f"
/* moduleIdentifier (server only) */
var c_chart_list___vue_module_identifier__ = null
var c_chart_list_Component = c_chart_list_normalizeComponent(
  c_chart_list,
  p_editor_c_chart_list,
  c_chart_list___vue_template_functional__,
  c_chart_list___vue_styles__,
  c_chart_list___vue_scopeId__,
  c_chart_list___vue_module_identifier__
)

/* harmony default export */ var components_p_editor_c_chart_list = (c_chart_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/p-editor/c-editor-sidebar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var c_editor_sidebar = ({
	name: 'c-editor-sidebar',
	components: {
		CChartList: components_p_editor_c_chart_list
	},
	computed: {
		route: function route() {
			if (this.edituser.type) {
				return {
					name: this.edituser.type,
					params: {
						id: this.edituser.id
					}
				};
			}
			return false;
		},
		backtotext: function backtotext() {
			if (this.presentation.type == 'user') return this.edituser.fancyname;
			if (this.presentation.type == 'partner' || this.presentation.type == 'customer') return this.edituser.title;
			return '';
		},
		edituser: function edituser() {
			return this.$store.getters.edituser;
		},
		presentation: function presentation() {
			return this.$store.getters.presentation;
		},
		charts: function charts() {
			return helpers_storeutilis.orderCharts(this.$store.getters.charts);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d42a0702","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p-editor/c-editor-sidebar.vue
var c_editor_sidebar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-editor-sidebar"},[(_vm.route)?_c('div',{staticClass:"c-editor-sidebar__userback"},[_c('router-link',{staticClass:"st-btn st-btn--full st-btn--dark st-btn--small st-btn--icon",attrs:{"to":_vm.route}},[_c('i',{staticClass:"fa fa-angle-left",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('Back to {name}', {name: _vm.backtotext}))+"\n\t\t")])],1):_vm._e(),_vm._v(" "),_c('c-chart-list',{attrs:{"data":_vm.charts,"child":false,"canHaveChilds":(_vm.presentation.addablecharts && _vm.presentation.addablecharts.length > 0)}}),_vm._v(" "),(_vm.presentation.fancyname && Object.keys(_vm.charts).length > 6)?_c('div',{staticClass:"c-editor-sidebar__userback"},[_c('router-link',{staticClass:"st-btn st-btn--full st-btn--dark st-btn--small st-btn--icon",attrs:{"to":_vm._a(0,function(){return { name: 'user-edit', params: { uid : _vm.presentation.id.toString(), role: _vm.presentation.role.toString() }}})}},[_c('i',{staticClass:"fa fa-angle-left",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('Back to {name}', {name: _vm.presentation.fancyname})))])],1):_vm._e()],1)}
var c_editor_sidebar_staticRenderFns = []
var c_editor_sidebar_esExports = { render: c_editor_sidebar_render, staticRenderFns: c_editor_sidebar_staticRenderFns }
/* harmony default export */ var p_editor_c_editor_sidebar = (c_editor_sidebar_esExports);
// CONCATENATED MODULE: ./src/components/p-editor/c-editor-sidebar.vue
function c_editor_sidebar_injectStyle (ssrContext) {
  __webpack_require__("Qop4")
}
var c_editor_sidebar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var c_editor_sidebar___vue_template_functional__ = false
/* styles */
var c_editor_sidebar___vue_styles__ = c_editor_sidebar_injectStyle
/* scopeId */
var c_editor_sidebar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var c_editor_sidebar___vue_module_identifier__ = null
var c_editor_sidebar_Component = c_editor_sidebar_normalizeComponent(
  c_editor_sidebar,
  p_editor_c_editor_sidebar,
  c_editor_sidebar___vue_template_functional__,
  c_editor_sidebar___vue_styles__,
  c_editor_sidebar___vue_scopeId__,
  c_editor_sidebar___vue_module_identifier__
)

/* harmony default export */ var components_p_editor_c_editor_sidebar = (c_editor_sidebar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/p-editor/c-editor-presentation.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Base







/* harmony default export */ var c_editor_presentation = ({
	name: 'c-editor-presentation',
	components: {
		MultiSelect: src_components_MultiSelect
	},
	props: {
		pid: {
			type: String,
			default: ''
		},
		master: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		chartitle: {
			get: function get() {
				if (!this.$route.params.chartid) return false;
				var field = this.$store.getters.getChartField(this.$route.params.chartid, 'title');
				return field ? field.value : false;
			},
			set: function set(value) {
				if (!this.$route.params.chartid) return false;
				var field = this.$store.getters.getChartField(this.$route.params.chartid, 'title');
				if (field) {
					field.changed = true;
					return field.value = value;
				}

				return false;
			}
		},
		chart: function chart() {
			return this.$route.params.chartid ? this.$store.getters.getChartById(this.$route.params.chartid) : false;
		},

		stateValue: {
			get: function get() {
				if (!this.$route.params.chartid) return false;
				var field = this.$store.getters.getChartField(this.$route.params.chartid, 'state');
				if (!field) return false;
				return typeof field.value == 'string' ? field.value.split(' ') : field.value;
			},
			set: function set(value) {
				if (!this.$route.params.chartid) return false;
				var field = this.$store.getters.getChartField(this.$route.params.chartid, 'state');
				if (field) {
					field.changed = true;
					return field.value = typeof value !== 'string' ? value.join(' ') : value;
				}

				return false;
			}
		},
		presentation_type: function presentation_type() {
			return this.$store.getters.presentation.type;
		},
		presentation: function presentation() {
			return this.$store.getters.presentation;
		}
	},
	methods: extends_default()({}, rest, {
		getSaveableChart: function getSaveableChart(chart, index) {
			var self = this;
			var sachart = {};

			sachart.id = chart.id;

			sachart.position = chart.position;
			sachart.trashed = chart.trashed;
			sachart.visible = chart.visible;
			sachart.template = chart.template;

			if (chart.newImage) {
				sachart.image = chart.image;
			}

			if (chart.charts) {
				sachart.charts = {};
				keys_default()(chart.charts).forEach(function (key, index) {
					sachart.charts[chart.charts[key].id] = self.getSaveableChart(chart.charts[key], index);
				});
			}

			sachart.fields = {};
			keys_default()(chart.fields).forEach(function (key) {
				if (key == 'background-image' || key == 'background-video') return;
				var field = chart.fields[key];

				if (field.changed) {
					sachart.fields[key] = field.value;
				}
			});

			return sachart;
		},
		updateCharts: function updateCharts(charts) {
			var self = this;
			keys_default()(charts).forEach(function (id) {
				var newChart = charts[id];
				if (newChart && newChart.updated) {
					var chart = void 0,
					    oldId = void 0;

					if (newChart.updated.trashed) {
						self.$store.commit('DELETE_CHART', id);
						return;
					}

					if (newChart.updated.id) {
						oldId = newChart.updated.id.from;
						chart = self.$store.getters.getChartById(oldId);
						vue_esm["default"].set(chart, 'id', newChart.updated.id.to);

						console.debug('UPDATE_ID_FOR_CHART', oldId, newChart.updated.id.to);
					} else {
						chart = self.$store.getters.getChartById(id);
					}
					console.log('a', chart);

					if (chart && chart.changed) {
						chart.changed = false;
					}

					if (newChart.updated.image) {
						chart.newImage = false; // updated
					}

					keys_default()(chart.fields).forEach(function (key) {
						if (key == 'background-image' || key == 'background-video') return;
						if (!newChart.updated[key]) return;
						var field = self.$store.getters.getChartField(chart.id, key),
						    upd = newChart.updated[key];

						field.default = upd.to; // update default
						field.value = upd.to; // update value
					});

					if (chart) {
						if (oldId) {
							if (self.$route.params.chartid == oldId) {
								self.$router.push({ params: { chartid: id } });
							}
						}

						if (newChart.charts) {
							self.updateCharts(newChart.charts);
						}
					}
				}
			});
		},
		save: function save() {
			var self = this;
			var preUrl = void 0,
			    presentation = void 0,
			    charts = void 0,
			    id = void 0;
			var payload = {};

			if (this.presentation_type == 'user') {
				preUrl = this.$store.getters.channel.urls.user, presentation = this.$store.getters.presentation, charts = this.$store.getters.charts, id = presentation.id;
			} else if (this.presentation_type == 'customer') {
				preUrl = '/api/v1/customers/:id:', presentation = this.$store.getters.presentation, charts = this.$store.getters.charts, id = this.$store.getters.edituser.id;
			} else if (this.presentation_type == 'partner') {
				preUrl = '/api/v1/partners/:id:', presentation = this.$store.getters.presentation, charts = this.$store.getters.charts, id = this.$store.getters.edituser.id;
			} else {
				preUrl = this.$store.getters.channel.urls.presentation, presentation = this.$store.getters.presentation, charts = this.$store.getters.charts, id = this.master ? 'master' : presentation.id;
			}

			payload.id = id;
			payload.charts = {};

			keys_default()(charts).forEach(function (key, index) {
				var chart = charts[key];
				payload.charts[chart.id] = self.getSaveableChart(chart, index);
			});

			var url = preUrl.replace(':id:', id);

			this.restpatch(url, payload, 'presentation').then(function (message) {
				if (message && message.updated && message.updated.charts) {
					self.updateCharts(message.updated.charts);
				} else {
					self.updateCharts(message);
				}
			});
		},
		savechildfield: function savechildfield(cid, fieldname, newvalue) {
			var chart = this.$store.getters.getChartById(cid);
			if (chart && chart.fields && chart.fields[fieldname]) {
				if (chart.fields[fieldname].value !== newvalue) {
					chart.fields[fieldname].value = newvalue;
				} else {
					console.error(chart.fields[fieldname].value, newvalue, 'value ist the same?');
				}
			} else if (fieldname == 'title') {
				chart.title = newvalue;
			} else {
				console.error(cid, fieldname, 'dosent exits?');
			}
		}
	})
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44ed2806","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p-editor/c-editor-presentation.vue
var c_editor_presentation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-editor-presentation"},[(_vm.presentation)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12  col-sm-6"},[(_vm.chart && _vm.chart.fields.title)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"inline-block"},[(_vm.chart && _vm.chart.fields.title)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chartitle),expression:"chartitle"}],staticClass:"st-input st-input--small st-input--text",attrs:{"id":"charttitle","disabled":!(_vm.chart.permissions && _vm.chart.permissions.can_edit && _vm.chart.fields.title.permissions.can_edit),"type":"text"},domProps:{"value":(_vm.chartitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.chartitle=$event.target.value}}}):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('v-editorbar',{attrs:{"token":_vm.presentation.token,"urls":_vm.presentation.urls},on:{"save":_vm.save}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"reveal-html"},[_c('div',{staticClass:"reveal-body"},[_c('router-view',{staticClass:"view",on:{"savefield":_vm.savechildfield}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.chart && _vm.chart.fields && _vm.chart.fields.state && _vm.chart.fields.state.permissions && _vm.chart.fields.state.permissions.can_edit)?_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"inline-block"},[_c('MultiSelect',{attrs:{"small":true,"options":_vm.chart.fields.state.options,"defaultValue":_vm.stateValue},model:{value:(_vm.stateValue),callback:function ($$v) {_vm.stateValue=$$v},expression:"stateValue"}})],1)]):_vm._e()])])}
var c_editor_presentation_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-block"},[_c('label',{attrs:{"for":"charttitle"}},[_vm._v("Chart Title")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-block"},[_c('label',{attrs:{"for":"charttitle"}},[_vm._v("States")])])}]
var c_editor_presentation_esExports = { render: c_editor_presentation_render, staticRenderFns: c_editor_presentation_staticRenderFns }
/* harmony default export */ var p_editor_c_editor_presentation = (c_editor_presentation_esExports);
// CONCATENATED MODULE: ./src/components/p-editor/c-editor-presentation.vue
var c_editor_presentation_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var c_editor_presentation___vue_template_functional__ = false
/* styles */
var c_editor_presentation___vue_styles__ = null
/* scopeId */
var c_editor_presentation___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var c_editor_presentation___vue_module_identifier__ = null
var c_editor_presentation_Component = c_editor_presentation_normalizeComponent(
  c_editor_presentation,
  p_editor_c_editor_presentation,
  c_editor_presentation___vue_template_functional__,
  c_editor_presentation___vue_styles__,
  c_editor_presentation___vue_scopeId__,
  c_editor_presentation___vue_module_identifier__
)

/* harmony default export */ var components_p_editor_c_editor_presentation = (c_editor_presentation_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/chunk.js
var chunk = __webpack_require__("O3gb");
var chunk_default = /*#__PURE__*/__webpack_require__.n(chunk);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/p-editor/c-editor-addablechart-modal.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var c_editor_addablechart_modal = ({
	name: 'c-editor-addablechart-modal',
	computed: {
		addchart: function addchart() {
			return this.$store.getters.addchart;
		}
	},
	methods: extends_default()({
		chunk: chunk_default.a
	}, rest, helpers_chart, {
		addAbleChartsByChart: function addAbleChartsByChart(chartid) {
			if (chartid) {
				var chart = this.$store.getters.getChartById(chartid);
				if (chart && chart.addablecharts) {
					return chart.addablecharts;
				}
			}

			return this.$store.getters.presentation.addablecharts;
		},
		addChartToPresentation: function addChartToPresentation(chart) {
			var self = this,
			    url = this.$store.getters.presentation.urls.newchart.replace(':charttemplate:', chart.template);

			this.restoptions(url, 'NEW_CHART').then(function (rawchart) {
				if (typeof rawchart.id !== 'number') {
					self.$store.commit('INCREASE_NEWCHARTCOUNTER');
					rawchart.id = self.$store.getters.newchartcounter;
				}

				rawchart.title = self.$t(rawchart.title);
				if (rawchart.fields && rawchart.fields.title) {
					rawchart.fields.title.value = self.$t(rawchart.title);
					rawchart.fields.title.chanegd = true;
				}

				self.setupChart(rawchart);
				// self.$store.commit('ADD_CHART', rawchart);
				self.$store.dispatch('ADD_CHART', rawchart).then(function (chart) {
					if (self.$route.params.chartid != chart.id) {
						self.$router.push({ params: { chartid: chart.id } });
					}

					self.$store.commit('END_ADDCHART');
				});
			});
		}
	})
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c4c4414","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p-editor/c-editor-addablechart-modal.vue
var c_editor_addablechart_modal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-editor-addablechart-modal"},[(_vm.addchart)?_c('v-modal',{on:{"cancel":function($event){_vm.$store.commit('END_ADDCHART');}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Slide hinzufügen")]),_vm._v(" "),_c('div',{attrs:{"slot":"message"},slot:"message"},_vm._l((_vm.chunk(_vm.addAbleChartsByChart(_vm.addchart), 4)),function(chs){return _c('div',{staticClass:"row"},_vm._l((chs),function(ch){return _c('div',{staticClass:"col-xs-12 col-sm-3"},[_c('button',{staticClass:"no-btn v-chart-preview st-chart-preview",on:{"click":function($event){_vm.addChartToPresentation(ch)}}},[(ch.title)?_c('div',[_c('strong',[_vm._v(_vm._s(_vm.$t(ch.title)))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"st-chart-preview__img",style:((ch.image ? 'background-image: url(' + ch.image + ')' : ''))},[_c('div',{staticClass:"st-chart-preview__wrap"},[(!ch.image)?_c('div',{staticClass:"st-chart-preview__alttext"},[(ch.fields && ch.fields.title)?_c('strong',[_vm._v(_vm._s(ch.fields.title.value))]):_c('strong',[_vm._v(_vm._s(ch.template))])]):_vm._e()])])])])}))}))]):_vm._e()],1)}
var c_editor_addablechart_modal_staticRenderFns = []
var c_editor_addablechart_modal_esExports = { render: c_editor_addablechart_modal_render, staticRenderFns: c_editor_addablechart_modal_staticRenderFns }
/* harmony default export */ var p_editor_c_editor_addablechart_modal = (c_editor_addablechart_modal_esExports);
// CONCATENATED MODULE: ./src/components/p-editor/c-editor-addablechart-modal.vue
var c_editor_addablechart_modal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var c_editor_addablechart_modal___vue_template_functional__ = false
/* styles */
var c_editor_addablechart_modal___vue_styles__ = null
/* scopeId */
var c_editor_addablechart_modal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var c_editor_addablechart_modal___vue_module_identifier__ = null
var c_editor_addablechart_modal_Component = c_editor_addablechart_modal_normalizeComponent(
  c_editor_addablechart_modal,
  p_editor_c_editor_addablechart_modal,
  c_editor_addablechart_modal___vue_template_functional__,
  c_editor_addablechart_modal___vue_styles__,
  c_editor_addablechart_modal___vue_scopeId__,
  c_editor_addablechart_modal___vue_module_identifier__
)

/* harmony default export */ var components_p_editor_c_editor_addablechart_modal = (c_editor_addablechart_modal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/v-editable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var v_editable = ({
	name: 'v-editable',
	props: {
		inline: {
			type: Boolean,
			default: function _default() {
				return this.$store.getters['features/inlinemod'];
			}
		},
		chartid: {
			default: false
		},
		fieldname: {
			type: String,
			default: ''
		},
		icon: {
			type: String,
			default: 'pencil'
		},
		disabled: {
			type: String,
			default: ''
		},
		areaedit: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		chart: function chart() {
			return this.$store.getters.getChartById(this.chartid);
		},
		field: function field() {
			return this.$store.getters.getChartField(this.chartid, this.fieldname);
		},
		active_field: function active_field() {
			return this.$store.getters.active_field;
		},
		can_edit: function can_edit() {
			if (this.chart.id <= 0) return false;
			return this.field && this.field.permissions ? this.field.permissions.can_edit : false;
		},
		vEditableClasses: function vEditableClasses() {
			var field = this.field,
			    active_field = this.active_field;

			return {
				'editable': this.can_edit,
				'v-editable--inline': this.$store.getters['features/inlinemod'],
				'v-editable--disabled': this.disabled.length > 0,
				'editable--active': active_field && active_field.fieldname == this.fieldname
			};
		},
		saveing: function saveing() {
			return this.$store.getters.saveing;
		},
		loading: function loading() {
			return this.$store.getters.loading;
		}
	},
	methods: {
		editfieldarea: function editfieldarea(event) {
			if (!this.can_edit) return;
			if (this.inline && this.active_field.fieldname == this.fieldname) return;

			if (!this.field.permissions.can_edit) return;
			if (this.areaedit) {
				this.trigger();
			}
		},
		editfield: function editfield(event) {
			if (!this.field.permissions.can_edit) return;
			if (!this.areaedit) {
				this.trigger();
			}
		},
		trigger: function trigger() {
			if (this.active_field.fieldname == this.fieldname) {
				this.$store.commit('RESET_ACTIVE_FIELD');
			} else {
				this.$store.commit('SET_ACTIVE_FIELD', {
					fieldname: this.fieldname,
					element: this.$el,
					chartid: this.chartid
				});
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d6d61e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v-editable.vue
var v_editable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-editable",class:_vm.vEditableClasses,on:{"click":_vm.editfieldarea}},[(!_vm.saveing && !_vm.loading && _vm.can_edit)?_c('button',{staticClass:"st-edit-btn",attrs:{"tabindex":"-1"},on:{"click":_vm.editfield}},[(_vm.active_field == false || _vm.active_field.fieldname != _vm.fieldname)?_c('i',{staticClass:"fa",class:'fa-' + _vm.icon,attrs:{"aria-hidden":"true"}}):_c('i',{staticClass:"fa fa-ban",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.active_field.fieldname == _vm.fieldname && _vm.inline)?_c('v-field',{attrs:{"inline":_vm.inline,"chart":_vm.chart,"name":_vm.fieldname},on:{"cancel":function($event){_vm.$store.commit('RESET_ACTIVE_FIELD')}}}):_vm._t("default",null,{slotScope:"field",field:_vm.field})],2)}
var v_editable_staticRenderFns = []
var v_editable_esExports = { render: v_editable_render, staticRenderFns: v_editable_staticRenderFns }
/* harmony default export */ var components_v_editable = (v_editable_esExports);
// CONCATENATED MODULE: ./src/components/v-editable.vue
function v_editable_injectStyle (ssrContext) {
  __webpack_require__("UtT8")
}
var v_editable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var v_editable___vue_template_functional__ = false
/* styles */
var v_editable___vue_styles__ = v_editable_injectStyle
/* scopeId */
var v_editable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var v_editable___vue_module_identifier__ = null
var v_editable_Component = v_editable_normalizeComponent(
  v_editable,
  components_v_editable,
  v_editable___vue_template_functional__,
  v_editable___vue_styles__,
  v_editable___vue_scopeId__,
  v_editable___vue_module_identifier__
)

/* harmony default export */ var src_components_v_editable = (v_editable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/p-editor.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Base


// Componenets






// funktion


// helper



if (!window.chartcomponents) window.chartcomponents = [];

/* harmony default export */ var p_editor = ({
	name: 'p-editor',
	components: {
		CEditorAddablechartModal: components_p_editor_c_editor_addablechart_modal,
		CEditorSidebar: components_p_editor_c_editor_sidebar,
		CEditorPresentation: components_p_editor_c_editor_presentation,
		VEditable: src_components_v_editable
	},
	data: function data() {
		return {
			data: {
				_socketid: false
			}
		};
	},

	watch: {
		'$route': 'routerupdate'
	},
	props: {
		uid: {
			default: ''
		},
		pid: {
			default: ''
		},
		master: {
			default: false
		}
	},

	computed: {
		presentation_type: function presentation_type() {
			return this.$store.getters.presentation.type;
		},
		presentation: function presentation() {
			return this.$store.getters.presentation;
		},
		channel: function channel() {
			return this.$store.getters.channel;
		},
		charts: function charts() {
			return this.$store.getters.charts;
		},
		changed: function changed() {
			return this.$store.getters.changed;
		},
		addchart: function addchart() {
			return this.$store.getters.addchart;
		},
		editing: function editing() {
			return this.$store.getters.editing;
		},
		loading: function loading() {
			return this.$store.getters.loading;
		},
		saveing: function saveing() {
			return this.$store.getters.saveing;
		}
	},

	mounted: function mounted() {
		this.$store.commit('ENABLE_SLIMNAVIGATION');
		if (!this.$store.getters.presentation || self.pid != this.$store.getters.presentation.id) {
			this.init();
		} else if (!this.$store.getters.loadings.presentation && (!this.$store.getters.presentation || keys_default()(this.$store.getters.presentation).length <= 0)) {
			this.init();
		}

		if (this._socketid) {
			this.$store.dispatch('socket/SEND_PACKAGE', {
				name: 'start edit presentation',
				payload: this._socketid,
				time: new Date().getTime()
			});
		}
	},
	destroyed: function destroyed() {
		this.$store.commit('DISABLE_SLIMNAVIGATION');

		if (this._socketid) {
			this.$store.dispatch('socket/SEND_PACKAGE', {
				name: 'end edit presentation',
				payload: this._socketid,
				time: new Date().getTime()
			});
		}
	},


	methods: extends_default()({}, rest, helpers_chart, {
		init: function init() {
			var self = this;

			var url = false,
			    name = '',
			    id = 0;
			if (self.pid) {
				console.log('self.pid', self.pid);
				name = 'presentation';
				id = self.pid;

				if (!(self.$store.getters.presentation && self.pid == self.$store.getters.presentation.id)) {
					console.log('debug presentation', !(self.$store.getters.presentation && self.pid == self.$store.getters.presentation.id), self.$store.getters.presentation.id, self.pid, self.pid == self.$store.getters.presentation.id);

					url = this.$store.getters.channel.urls.presentation.replace(':id:', self.pid);
				}
			} else if (this.master) {
				console.log('this.master', this.master);
				url = this.$store.getters.channel.urls.presentation.replace(':id:', 'master');
				name = 'master';
				id = 'master';
			} else if (this.$route.params.uid) {
				console.log('this.$route.params.uid', this.$route.params.uid);
				name = 'user';
				id = this.$route.params.uid;
				if (self.$store.getters.edituser) {
					// user was allready loaded
					self.$store.dispatch('SET_PRESENTATION', self.$store.getters.edituser.presentation);
				} else {
					url = this.$store.getters.channel.urls.user.replace(':id:', id);
				}
			} else if (this.$route.params.id) {
				console.log('this.$route.params.id', this.$route.params.id);
				name = 'page';
				id = this.$route.params.id;
				if (self.$store.getters.edituser) {
					// user was allready loaded
					self.$store.dispatch('SET_PRESENTATION', self.$store.getters.edituser.presentation);
				} else {
					url = '/api/v1/' + this.$route.name.split('-')[0] + 's' + '/' + id;

					// url = this.$store.getters.channel.urls.user.replace(':id:', id);
				}
			}

			if (id) this._socketid = id;

			if (url) {
				this.reset();

				this.restget(url, name).then(function (data) {
					if (!data) console.error('could not get presentation');
					self.$store.commit('START_LOADING', 'setupCharts');
					if (data.presentation) {
						self.$store.dispatch('SET_EDITUSER', data);
					} else {
						self.$store.dispatch('SET_PRESENTATION', data);
					}

					return true;
				}).then(function (data) {
					self.getChartTemplates().then(function (charttemplates) {
						// fallback
						var charts = self.$store.getters.charts;
						if (charts) {
							keys_default()(charts).forEach(function (k) {
								self.setupChart(charts[k]);
							});
						}
						return data;
					});
				}).then(function (data) {
					self.$store.commit('END_LOADING', 'setupCharts');
				}).catch(function (error) {
					console.error(error);
				});
			} else if (self.$store.getters.charts) {
				self.getChartTemplates().then(function (charttemplates) {
					// fallback
					var charts = self.$store.getters.charts;
					if (charts) {
						keys_default()(charts).forEach(function (k) {
							self.setupChart(charts[k]);
						});
					}
				});
			}
		},
		routerupdate: function routerupdate() {
			this.$store.commit('RESET_ACTIVE_FIELD');
		},
		addAbleChartsByChart: function addAbleChartsByChart(chartid) {
			if (chartid) {
				var chart = this.$store.getters.getChartById(chartid);
				if (chart && chart.addablecharts) {
					return chart.addablecharts;
				}
			}

			return this.$store.getters.presentation.addablecharts;
		},
		reset: function reset(resetui) {
			this.$store.commit('RESET_EDITUSER');
			this.$store.commit('RESET_ACTIVE_FIELD');
			this.$store.commit('RESET_PRESENTATIONID');
			this.$store.commit('UNSET_PRESENTATION');
			this.$store.commit('UNSET_ADDABLECHARTS');
			this.$store.commit('UNSET_CHARTS');
		}
	})
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3420227e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/p-editor.vue
var p_editor_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-editor ui-editor"},[_c('transition',{attrs:{"name":"ui-sidebar","enter-active-class":"animated animatefast fadeInLeft","leave-active-class":"animated animatefast fadeOutLeft"}},[(_vm.charts)?_c('div',{staticClass:"ui-editor__sidebar"},[_c('c-editor-sidebar')],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"ui-editor__main"},[(_vm.saveing)?_c('v-modal',{attrs:{"options":(false === true)}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Speichern")]),_vm._v(" "),_c('div',{attrs:{"slot":"message"},slot:"message"},[_vm._v("Dieser vorgang kann einige Sekunden dauern.")])]):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',[(_vm.presentation_type == 'user')?_c('c-editor-presentation',{attrs:{"uid":_vm.uid}}):(_vm.presentation_type == 'presentation')?_c('c-editor-presentation',{attrs:{"pid":_vm.pid}}):(_vm.presentation_type == 'master')?_c('c-editor-presentation',{attrs:{"master":true}}):_c('c-editor-presentation',{attrs:{"master":false}})],1):_vm._e()],1),_vm._v(" "),_c('c-editor-addablechart-modal')],1)}
var p_editor_staticRenderFns = []
var p_editor_esExports = { render: p_editor_render, staticRenderFns: p_editor_staticRenderFns }
/* harmony default export */ var pages_p_editor = (p_editor_esExports);
// CONCATENATED MODULE: ./src/pages/p-editor.vue
function p_editor_injectStyle (ssrContext) {
  __webpack_require__("BI6m")
}
var p_editor_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var p_editor___vue_template_functional__ = false
/* styles */
var p_editor___vue_styles__ = p_editor_injectStyle
/* scopeId */
var p_editor___vue_scopeId__ = "data-v-3420227e"
/* moduleIdentifier (server only) */
var p_editor___vue_module_identifier__ = null
var p_editor_Component = p_editor_normalizeComponent(
  p_editor,
  pages_p_editor,
  p_editor___vue_template_functional__,
  p_editor___vue_styles__,
  p_editor___vue_scopeId__,
  p_editor___vue_module_identifier__
)

/* harmony default export */ var src_pages_p_editor = (p_editor_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/p-editor/c-editor-charts.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function c_editor_charts_flatenCharts(charts) {
	var out = {};
	keys_default()(charts).forEach(function (key) {
		var chart = charts[key];
		if (!out[chart.id]) vue_esm["default"].set(out, chart.id, chart);
		if (chart.charts) out = assign_default()({}, out, c_editor_charts_flatenCharts(chart.charts));
	});

	return out;
}

/* harmony default export */ var c_editor_charts = ({
	name: 'c-editor-charts',
	props: ['chartid'],
	methods: {
		chart_component_exists: function chart_component_exists(chartname) {
			var ccexists = this.$store.getters.chartcomponents.indexOf(chartname) >= 0;
			if (!ccexists) console.info('chart component dosent exists', chartname);
			return ccexists;
		}
	},
	computed: {
		active_field: function active_field() {
			return this.$store.getters.active_field;
		},
		loading: function loading() {
			return this.$store.getters.loading;
		},
		charts: function charts() {
			var charts = c_editor_charts_flatenCharts(this.$store.getters.charts);
			return charts;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa388ff0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p-editor/c-editor-charts.vue
var c_editor_charts_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-editor-charts"},_vm._l((_vm.charts),function(chart){return (!_vm.loading)?_c('div',[(_vm.$route.params.chartid == chart.id)?_c('div',[_c('div',{staticClass:"c-editor-charts__editablebar",class:{ 'margin-top-large': !((chart.fields['background-image'] && chart.fields['background-image'].permissions.can_edit) || (chart.fields['background-video'] && chart.fields['background-video'].permissions.can_edit))}},[(chart.fields['background-image'] && chart.fields['background-image'].permissions.can_edit)?_c('div',{staticClass:"c-editor-charts__editable"},[_c('v-editable',{attrs:{"chartid":chart.id,"icon":'picture-o',"areaedit":false,"fieldname":'background-image'}})],1):_vm._e(),_vm._v(" "),(chart.fields['background-video'] && chart.fields['background-video'].permissions.can_edit)?_c('div',{staticClass:"c-editor-charts__editable"},[_c('v-editable',{attrs:{"chartid":chart.id,"icon":'video-camera',"areaedit":false,"name":'background-video'}})],1):_vm._e()]),_vm._v(" "),(_vm.chart_component_exists('v-chart-' + chart.component))?_c('v-chart-' + chart.component,{key:chart.id,tag:"div",attrs:{"data":chart}}):_vm._e(),_vm._v(" "),_vm._l((chart.fields),function(field,name){return (_vm.active_field.fieldname == name && !_vm.$store.getters['features/inlinemod'])?_c('v-field',{key:name,attrs:{"chart":chart,"name":name},on:{"cancel":function($event){_vm.$store.commit('RESET_ACTIVE_FIELD')}}}):_vm._e()})],2):_vm._e()]):_vm._e()}))}
var c_editor_charts_staticRenderFns = []
var c_editor_charts_esExports = { render: c_editor_charts_render, staticRenderFns: c_editor_charts_staticRenderFns }
/* harmony default export */ var p_editor_c_editor_charts = (c_editor_charts_esExports);
// CONCATENATED MODULE: ./src/components/p-editor/c-editor-charts.vue
function c_editor_charts_injectStyle (ssrContext) {
  __webpack_require__("ravv")
}
var c_editor_charts_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var c_editor_charts___vue_template_functional__ = false
/* styles */
var c_editor_charts___vue_styles__ = c_editor_charts_injectStyle
/* scopeId */
var c_editor_charts___vue_scopeId__ = "data-v-fa388ff0"
/* moduleIdentifier (server only) */
var c_editor_charts___vue_module_identifier__ = null
var c_editor_charts_Component = c_editor_charts_normalizeComponent(
  c_editor_charts,
  p_editor_c_editor_charts,
  c_editor_charts___vue_template_functional__,
  c_editor_charts___vue_styles__,
  c_editor_charts___vue_scopeId__,
  c_editor_charts___vue_module_identifier__
)

/* harmony default export */ var components_p_editor_c_editor_charts = (c_editor_charts_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/p-role-permission.vue

//
//
//
//
//
//
//
//
//
//
//

// Base


// Componenets

// funktion

// helper


/* harmony default export */ var p_role_permission = ({

	name: 'p-role-permission',

	props: {
		role: {
			type: String,
			default: ''
		}
	},

	data: function data() {
		return {
			permissions: {}
		};
	},


	methods: extends_default()({}, rest, {
		init: function init() {
			restget('/api/v1/roles/' + role, role + '-permission').then(function (msg) {
				console.log(msg);
			});
		}
	})
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56949b5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/p-role-permission.vue
var p_role_permission_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-role-permission"},[(!(_vm.$route.name.match(/-chart/) || _vm.$route.name.match(/-editor/)))?_c('div',{staticClass:"row margin-bottom-medium"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"st-headline st-headline--1"},[_vm._v(_vm._s(_vm.title))])])]):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var p_role_permission_staticRenderFns = []
var p_role_permission_esExports = { render: p_role_permission_render, staticRenderFns: p_role_permission_staticRenderFns }
/* harmony default export */ var pages_p_role_permission = (p_role_permission_esExports);
// CONCATENATED MODULE: ./src/pages/p-role-permission.vue
function p_role_permission_injectStyle (ssrContext) {
  __webpack_require__("ziuR")
}
var p_role_permission_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var p_role_permission___vue_template_functional__ = false
/* styles */
var p_role_permission___vue_styles__ = p_role_permission_injectStyle
/* scopeId */
var p_role_permission___vue_scopeId__ = "data-v-56949b5c"
/* moduleIdentifier (server only) */
var p_role_permission___vue_module_identifier__ = null
var p_role_permission_Component = p_role_permission_normalizeComponent(
  p_role_permission,
  pages_p_role_permission,
  p_role_permission___vue_template_functional__,
  p_role_permission___vue_styles__,
  p_role_permission___vue_scopeId__,
  p_role_permission___vue_module_identifier__
)

/* harmony default export */ var src_pages_p_role_permission = (p_role_permission_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/v-userform.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var v_userform = ({
	name: 'v-userform',
	components: {
		FFieldset: components_form_f_fieldset
	},
	computed: {
		saveing: function saveing() {
			return this.$store.getters.saveing;
		}
	},
	data: function data() {
		return {
			loading: false,
			isdeleting: false,
			deleteel: false
		};
	},

	props: {
		formfields: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		isnew: {
			type: Boolean,
			default: true
		},
		uid: {
			default: ''
		},
		rolename: {
			type: String,
			default: ''
		}
	},
	methods: extends_default()({
		startdeleteuser: function startdeleteuser(event) {
			this.deleteel = event.target;
			this.isdeleting = !this.isdeleting;
		},
		deleteuser: function deleteuser() {
			var _this = this;

			var self = this,
			    url = this.data && this.data.urls && this.data.urls.delete ? this.data.urls.delete : this.$store.getters.channel.urls.user.replace(':id:', this.data.id);

			self.loading = true;
			this.restdelete(url, 'delete').then(function (message) {
				self.loading = false;
				self.$emit('delete');
				_this.stopdeleteuser();
			});
		},
		stopdeleteuser: function stopdeleteuser() {
			this.deleteel = false;
			this.isdeleting = false;
		}
	}, rest, {
		getSaveableFields: function getSaveableFields(fields) {
			var self = this;
			var out = {};
			fields.forEach(function (item) {
				if (item.type == "image") return; //weiter

				if (typeof item.value !== 'undefined') {
					out[item.name] = item.value;
				}

				if (item.fields) {
					out = assign_default()({}, out, self.getSaveableFields(item.fields));
				}
			});
			return out;
		},
		getAndValidEdituser: function getAndValidEdituser() {
			var self = this;
			return new promise_default.a(function (resolve, reject) {

				var promises = [];
				for (var child in self.$refs.fieldset) {
					promises.push(self.$refs.fieldset[child].validate());
				}

				promise_default.a.all(promises).then(function (result) {
					var user = self.$store.getters.edituser;
					var payload = self.getSaveableFields(user.fields);
					resolve(payload);
				}).catch(function (errors) {
					reject(errors);
				});
			});
		},
		create: function create(ev) {
			var self = this;
			ev.preventDefault();

			this.getAndValidEdituser().then(function (payload) {
				self.restput(self.$store.getters.channel.urls.users + '/' + self.rolename, payload, 'saveing').then(function (message) {});
			}).catch(function (errors) {
				console.error(errors);
				self.$store.commit('ADD_NOTICE', {
					'text': 'There are errors in the Form',
					'type': 'error'
				});
			});
		},
		save: function save(ev) {
			var self = this;
			ev.preventDefault();
			console.log('save', ev);

			this.getAndValidEdituser().then(function (payload) {
				self.restpatch(self.$store.getters.channel.urls.user.replace(':id:', self.uid), payload, 'saveing').then(function (message) {
					console.log(message);
				});
			}).catch(function (errors) {
				console.error(errors);
				self.$store.commit('ADD_NOTICE', {
					'text': 'There are errors in the Form',
					'type': 'error'
				});
			});
		},
		promotToLeader: function promotToLeader(ev) {},
		requestPasswortEmail: function requestPasswortEmail(ev) {
			var email = this.$store.getters.getEditFieldById('email');
			if (email) {
				this.restpatch('/api/v1/request_password', { email: email.value }, 'request_password').then(function (message) {
					console.log(message);
				});
			}
		}
	})
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1530c11c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/v-userform.vue
var v_userform_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formfields.length > 0)?_c('form',{staticClass:"v-userform",on:{"submit":function($event){$event.preventDefault();_vm.save($event)}}},[_vm._l((_vm.formfields),function(field){return (field.fields.length > 0)?_c('f-' + field.type,{key:field.name,ref:"fieldset",refInFor:true,tag:"div",attrs:{"field":field}}):_vm._e()}),_vm._v(" "),(_vm.isnew && _vm.rolename !== 'customer')?_c('div',{staticClass:"st-form__fieldset"},[_c('div',{staticClass:"st-notice"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-11"},[_c('div',{staticClass:"user-content-wrapper"},[_vm._v("\n\t                    "+_vm._s(_vm.$t("After submitting this form, an automatic e-mail will be sent with login information to the specified address."))+"\n\t                ")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"st-form__fieldset"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6"}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 text-sm-right"},[(_vm.isnew)?_c('button',{staticClass:"st-btn st-btn--submit",class:{'st-btn--loading':_vm.saveing},attrs:{"type":"button","disabled":_vm.saveing},on:{"click":_vm.create}},[_vm._v(_vm._s(_vm.$t('Create')))]):_c('button',{staticClass:"st-btn st-btn--submit",class:{'st-btn--loading':_vm.saveing},attrs:{"type":"button","disabled":_vm.saveing},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('Save')))])])])]),_vm._v(" "),(_vm.$store.getters.edituser && _vm.$store.getters.edituser.permissions)?_c('div',{staticClass:"st-form__fieldset"},[_c('div',{staticClass:"row st-form__row"},[_c('div',{staticClass:"col-xs-12"},[(_vm.$store.getters.edituser.permissions.can_request_password)?_c('div',{staticClass:"st-link-block"},[_c('a',{staticClass:"st-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.requestPasswortEmail($event)}}},[_vm._v("Send activation email again")])]):_vm._e(),_vm._v(" "),(_vm.$store.getters.edituser.permissions.can_delete)?_c('div',{staticClass:"st-link-block"},[_c('a',{staticClass:"st-link st-link--delete",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.startdeleteuser($event)}}},[_vm._v(_vm._s(_vm.$t("Irrevocably delete this account.")))]),_vm._v(" "),(_vm.deleteel && _vm.isdeleting)?_c('v-tooldown',{attrs:{"loading":_vm.loading,"type":'delete',"el":_vm.deleteel,"yesno":true},on:{"ok":_vm.deleteuser,"cancel":_vm.stopdeleteuser}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.$t('Delete User')))]),_vm._v(" "),_c('span',{attrs:{"slot":"message"},slot:"message"},[_vm._v(_vm._s(_vm.$t('Do you really want to delete this user.')))]),_vm._v(" "),_c('span',{attrs:{"slot":"positive"},slot:"positive"},[_vm._v(_vm._s(_vm.$t('Delete')))])]):_vm._e()],1):_vm._e()])])]):_vm._e()],2):_vm._e()}
var v_userform_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-sm-1"},[_c('i',{staticClass:"fa fa-hand-o-right",attrs:{"aria-hidden":"true"}})])}]
var v_userform_esExports = { render: v_userform_render, staticRenderFns: v_userform_staticRenderFns }
/* harmony default export */ var form_v_userform = (v_userform_esExports);
// CONCATENATED MODULE: ./src/components/form/v-userform.vue
function v_userform_injectStyle (ssrContext) {
  __webpack_require__("OJrQ")
}
var v_userform_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var v_userform___vue_template_functional__ = false
/* styles */
var v_userform___vue_styles__ = v_userform_injectStyle
/* scopeId */
var v_userform___vue_scopeId__ = "data-v-1530c11c"
/* moduleIdentifier (server only) */
var v_userform___vue_module_identifier__ = null
var v_userform_Component = v_userform_normalizeComponent(
  v_userform,
  form_v_userform,
  v_userform___vue_template_functional__,
  v_userform___vue_styles__,
  v_userform___vue_scopeId__,
  v_userform___vue_module_identifier__
)

/* harmony default export */ var components_form_v_userform = (v_userform_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/p-userform.vue
//
//
//
//
//
//
//
//



/* harmony default export */ var p_userform = ({
	name: 'p-userform',
	components: {
		VUserform: components_form_v_userform
	},
	computed: {
		edituser: function edituser() {
			return this.$store.getters.edituser;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1a04c06","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/p-userform.vue
var p_userform_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-userform"},[(_vm.edituser && _vm.edituser.fields)?_c('div',[_c('v-userform',{attrs:{"rolename":_vm.edituser.role,"uid":_vm.edituser.id,"isnew":!_vm.edituser.id,"formfields":_vm.edituser.fields}})],1):_vm._e()])}
var p_userform_staticRenderFns = []
var p_userform_esExports = { render: p_userform_render, staticRenderFns: p_userform_staticRenderFns }
/* harmony default export */ var pages_p_userform = (p_userform_esExports);
// CONCATENATED MODULE: ./src/pages/p-userform.vue
function p_userform_injectStyle (ssrContext) {
  __webpack_require__("GKAi")
}
var p_userform_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var p_userform___vue_template_functional__ = false
/* styles */
var p_userform___vue_styles__ = p_userform_injectStyle
/* scopeId */
var p_userform___vue_scopeId__ = "data-v-c1a04c06"
/* moduleIdentifier (server only) */
var p_userform___vue_module_identifier__ = null
var p_userform_Component = p_userform_normalizeComponent(
  p_userform,
  pages_p_userform,
  p_userform___vue_template_functional__,
  p_userform___vue_styles__,
  p_userform___vue_scopeId__,
  p_userform___vue_module_identifier__
)

/* harmony default export */ var src_pages_p_userform = (p_userform_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/p-styleguide.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var p_styleguide = ({
	name: 'p-styleguide'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22b0fd85","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/p-styleguide.vue
var p_styleguide_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var p_styleguide_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-styleguide"},[_c('div',{staticClass:"st-group"},[_c('div',{staticClass:"container container-max"},[_c('h2',{staticClass:"st-headline st-headline--2"},[_vm._v("Sales Tool")]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('h3',{staticClass:"st-headline st-headline--3"},[_vm._v("Example Type")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"})])])]),_vm._v(" "),_c('div',{staticClass:"st-group"},[_c('div',{staticClass:"container container-max"},[_c('h2',{staticClass:"st-headline st-headline--2"},[_vm._v("Headlines")]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('h3',{staticClass:"st-headline st-headline--1"},[_vm._v("Headline 1")]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('h3',{staticClass:"st-headline st-headline--2"},[_vm._v("Headline 2")]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('h3',{staticClass:"st-headline st-headline--3"},[_vm._v("Headline 3")])])]),_vm._v(" "),_c('div',{staticClass:"st-group"},[_c('div',{staticClass:"container container-max"},[_c('h2',{staticClass:"st-headline st-headline--2"},[_vm._v("Text")]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"user-content-wrapper"},[_c('p',[_vm._v("Lorem "),_c('b',[_vm._v("ipsum")]),_vm._v(" "),_c('i',[_vm._v("dolor")]),_vm._v(" "),_c('b',[_c('i',[_vm._v("sit amet")])]),_vm._v(", consectetur adipisicing elit. Dolore at tempore odio unde sapiente maxime sunt, omnis amet neque mollitia eius velit in, culpa ipsum ipsa tenetur perferendis atque. "),_c('a',{attrs:{"href":"#"}},[_vm._v("Esse")]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("Nesciunt dolores dignissimos corporis soluta ex distinctio velit labore recusandae nemo quia obcaecati numquam optio, quo officiis, suscipit laboriosam dolore quae consequuntur fuga odit dolor. Voluptatibus eaque, dolore consectetur in!")])])])])])]),_vm._v(" "),_c('div',{staticClass:"st-group"},[_c('div',{staticClass:"container container-max"},[_c('h2',{staticClass:"st-headline st-headline--2"},[_vm._v("Buttons")]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('h3',{staticClass:"st-headline st-headline--3"},[_vm._v("Normal")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-3"},[_c('a',{staticClass:"st-btn st-btn--small",attrs:{"href":"#"}},[_vm._v("Small")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"st-btn",attrs:{"href":"#"}},[_vm._v("Button")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"st-btn st-btn--hover",attrs:{"href":"#"}},[_vm._v("Hover")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"st-btn st-btn--active",attrs:{"href":"#"}},[_vm._v("Active")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"st-btn st-btn--disabled",attrs:{"href":"#"}},[_vm._v("disabled")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"st-btn st-btn--loading",attrs:{"href":"#"}},[_vm._v("Loading")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-3"},[_c('input',{staticClass:"st-btn st-btn--small",attrs:{"type":"button","value":"Small"}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"st-btn",attrs:{"type":"button","value":"Button"}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"st-btn st-btn--hover",attrs:{"type":"button","value":"Hover"}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"st-btn st-btn--active",attrs:{"type":"button","value":"Active"}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"st-btn st-btn--disabled",attrs:{"type":"button","value":"disabled"}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"st-btn st-btn--loading",attrs:{"type":"button","value":"Loading"}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-3"},[_c('button',{staticClass:"st-btn st-btn--small"},[_vm._v("Small")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"st-btn"},[_vm._v("Button")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"st-btn st-btn--hover"},[_vm._v("Hover")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"st-btn st-btn--active"},[_vm._v("Active")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"st-btn st-btn--disabled "},[_vm._v("disabled")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"st-btn st-btn--loading"},[_vm._v("Loading")])])]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('h3',{staticClass:"st-headline st-headline--3"},[_vm._v("Primary / Aktion")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-3"},[_c('a',{staticClass:"st-btn st-btn--small st-btn--primary",attrs:{"href":"#"}},[_vm._v("Small")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"st-btn st-btn--primary",attrs:{"href":"#"}},[_vm._v("Button")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"st-btn st-btn--hover st-btn--primary",attrs:{"href":"#"}},[_vm._v("Hover")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"st-btn st-btn--active st-btn--primary",attrs:{"href":"#"}},[_vm._v("Active")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"st-btn st-btn--disabled st-btn--primary",attrs:{"href":"#"}},[_vm._v("Disabled")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"st-btn st-btn--loading st-btn--primary",attrs:{"href":"#"}},[_vm._v("Loading")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"st-btn st-btn--disabled st-btn--loading st-btn--primary",attrs:{"href":"#"}},[_vm._v("Disabled Loading")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-3"},[_c('input',{staticClass:"st-btn st-btn--small st-btn--primary",attrs:{"type":"button","value":"Small"}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"st-btn st-btn--primary",attrs:{"type":"button","value":"Button"}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"st-btn st-btn--hover st-btn--primary",attrs:{"type":"button","value":"Hover"}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"st-btn st-btn--active st-btn--primary",attrs:{"type":"button","value":"Active"}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"st-btn st-btn--disabled st-btn--primary",attrs:{"type":"button","value":"disabled","disabled":""}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"st-btn st-btn--loading st-btn--primary",attrs:{"type":"button","value":"Loading"}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"st-btn st-btn--disabled st-btn--loading st-btn--primary",attrs:{"type":"button","value":"Disabled Loading"}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-3"},[_c('button',{staticClass:"st-btn st-btn--small st-btn--primary"},[_vm._v("Small")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"st-btn st-btn--primary"},[_vm._v("Button")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"st-btn st-btn--hover st-btn--primary"},[_vm._v("Hover")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"st-btn st-btn--active st-btn--primary"},[_vm._v("Active")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"st-btn st-btn--disabled st-btn--primary"},[_vm._v("Disabled")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"st-btn st-btn--loading st-btn--primary"},[_vm._v("Loading")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"st-btn st-btn--disabled st-btn--loading st-btn--primary"},[_vm._v("Disabled Loading")])])]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('h3',{staticClass:"st-headline st-headline--3"},[_vm._v("Dark")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-3"},[_c('a',{staticClass:"st-btn st-btn--small st-btn--dark",attrs:{"href":"#"}},[_vm._v("Small")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"st-btn st-btn--dark",attrs:{"href":"#"}},[_vm._v("Button")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"st-btn st-btn--hover st-btn--dark",attrs:{"href":"#"}},[_vm._v("Hover")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"st-btn st-btn--active st-btn--dark",attrs:{"href":"#"}},[_vm._v("Active")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"st-btn st-btn--disabled st-btn--dark",attrs:{"href":"#"}},[_vm._v("Disabled")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"st-btn st-btn--loading st-btn--dark",attrs:{"href":"#"}},[_vm._v("Loading")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"st-btn st-btn--disabled st-btn--loading st-btn--dark",attrs:{"href":"#"}},[_vm._v("Disabled Loading")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-3"},[_c('input',{staticClass:"st-btn st-btn--small st-btn--dark",attrs:{"type":"button","value":"Small"}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"st-btn st-btn--dark",attrs:{"type":"button","value":"Button"}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"st-btn st-btn--hover st-btn--dark",attrs:{"type":"button","value":"Hover"}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"st-btn st-btn--active st-btn--dark",attrs:{"type":"button","value":"Active"}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"st-btn st-btn--disabled st-btn--dark",attrs:{"type":"button","value":"disabled","disabled":""}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"st-btn st-btn--loading st-btn--dark",attrs:{"type":"button","value":"Loading"}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"st-btn st-btn--disabled st-btn--loading st-btn--dark",attrs:{"type":"button","value":"Disabled Loading"}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-3"},[_c('button',{staticClass:"st-btn st-btn--small st-btn--dark"},[_vm._v("Small")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"st-btn st-btn--dark"},[_vm._v("Button")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"st-btn st-btn--hover st-btn--dark"},[_vm._v("Hover")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"st-btn st-btn--active st-btn--dark"},[_vm._v("Active")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"st-btn st-btn--disabled st-btn--dark"},[_vm._v("Disabled")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"st-btn st-btn--loading st-btn--dark"},[_vm._v("Loading")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"st-btn st-btn--disabled st-btn--loading st-btn--dark"},[_vm._v("Disabled Loading")])])])])]),_vm._v(" "),_c('div',{staticClass:"st-group"},[_c('div',{staticClass:"container container-max"},[_c('h2',{staticClass:"st-headline st-headline--2"},[_vm._v("Loading")]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"})])])]),_vm._v(" "),_c('div',{staticClass:"st-group"},[_c('div',{staticClass:"container container-max"},[_c('h2',{staticClass:"st-headline st-headline--2"},[_vm._v("Inputs")]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('div',{staticClass:"row col-xs-12 col-sm-6"},[_c('h3',{staticClass:"st-headline st-headline--3"},[_vm._v("Text")]),_vm._v(" "),_c('input',{staticClass:"st-input st-input--text",attrs:{"type":"text","placeholder":"Name"}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"st-input st-input--text",attrs:{"type":"text","placeholder":"Name","value":"Pascal Franzke"}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"st-input st-input--error st-input--text",attrs:{"type":"text","placeholder":"Name","value":"Pascal Franzke"}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"st-input st-input--disabled st-input--text",attrs:{"disabled":"","type":"text","placeholder":"Name","value":"Pascal Franzke"}}),_c('br')]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('div',{staticClass:"row col-xs-12 col-sm-6"},[_c('h3',{staticClass:"st-headline st-headline--3"},[_vm._v("Textarea")]),_vm._v(" "),_c('textarea',{staticClass:"st-input st-input--textarea",attrs:{"name":"","id":"","cols":"50","rows":"4","placeholder":"example textarea"}}),_c('br'),_vm._v(" "),_c('textarea',{staticClass:"st-input st-input--textarea",attrs:{"name":"","id":"","cols":"50","rows":"4","placeholder":"example textarea"}},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dicta corporis voluptatem possimus voluptate harum ducimus aliquid tempora. Dolorum omnis impedit a, ex totam et minus, dicta quisquam soluta iusto hic.")]),_c('br'),_vm._v(" "),_c('textarea',{staticClass:"st-input st-input--error st-input--textarea",attrs:{"name":"","id":"","cols":"50","rows":"4","placeholder":"example textarea"}},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatem sint quod sequi fugiat, modi ratione aliquid. In sint tenetur nostrum cupiditate harum, repudiandae sapiente provident veritatis ducimus quisquam rerum, quos.")]),_c('br'),_vm._v(" "),_c('textarea',{staticClass:"st-input st-input--disabled st-input--textarea",attrs:{"disabled":"","name":"","id":"","cols":"50","rows":"4","placeholder":"example textarea"}},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatem sint quod sequi fugiat, modi ratione aliquid. In sint tenetur nostrum cupiditate harum, repudiandae sapiente provident veritatis ducimus quisquam rerum, quos.")])])])]),_vm._v(" "),_c('div',{staticClass:"st-group"},[_c('div',{staticClass:"container container-max"},[_c('div',{staticClass:"dive"}),_vm._v(" "),_c('div',{staticClass:"row col-xs-12 col-sm-6"},[_c('h2',{staticClass:"st-headline st-headline--2"},[_vm._v("Checkbox")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"st-checkbox"},[_c('input',{staticClass:"st-checkbox__input",attrs:{"type":"checkbox","id":"checkbox0","name":"checkbox0"}}),_vm._v(" "),_c('label',{staticClass:"st-checkbox__label",attrs:{"for":"checkbox0"}})]),_vm._v(" "),_c('div',{staticClass:"st-checkbox st-checkbox--disabled"},[_c('input',{staticClass:"st-checkbox__input",attrs:{"disabled":"","type":"checkbox","id":"checkbox1","name":"checkbox1"}}),_vm._v(" "),_c('label',{staticClass:"st-checkbox__label",attrs:{"for":"checkbox1"}})]),_vm._v(" "),_c('div',{staticClass:"st-checkbox st-checkbox--hover"},[_c('input',{staticClass:"st-checkbox__input",attrs:{"checked":"","type":"checkbox","id":"checkbox2","name":"checkbox2"}}),_vm._v(" "),_c('label',{staticClass:"st-checkbox__label",attrs:{"for":"checkbox2"}})])])]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('div',{staticClass:"row col-xs-12 col-sm-6"},[_c('h3',{staticClass:"st-headline st-headline--3"},[_vm._v("Radios")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"st-checkbox st-checkbox--radio"},[_c('input',{staticClass:"st-checkbox__input",attrs:{"type":"radio","id":"radio0","name":"companion2"}}),_vm._v(" "),_c('label',{staticClass:"st-checkbox__label",attrs:{"for":"radio0"}})]),_vm._v(" "),_c('div',{staticClass:"st-checkbox st-checkbox--radio st-checkbox--disabled"},[_c('input',{staticClass:"st-checkbox__input",attrs:{"disabled":"","type":"radio","id":"radio1","name":"companion2"}}),_vm._v(" "),_c('label',{staticClass:"st-checkbox__label",attrs:{"for":"radio1"}})]),_vm._v(" "),_c('div',{staticClass:"st-checkbox st-checkbox--radio st-checkbox--hover"},[_c('input',{staticClass:"st-checkbox__input",attrs:{"checked":"","type":"radio","id":"radio2","name":"companion2"}}),_vm._v(" "),_c('label',{staticClass:"st-checkbox__label",attrs:{"for":"radio2"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"st-group"},[_c('div',{staticClass:"container container-max"},[_c('h2',{staticClass:"st-headline st-headline--2"},[_vm._v("Notice")]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('h3',{staticClass:"st-headline st-headline--3"},[_vm._v("Normal")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-8"},[_c('div',{staticClass:"st-notice box-shadow"},[_c('div',{staticClass:"user-content-wrapper"},[_vm._v("\n                            Beim Absenden dieses Formulars wird eine automatische E-Mail"),_c('br'),_vm._v("\n                            mit Login-Informationen an die angegebene Adresse verschickt.\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('div',{staticClass:"st-notice"},[_c('div',{staticClass:"user-content-wrapper"},[_vm._v("\n                            Beim Absenden dieses Formulars wird eine automatische E-Mail"),_c('br'),_vm._v("\n                            mit Login-Informationen an die angegebene Adresse verschickt.\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('div',{staticClass:"st-notice st-notice--small"},[_c('div',{staticClass:"user-content-wrapper"},[_vm._v("\n                            Beim Absenden dieses Formulars wird eine automatische E-Mail"),_c('br'),_vm._v("\n                            mit Login-Informationen an die angegebene Adresse verschickt.\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('div',{staticClass:"st-notice"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-1"},[_c('i',{staticClass:"fa fa-hand-o-right",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-11"},[_c('div',{staticClass:"user-content-wrapper"},[_vm._v("\n                                    Beim Absenden dieses Formulars wird eine automatische E-Mail"),_c('br'),_vm._v("\n                                mit Login-Informationen an die angegebene Adresse verschickt.\n                                ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('h3',{staticClass:"st-headline st-headline--3"},[_vm._v("Warning")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-8"},[_c('div',{staticClass:"st-notice st-notice--warning"},[_c('div',{staticClass:"user-content-wrapper"},[_vm._v("\n                            Beim Absenden dieses Formulars wird eine automatische E-Mail"),_c('br'),_vm._v("\n                            mit Login-Informationen an die angegebene Adresse verschickt.\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('div',{staticClass:"st-notice st-notice--small st-notice--warning"},[_c('div',{staticClass:"user-content-wrapper"},[_vm._v("\n                            Beim Absenden dieses Formulars wird eine automatische E-Mail"),_c('br'),_vm._v("\n                            mit Login-Informationen an die angegebene Adresse verschickt.\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('div',{staticClass:"st-notice st-notice--warning"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-1"},[_c('i',{staticClass:"fa fa-exclamation-triangle",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-11"},[_c('div',{staticClass:"user-content-wrapper"},[_vm._v("\n                                    Beim Absenden dieses Formulars wird eine automatische E-Mail"),_c('br'),_vm._v("\n                                mit Login-Informationen an die angegebene Adresse verschickt.\n                                ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('h3',{staticClass:"st-headline st-headline--3"},[_vm._v("Error")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-8"},[_c('div',{staticClass:"st-notice st-notice--error"},[_c('div',{staticClass:"user-content-wrapper"},[_vm._v("\n                            Beim Absenden dieses Formulars wird eine automatische E-Mail"),_c('br'),_vm._v("\n                            mit Login-Informationen an die angegebene Adresse verschickt.\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('div',{staticClass:"st-notice st-notice--small st-notice--error"},[_c('div',{staticClass:"user-content-wrapper"},[_vm._v("\n                            Beim Absenden dieses Formulars wird eine automatische E-Mail"),_c('br'),_vm._v("\n                            mit Login-Informationen an die angegebene Adresse verschickt.\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('div',{staticClass:"st-notice st-notice--error"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-1"},[_c('i',{staticClass:"fa fa-exclamation-triangle",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-11"},[_c('div',{staticClass:"user-content-wrapper"},[_vm._v("\n                                    Beim Absenden dieses Formulars wird eine automatische E-Mail"),_c('br'),_vm._v("\n                                mit Login-Informationen an die angegebene Adresse verschickt.\n                                ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('h3',{staticClass:"st-headline st-headline--3"},[_vm._v("Success")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-8"},[_c('div',{staticClass:"st-notice st-notice--success"},[_c('div',{staticClass:"user-content-wrapper"},[_vm._v("\n                            Beim Absenden dieses Formulars wird eine automatische E-Mail"),_c('br'),_vm._v("\n                            mit Login-Informationen an die angegebene Adresse verschickt.\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('div',{staticClass:"st-notice st-notice--small st-notice--success"},[_c('div',{staticClass:"user-content-wrapper"},[_vm._v("\n                            Beim Absenden dieses Formulars wird eine automatische E-Mail"),_c('br'),_vm._v("\n                            mit Login-Informationen an die angegebene Adresse verschickt.\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('div',{staticClass:"st-notice st-notice--success"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-1"},[_c('i',{staticClass:"fa fa-exclamation-triangle",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-11"},[_c('div',{staticClass:"user-content-wrapper"},[_vm._v("\n                                    Beim Absenden dieses Formulars wird eine automatische E-Mail"),_c('br'),_vm._v("\n                                mit Login-Informationen an die angegebene Adresse verschickt.\n                                ")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"st-group"},[_c('div',{staticClass:"container container-max"},[_c('h2',{staticClass:"st-headline st-headline--2"},[_vm._v("Breadcrumb")]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('ul',{staticClass:"st-breadcrumb",attrs:{"itemscope":"","itemtype":"http://schema.org/BreadcrumbList"}},[_c('li',{staticClass:"st-breadcrumb__item",attrs:{"itemprop":"itemListElement","itemscope":"","itemtype":"http://schema.org/ListItem"}},[_c('a',{staticClass:"st-breadcrumb__link",attrs:{"itemprop":"item","href":""}},[_c('span',{attrs:{"itemprop":"name"}},[_vm._v("Home")])])]),_vm._v(" "),_c('li',{staticClass:"st-breadcrumb__item",attrs:{"itemprop":"itemListElement","itemscope":"","itemtype":"http://schema.org/ListItem"}},[_c('a',{staticClass:"st-breadcrumb__link",attrs:{"itemprop":"item","href":""}},[_c('span',{attrs:{"itemprop":"name"}},[_vm._v("Indirect Sales")])])]),_vm._v(" "),_c('li',{staticClass:"st-breadcrumb__item",attrs:{"itemprop":"itemListElement","itemscope":"","itemtype":"http://schema.org/ListItem"}},[_c('a',{staticClass:"st-breadcrumb__link",attrs:{"itemprop":"item","href":""}},[_c('span',{attrs:{"itemprop":"name"}},[_vm._v("Teamleiter hinzufügen")])])])])])]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('h3',{staticClass:"st-headline st-headline--3"},[_vm._v("Inline Nav")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('a',{staticClass:"inline-nav",attrs:{"href":"#"}},[_vm._v("zurück zu allen Präsentationen")])])])])]),_vm._v(" "),_c('div',{staticClass:"st-group"},[_c('div',{staticClass:"container container-max"},[_c('h2',{staticClass:"st-headline st-headline--2"},[_vm._v("Table (not sortable)")]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('table',{staticClass:"st-table st-table--fixed st-table--full"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Title")]),_vm._v(" "),_c('th',[_vm._v("Title")])])]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"has-action"},[_c('th',[_c('a',{staticClass:"st-table__link",attrs:{"href":"#"}},[_vm._v("Table Text Primary")]),_vm._v(" "),_c('div',{staticClass:"st-table-action"},[_c('a',{staticClass:"st-table-action__link",attrs:{"href":"#Bearbeiten"}},[_vm._v("Bearbeiten")]),_vm._v(" | "),_c('a',{staticClass:"st-table-action__link st-table-action__link--delete",attrs:{"href":"#Löschen"}},[_vm._v("Löschen")])])]),_vm._v(" "),_c('td',[_vm._v("Table Text")])]),_vm._v(" "),_c('tr',[_c('th',[_c('a',{staticClass:"st-table__link",attrs:{"href":"#"}},[_vm._v("Table Text Primary")])]),_vm._v(" "),_c('td',[_vm._v("Table Text")])]),_vm._v(" "),_c('tr',[_c('th',[_c('a',{staticClass:"st-table__link",attrs:{"href":"#"}},[_vm._v("Table Text Primary")])]),_vm._v(" "),_c('td',[_vm._v("Table Text")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"st-group"},[_c('div',{staticClass:"container container-max"},[_c('h2',{staticClass:"st-headline st-headline--2"},[_vm._v("Filters")]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"st-filters"},[_c('a',{staticClass:"st-filters__link st-filters__link--active",attrs:{"href":"#"}},[_vm._v("Alle (24)")]),_vm._v(" |\n                        "),_c('a',{staticClass:"st-filters__link",attrs:{"href":"#"}},[_vm._v("Partner Business (12)")]),_vm._v(" |\n                        "),_c('a',{staticClass:"st-filters__link",attrs:{"href":"#"}},[_vm._v("Project Business (12)")])])])])])]),_vm._v(" "),_c('div',{staticClass:"st-group"},[_c('div',{staticClass:"container container-max"},[_c('h2',{staticClass:"st-headline st-headline--2"},[_vm._v("Select")]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('select',{staticClass:"st-select",attrs:{"name":"asd","id":"asd"}},[_c('option',{attrs:{"value":"asd"}},[_vm._v("asd")]),_vm._v(" "),_c('option',{attrs:{"value":"asd"}},[_vm._v("asd")]),_vm._v(" "),_c('option',{attrs:{"disabled":"","value":"asd"}},[_vm._v("asd")]),_vm._v(" "),_c('option',{attrs:{"value":"asd"}},[_vm._v("asd")])]),_vm._v(" "),_c('select',{staticClass:"st-select",attrs:{"disabled":"true","name":"asd","id":"asd"}},[_c('option',{attrs:{"value":"asd"}},[_vm._v("asd")]),_vm._v(" "),_c('option',{attrs:{"value":"asd"}},[_vm._v("asd")]),_vm._v(" "),_c('option',{attrs:{"disabled":"","value":"asd"}},[_vm._v("asd")]),_vm._v(" "),_c('option',{attrs:{"value":"asd"}},[_vm._v("asd")])])])])])]),_vm._v(" "),_c('div',{staticClass:"st-group"},[_c('div',{staticClass:"container container-max"},[_c('h2',{staticClass:"st-headline st-headline--2"},[_vm._v("List")]),_vm._v(" "),_c('div',{staticClass:"dive"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('ul',{staticClass:"st-list"},[_c('li',{staticClass:"st-list__item"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('li',{staticClass:"st-list__item"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('li',{staticClass:"st-list__item"},[_vm._v("Lorem ipsum dolor sit amet")])]),_vm._v(" "),_c('ul',{staticClass:"st-list st-list--flat"},[_c('li',{staticClass:"st-list__item"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('li',{staticClass:"st-list__item"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('li',{staticClass:"st-list__item"},[_vm._v("Lorem ipsum dolor sit amet")])])])])])])])}]
var p_styleguide_esExports = { render: p_styleguide_render, staticRenderFns: p_styleguide_staticRenderFns }
/* harmony default export */ var pages_p_styleguide = (p_styleguide_esExports);
// CONCATENATED MODULE: ./src/pages/p-styleguide.vue
function p_styleguide_injectStyle (ssrContext) {
  __webpack_require__("dKjR")
}
var p_styleguide_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var p_styleguide___vue_template_functional__ = false
/* styles */
var p_styleguide___vue_styles__ = p_styleguide_injectStyle
/* scopeId */
var p_styleguide___vue_scopeId__ = "data-v-22b0fd85"
/* moduleIdentifier (server only) */
var p_styleguide___vue_module_identifier__ = null
var p_styleguide_Component = p_styleguide_normalizeComponent(
  p_styleguide,
  pages_p_styleguide,
  p_styleguide___vue_template_functional__,
  p_styleguide___vue_styles__,
  p_styleguide___vue_scopeId__,
  p_styleguide___vue_module_identifier__
)

/* harmony default export */ var src_pages_p_styleguide = (p_styleguide_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/p-translations.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var p_translations = ({
	name: 'v-translations'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1705e1c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/p-translations.vue
var p_translations_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-translations"},[_c('table',{staticClass:"st-table st-table--full"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Dev Englisch")]),_vm._v(" "),_vm._l((_vm.$i18n.messages),function(messages,langcode){return _c('th',[_vm._v(_vm._s(_vm.$t(langcode)))])})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.$i18n.messages.en),function(value,defaultValue){return _c('tr',[_c('td',[_vm._v(_vm._s(defaultValue))]),_vm._v(" "),_vm._l((_vm.$i18n.messages),function(messages,langcode){return _c('td',[_vm._v("\n\t\t\t\t\t"+_vm._s(messages[defaultValue])+"\n\t\t\t\t")])})],2)}))])])}
var p_translations_staticRenderFns = []
var p_translations_esExports = { render: p_translations_render, staticRenderFns: p_translations_staticRenderFns }
/* harmony default export */ var pages_p_translations = (p_translations_esExports);
// CONCATENATED MODULE: ./src/pages/p-translations.vue
function p_translations_injectStyle (ssrContext) {
  __webpack_require__("ENT2")
}
var p_translations_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var p_translations___vue_template_functional__ = false
/* styles */
var p_translations___vue_styles__ = p_translations_injectStyle
/* scopeId */
var p_translations___vue_scopeId__ = "data-v-1705e1c2"
/* moduleIdentifier (server only) */
var p_translations___vue_module_identifier__ = null
var p_translations_Component = p_translations_normalizeComponent(
  p_translations,
  pages_p_translations,
  p_translations___vue_template_functional__,
  p_translations___vue_styles__,
  p_translations___vue_scopeId__,
  p_translations___vue_module_identifier__
)

/* harmony default export */ var src_pages_p_translations = (p_translations_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageGroup.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var PageGroup = ({
	name: 'PageGroup'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1fb51da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageGroup.vue
var PageGroup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageGroup"},[_c('transition',{attrs:{"name":"PageGroupTranstion","enter-active-class":"animated PageGroupFadeIn"}},[_c('router-view')],1)],1)}
var PageGroup_staticRenderFns = []
var PageGroup_esExports = { render: PageGroup_render, staticRenderFns: PageGroup_staticRenderFns }
/* harmony default export */ var pages_PageGroup = (PageGroup_esExports);
// CONCATENATED MODULE: ./src/pages/PageGroup.vue
var PageGroup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageGroup___vue_template_functional__ = false
/* styles */
var PageGroup___vue_styles__ = null
/* scopeId */
var PageGroup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageGroup___vue_module_identifier__ = null
var PageGroup_Component = PageGroup_normalizeComponent(
  PageGroup,
  pages_PageGroup,
  PageGroup___vue_template_functional__,
  PageGroup___vue_styles__,
  PageGroup___vue_scopeId__,
  PageGroup___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageGroup = (PageGroup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageGroupReset.vue
//
//
//
//
//
//

/* harmony default export */ var PageGroupReset = ({
	name: 'PageGroupReset',
	destroyed: function destroyed() {
		this.$store.commit('RESET_EDITUSER');
		this.$store.commit('RESET_ACTIVE_FIELD');
		this.$store.commit('RESET_PRESENTATIONID');
		this.$store.commit('UNSET_PRESENTATION');
		this.$store.commit('UNSET_ADDABLECHARTS');
		this.$store.commit('UNSET_CHARTS');
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32119d5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageGroupReset.vue
var PageGroupReset_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageGroupReset"},[_c('router-view')],1)}
var PageGroupReset_staticRenderFns = []
var PageGroupReset_esExports = { render: PageGroupReset_render, staticRenderFns: PageGroupReset_staticRenderFns }
/* harmony default export */ var pages_PageGroupReset = (PageGroupReset_esExports);
// CONCATENATED MODULE: ./src/pages/PageGroupReset.vue
var PageGroupReset_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageGroupReset___vue_template_functional__ = false
/* styles */
var PageGroupReset___vue_styles__ = null
/* scopeId */
var PageGroupReset___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageGroupReset___vue_module_identifier__ = null
var PageGroupReset_Component = PageGroupReset_normalizeComponent(
  PageGroupReset,
  pages_PageGroupReset,
  PageGroupReset___vue_template_functional__,
  PageGroupReset___vue_styles__,
  PageGroupReset___vue_scopeId__,
  PageGroupReset___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageGroupReset = (PageGroupReset_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageTest.vue
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PageTest = ({
	name: 'PageTest',
	components: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8165334","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageTest.vue
var PageTest_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var PageTest_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageTest"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"})])])}]
var PageTest_esExports = { render: PageTest_render, staticRenderFns: PageTest_staticRenderFns }
/* harmony default export */ var pages_PageTest = (PageTest_esExports);
// CONCATENATED MODULE: ./src/pages/PageTest.vue
var PageTest_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageTest___vue_template_functional__ = false
/* styles */
var PageTest___vue_styles__ = null
/* scopeId */
var PageTest___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageTest___vue_module_identifier__ = null
var PageTest_Component = PageTest_normalizeComponent(
  PageTest,
  pages_PageTest,
  PageTest___vue_template_functional__,
  PageTest___vue_styles__,
  PageTest___vue_scopeId__,
  PageTest___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageTest = (PageTest_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-switches/src/switches.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var switches = ({
    name: 'switches',

    props: {
        typeBold: {
            default: false
        },

        value: {
            default: false
        },

        disabled: {
            default: false
        },

        label: {
            default: ''
        },

        textEnabled: {
            default: ''
        },

        textDisabled: {
            default: ''
        },

        color: {
            default: 'default'
        },

        theme: {
            default: 'default'
        },

        emitOnMount: {
            default: true
        }
    },

    mounted: function mounted() {
        if (this.emitOnMount) {
            this.$emit('input', this.value);
        }
    },


    methods: {
        trigger: function trigger(e) {
            this.$emit('input', e.target.checked);
        }
    },

    computed: {
        classObject: function classObject() {
            var _ref;

            var color = this.color,
                value = this.value,
                theme = this.theme,
                typeBold = this.typeBold,
                disabled = this.disabled;


            return _ref = {
                'vue-switcher': true
            }, defineProperty_default()(_ref, 'vue-switcher--unchecked', !value), defineProperty_default()(_ref, 'vue-switcher--disabled', disabled), defineProperty_default()(_ref, 'vue-switcher--bold', typeBold), defineProperty_default()(_ref, 'vue-switcher--bold--unchecked', typeBold && !value), defineProperty_default()(_ref, 'vue-switcher-theme--' + theme, color), defineProperty_default()(_ref, 'vue-switcher-color--' + color, color), _ref;
        },
        shouldShowLabel: function shouldShowLabel() {
            return this.label !== '' || this.textEnabled !== '' || this.textDisabled !== '';
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e4870fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-switches/src/switches.vue
var switches_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classObject},[(_vm.shouldShowLabel)?_c('span',{staticClass:"vue-switcher__label"},[(_vm.label)?_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}):_vm._e(),_vm._v(" "),(!_vm.label && _vm.value)?_c('span',{domProps:{"textContent":_vm._s(_vm.textEnabled)}}):_vm._e(),_vm._v(" "),(!_vm.label && !_vm.value)?_c('span',{domProps:{"textContent":_vm._s(_vm.textDisabled)}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"change":_vm.trigger}}),_vm._v(" "),_c('div')])}
var switches_staticRenderFns = []
var switches_esExports = { render: switches_render, staticRenderFns: switches_staticRenderFns }
/* harmony default export */ var src_switches = (switches_esExports);
// CONCATENATED MODULE: ./node_modules/vue-switches/src/switches.vue
function switches_injectStyle (ssrContext) {
  __webpack_require__("mhMr")
}
var switches_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var switches___vue_template_functional__ = false
/* styles */
var switches___vue_styles__ = switches_injectStyle
/* scopeId */
var switches___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var switches___vue_module_identifier__ = null
var switches_Component = switches_normalizeComponent(
  switches,
  src_switches,
  switches___vue_template_functional__,
  switches___vue_styles__,
  switches___vue_scopeId__,
  switches___vue_module_identifier__
)

/* harmony default export */ var vue_switches_src_switches = (switches_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageSettings.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var PageSettings = ({
	name: 'PageSettings',
	components: {
		Switches: vue_switches_src_switches
	},
	computed: {
		croppa: {
			get: function get() {
				return this.$store.getters['features/croppa'];
			},
			set: function set(value) {
				this.$store.commit('features/SET_CROPPA', value);
			}
		},
		media_store: {
			get: function get() {
				return this.$store.getters['features/media_store'];
			},
			set: function set(value) {
				this.$store.commit('features/SET_MEDIA_STORE', value);
			}
		},
		livepreview: {
			get: function get() {
				return this.$store.getters['features/livepreview'];
			},
			set: function set(value) {
				this.$store.commit('features/SET_LIVEPREVIEW', value);
			}
		},
		inlinemod: {
			get: function get() {
				return this.$store.getters['features/inlinemod'];
			},
			set: function set(value) {
				this.$store.commit('features/SET_INLINEMOD', value);
			}
		},
		auto_hide_notifications: {
			get: function get() {
				return this.$store.getters['features/auto_hide_notifications'];
			},
			set: function set(value) {
				this.$store.commit('features/SET_AUTO_HIDE_NOTIFICATIONS', value);
			}
		}

	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3952c4b5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageSettings.vue
var PageSettings_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageSettings"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_vm._v("croppa")]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('switches',{attrs:{"color":_vm.croppa ? 'green' : 'red'},model:{value:(_vm.croppa),callback:function ($$v) {_vm.croppa=$$v},expression:"croppa"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_vm._v("media_store")]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('switches',{attrs:{"color":_vm.media_store ? 'green' : 'red'},model:{value:(_vm.media_store),callback:function ($$v) {_vm.media_store=$$v},expression:"media_store"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_vm._v("livepreview")]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('switches',{attrs:{"color":_vm.livepreview ? 'green' : 'red'},model:{value:(_vm.livepreview),callback:function ($$v) {_vm.livepreview=$$v},expression:"livepreview"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_vm._v("inlinemod")]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('switches',{attrs:{"color":_vm.inlinemod ? 'green' : 'red'},model:{value:(_vm.inlinemod),callback:function ($$v) {_vm.inlinemod=$$v},expression:"inlinemod"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_vm._v("auto_hide_notifications")]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('switches',{attrs:{"color":_vm.auto_hide_notifications ? 'green' : 'red'},model:{value:(_vm.auto_hide_notifications),callback:function ($$v) {_vm.auto_hide_notifications=$$v},expression:"auto_hide_notifications"}})],1)])])])])}
var PageSettings_staticRenderFns = []
var PageSettings_esExports = { render: PageSettings_render, staticRenderFns: PageSettings_staticRenderFns }
/* harmony default export */ var pages_PageSettings = (PageSettings_esExports);
// CONCATENATED MODULE: ./src/pages/PageSettings.vue
var PageSettings_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageSettings___vue_template_functional__ = false
/* styles */
var PageSettings___vue_styles__ = null
/* scopeId */
var PageSettings___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageSettings___vue_module_identifier__ = null
var PageSettings_Component = PageSettings_normalizeComponent(
  PageSettings,
  pages_PageSettings,
  PageSettings___vue_template_functional__,
  PageSettings___vue_styles__,
  PageSettings___vue_scopeId__,
  PageSettings___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageSettings = (PageSettings_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageUser.vue

//
//
//
//
//
//
//
//
//
//
//

// Base


// Componenets

// funktion

// helper



/* harmony default export */ var PageUser = ({

	name: 'PageUser',

	data: function data() {
		return {
			newChartIDCount: 0,
			olduid: false,
			oldrole: false,
			data: {}
		};
	},


	props: {
		partnerid: {
			default: ''
		},
		uid: {
			default: ''
		},
		role: {
			default: ''
		}
	},

	computed: {
		title: helpers_user.editusertitle,
		edituser: function edituser() {
			return this.$store.getters.edituser;
		}
	},

	updated: function updated() {
		this.getUser();
	},
	created: function created() {
		this.getUser();
	},
	destroyed: function destroyed() {
		this.$store.commit('UNSET_EDITUSER');
	},


	methods: extends_default()({}, rest, {
		getUser: function getUser() {
			var self = this;
			if (this.uid == this.olduid && this.role == this.oldrole) return; // brauch kein update
			this.oldrole = this.role;
			this.olduid = this.uid;

			this.data = {};this.$store.commit('RESET_EDITUSER');
			if (this.uid == 'new') {
				var url = this.$store.getters.channel.urls.user.replace(':id:', this.role);
				this.restoptions(url, {
					partnerid: this.partnerid
				}, 'user-options').then(function (data) {
					if (data) self.$store.dispatch('SET_EDITUSER', data);
					self.data = data;
				});
			} else {
				var _url = this.$store.getters.channel.urls.user.replace(':id:', this.uid);
				this.restget(_url, 'user-get').then(function (data) {
					if (data) self.$store.dispatch('SET_EDITUSER', data);
					self.data = data;
				});
			}
		}
	})
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-553de89d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageUser.vue
var PageUser_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageUser"},[(!(_vm.$route.name.match(/-chart/) || _vm.$route.name.match(/-editor/)) && _vm.title)?_c('div',{staticClass:"row margin-bottom-medium"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"st-headline st-headline--1"},[_vm._v(_vm._s(_vm.title))])])]):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var PageUser_staticRenderFns = []
var PageUser_esExports = { render: PageUser_render, staticRenderFns: PageUser_staticRenderFns }
/* harmony default export */ var pages_PageUser = (PageUser_esExports);
// CONCATENATED MODULE: ./src/pages/PageUser.vue
function PageUser_injectStyle (ssrContext) {
  __webpack_require__("bItx")
}
var PageUser_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageUser___vue_template_functional__ = false
/* styles */
var PageUser___vue_styles__ = PageUser_injectStyle
/* scopeId */
var PageUser___vue_scopeId__ = "data-v-553de89d"
/* moduleIdentifier (server only) */
var PageUser___vue_module_identifier__ = null
var PageUser_Component = PageUser_normalizeComponent(
  PageUser,
  pages_PageUser,
  PageUser___vue_template_functional__,
  PageUser___vue_styles__,
  PageUser___vue_scopeId__,
  PageUser___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageUser = (PageUser_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageUserOverview.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var PageUserOverview = ({
	name: 'PageUserOverview',
	components: {
		UserList: src_components_UserList
	},
	computed: {
		channel: function channel() {
			return this.$store.getters.channel;
		}
	},
	props: ['role']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-115bd949","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageUserOverview.vue
var PageUserOverview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageUserOverview"},[(_vm.channel.roles[_vm.role])?_c('div',{staticClass:"row margin-bottom-xlarge"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"st-headline st-headline--1"},[_vm._v(_vm._s(_vm.$t(_vm.channel.roles[_vm.role].plural)))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row margin-bottom-xlarge margin-top-xlarge"},[_c('div',{staticClass:"col-xs-12"},[(_vm.role == 'kam')?_c('UserList',{attrs:{"role":_vm.role,"rolename":'kam',"roleleadername":'kam_leader'}}):_vm._e()],1)])])}
var PageUserOverview_staticRenderFns = []
var PageUserOverview_esExports = { render: PageUserOverview_render, staticRenderFns: PageUserOverview_staticRenderFns }
/* harmony default export */ var pages_PageUserOverview = (PageUserOverview_esExports);
// CONCATENATED MODULE: ./src/pages/PageUserOverview.vue
var PageUserOverview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageUserOverview___vue_template_functional__ = false
/* styles */
var PageUserOverview___vue_styles__ = null
/* scopeId */
var PageUserOverview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageUserOverview___vue_module_identifier__ = null
var PageUserOverview_Component = PageUserOverview_normalizeComponent(
  PageUserOverview,
  pages_PageUserOverview,
  PageUserOverview___vue_template_functional__,
  PageUserOverview___vue_styles__,
  PageUserOverview___vue_scopeId__,
  PageUserOverview___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageUserOverview = (PageUserOverview_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageChannel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PageChannel = ({
	name: 'PageChannel',
	components: {
		FieldForm: components_form_FieldForm
	},
	computed: {
		channel: function channel() {
			return this.$store.getters.channel;
		}
	},
	methods: extends_default()({}, rest, {
		save: function save(payload) {
			var self = this;
			self.restpatch('/api/v1/channel/' + this.channel.id, payload, 'channel');
		}
	})
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a004c26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageChannel.vue
var PageChannel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageChannel"},[_c('transition',{attrs:{"name":"PageGroupTranstion","enter-active-class":"animated PageGroupFadeIn"}},[_c('div',[_c('FieldForm',{attrs:{"cancelable":false,"isnew":false,"formfields":_vm.channel.page},on:{"save":_vm.save}}),_vm._v(" "),_c('router-view')],1)])],1)}
var PageChannel_staticRenderFns = []
var PageChannel_esExports = { render: PageChannel_render, staticRenderFns: PageChannel_staticRenderFns }
/* harmony default export */ var pages_PageChannel = (PageChannel_esExports);
// CONCATENATED MODULE: ./src/pages/PageChannel.vue
var PageChannel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageChannel___vue_template_functional__ = false
/* styles */
var PageChannel___vue_styles__ = null
/* scopeId */
var PageChannel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageChannel___vue_module_identifier__ = null
var PageChannel_Component = PageChannel_normalizeComponent(
  PageChannel,
  pages_PageChannel,
  PageChannel___vue_template_functional__,
  PageChannel___vue_styles__,
  PageChannel___vue_scopeId__,
  PageChannel___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageChannel = (PageChannel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageMediaStore.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var PageMediaStore = ({
	name: 'PageMediaStore',
	components: { CroppableImage: src_components_CroppableImage },
	data: function data() {
		return {
			active: false,
			assets: []
		};
	},
	mounted: function mounted() {
		this.init();
	},

	methods: extends_default()({
		deleteAsset: function deleteAsset(aid) {
			var self = this;
			self.restdelete('/api/v1/assets/' + aid, 'deleteAsset').then(function (message) {
				forEach_default()(self.assets, function (asset, index) {
					if (asset && asset.id == aid) {
						self.assets.splice(index, 1);
					}
				});
			});
		},

		chunk: chunk_default.a
	}, rest, {
		init: function init() {
			var self = this;
			self.restget('/api/v1/assets/', 'media_store').then(function (message) {
				self.assets = message;
			});
		}
	})
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a08fbd68","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageMediaStore.vue
var PageMediaStore_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageMediaStore"},_vm._l((_vm.chunk(_vm.assets, 4)),function(chunked_asset){return _c('div',{staticClass:"row"},_vm._l((chunked_asset),function(asset,index){return (chunked_asset)?_c('div',{key:index,staticClass:"col-xs-12 col-sm-6 col-md-3",on:{"click":function($event){_vm.active = asset.id}}},[(asset && asset.id)?_c('div',{staticClass:"mediabox",class:{'mediabox--active': _vm.active == asset.id, 'mediabox--not-embeded': asset.pages.length <= 0}},[(asset.height && asset.width)?_c('div',[_vm._v(_vm._s(asset.height)+"x"+_vm._s(asset.width))]):_vm._e(),_vm._v(" "),(asset.type == 'image' || asset.ext == 'jpg' || asset.ext == 'jpeg' || asset.ext == 'png' || asset.ext == 'gif' || asset.ext == 'svg')?_c('img',{attrs:{"src":asset.url,"alt":asset.basename}}):(asset.preview)?_c('img',{attrs:{"src":asset.preview,"alt":asset.basename}}):_c('strong',{staticClass:"st-headline st-headline--1"},[_vm._v(_vm._s(asset.ext))]),_vm._v(" "),_c('div',{staticClass:"mediabox__content"},[_c('small',[_c('strong',[_vm._v(_vm._s(asset.basename))]),_vm._v(" "),(asset.owner)?_c('div',[_vm._v("Owner: "+_vm._s(asset.owner.fancyname))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"st-btn st-btn--primary st-btn--small",attrs:{"download":"","href":asset.url}},[_vm._v("Download")]),_vm._v(" "),(asset.pages.length <= 0)?_c('button',{staticClass:"st-btn st-btn--highlight st-btn--small",on:{"click":function($event){_vm.deleteAsset(asset.id)}}},[_vm._v("Delete")]):_vm._e(),_vm._v(" "),_c('div',_vm._l((asset.pages),function(id){return _c('span',[_vm._v(_vm._s(id))])}))]),_vm._v(" "),(asset.variations)?_c('div',{staticClass:"row"},_vm._l((asset.variations),function(variation){return _c('div',{staticClass:"col-xs-6"},[_c('strong',[_vm._v(_vm._s(variation.basename))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(variation.height)+"x"+_vm._s(variation.width))]),_vm._v(" "),_c('img',{attrs:{"src":variation.url,"alt":variation.basename}}),_vm._v(" "),_c('a',{attrs:{"download":"","href":variation.url}},[_vm._v("Download "+_vm._s(variation.basename))])])})):_vm._e()])]):_c('div',[_c('pre',[_vm._v(_vm._s(asset))]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(index))])])]):_vm._e()}))}))}
var PageMediaStore_staticRenderFns = []
var PageMediaStore_esExports = { render: PageMediaStore_render, staticRenderFns: PageMediaStore_staticRenderFns }
/* harmony default export */ var pages_PageMediaStore = (PageMediaStore_esExports);
// CONCATENATED MODULE: ./src/pages/PageMediaStore.vue
function PageMediaStore_injectStyle (ssrContext) {
  __webpack_require__("oxJP")
}
var PageMediaStore_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageMediaStore___vue_template_functional__ = false
/* styles */
var PageMediaStore___vue_styles__ = PageMediaStore_injectStyle
/* scopeId */
var PageMediaStore___vue_scopeId__ = "data-v-a08fbd68"
/* moduleIdentifier (server only) */
var PageMediaStore___vue_module_identifier__ = null
var PageMediaStore_Component = PageMediaStore_normalizeComponent(
  PageMediaStore,
  pages_PageMediaStore,
  PageMediaStore___vue_template_functional__,
  PageMediaStore___vue_styles__,
  PageMediaStore___vue_scopeId__,
  PageMediaStore___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageMediaStore = (PageMediaStore_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PagePartnerOverview.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var PagePartnerOverview = ({
	name: 'PagePartnerOverview',
	components: {
		UserList: src_components_UserList
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c02dce8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PagePartnerOverview.vue
var PagePartnerOverview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PagePartnerOverview"},[_c('div',{staticClass:"row margin-bottom-xlarge"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"st-headline st-headline--1"},[_vm._v(_vm._s(_vm.$t('Partners')))])])]),_vm._v(" "),_c('div',{staticClass:"row margin-bottom-xlarge margin-top-xlarge"},[_c('div',{staticClass:"col-xs-12"},[_c('UserList',{attrs:{"apiurl":'/api/v1/partners',"columns":_vm._a(0,function(){return ['image', 'this', 'leader', 'managers', 'customers']}),"listname":'partners'}})],1)])])}
var PagePartnerOverview_staticRenderFns = []
var PagePartnerOverview_esExports = { render: PagePartnerOverview_render, staticRenderFns: PagePartnerOverview_staticRenderFns }
/* harmony default export */ var pages_PagePartnerOverview = (PagePartnerOverview_esExports);
// CONCATENATED MODULE: ./src/pages/PagePartnerOverview.vue
function PagePartnerOverview_injectStyle (ssrContext) {
  __webpack_require__("qO0a")
}
var PagePartnerOverview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PagePartnerOverview___vue_template_functional__ = false
/* styles */
var PagePartnerOverview___vue_styles__ = PagePartnerOverview_injectStyle
/* scopeId */
var PagePartnerOverview___vue_scopeId__ = "data-v-5c02dce8"
/* moduleIdentifier (server only) */
var PagePartnerOverview___vue_module_identifier__ = null
var PagePartnerOverview_Component = PagePartnerOverview_normalizeComponent(
  PagePartnerOverview,
  pages_PagePartnerOverview,
  PagePartnerOverview___vue_template_functional__,
  PagePartnerOverview___vue_styles__,
  PagePartnerOverview___vue_scopeId__,
  PagePartnerOverview___vue_module_identifier__
)

/* harmony default export */ var src_pages_PagePartnerOverview = (PagePartnerOverview_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UserSimpleList.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var UserSimpleList = ({
	name: 'UserSimpleList',
	components: {
		CUser: src_components_c_user
	},
	computed: {
		loading: function loading() {
			return this.$store.getters.loading;
		}
	},
	methods: {
		hasAction: function hasAction(user) {
			if (!user) return false;
			if (!user.urls) return false;
			return keys_default()(user.urls).length > 0;
		}
	},
	props: ['users', 'title', 'simpleusers', 'newlink']

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347b8444","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserSimpleList.vue
var UserSimpleList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"UserSimpleList"},[(_vm.title)?_c('h2',[_vm._v(_vm._s(_vm.$t(_vm.title)))]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"st-table st-table--full"},[_c('thead',[_c('tr',[_c('th',{staticClass:"UserSimpleList__th--image"}),_vm._v(" "),_c('th',{staticClass:"UserSimpleList__th--name"},[_vm._v(_vm._s(_vm.$t("Name")))]),_vm._v(" "),_c('th',{staticClass:"UserSimpleList__th--role"},[_vm._v(_vm._s(_vm.$t("Role")))])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.users),function(user,index){return (_vm.users && _vm.users.length > 0)?_c('tr',{class:{ 'has-action' : _vm.hasAction(user) }},[_c('td',[(user.image)?_c('img',{attrs:{"src":user.image.url,"alt":(user.fancyname ? user.fancyname : user.title),"width":"50"}}):_vm._e()]),_vm._v(" "),_c('td',[_c('c-user',{attrs:{"simple":_vm.simpleusers,"data":user,"canedit":(user.urls && Object.keys(user.urls).length > 0)}})],1),_vm._v(" "),_c('td',[(user.mainrole)?_c('div',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.$t(user.mainrole.singular))+"\n\t\t\t\t\t\t")]):(user.leader)?_c('div',[_c('c-user',{attrs:{"simple":_vm.simpleusers,"data":user.leader,"canedit":(user.leader && user.leader.urls && Object.keys(user.leader.urls).length > 0)}})],1):_c('div',[_vm._v("\n\t\t\t\t\t\t\t---\n\t\t\t\t\t\t")])])]):_vm._e()}),_vm._v(" "),(!_vm.users || _vm.users.length <= 0)?_c('tr',[_c('td',{attrs:{"colspan":"3"}},[(_vm.loading)?_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"spinner"})]):_c('div',[_vm._v(_vm._s(_vm.$t('Nothing Found')))])])]):_vm._e()],2)]),_vm._v(" "),(_vm.newlink)?_c('router-link',{staticClass:"st-btn st-btn--small st-btn--submit",attrs:{"to":_vm.newlink}},[_vm._v("New")]):_vm._e()],1)}
var UserSimpleList_staticRenderFns = []
var UserSimpleList_esExports = { render: UserSimpleList_render, staticRenderFns: UserSimpleList_staticRenderFns }
/* harmony default export */ var components_UserSimpleList = (UserSimpleList_esExports);
// CONCATENATED MODULE: ./src/components/UserSimpleList.vue
function UserSimpleList_injectStyle (ssrContext) {
  __webpack_require__("Qy75")
}
var UserSimpleList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UserSimpleList___vue_template_functional__ = false
/* styles */
var UserSimpleList___vue_styles__ = UserSimpleList_injectStyle
/* scopeId */
var UserSimpleList___vue_scopeId__ = "data-v-347b8444"
/* moduleIdentifier (server only) */
var UserSimpleList___vue_module_identifier__ = null
var UserSimpleList_Component = UserSimpleList_normalizeComponent(
  UserSimpleList,
  components_UserSimpleList,
  UserSimpleList___vue_template_functional__,
  UserSimpleList___vue_styles__,
  UserSimpleList___vue_scopeId__,
  UserSimpleList___vue_module_identifier__
)

/* harmony default export */ var src_components_UserSimpleList = (UserSimpleList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PagePartner.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var PagePartner = ({
	name: 'PagePartner',
	components: {
		FieldForm: components_form_FieldForm, UserSimpleList: src_components_UserSimpleList
	},
	props: ['id'],
	data: function data() {
		return {
			loading: false
		};
	},
	computed: {
		title: helpers_user.editusertitle,
		edituser: function edituser() {
			return this.$store.getters.edituser;
		}
	},
	created: function created() {
		this.update();
	},
	mounted: function mounted() {
		this.update();
	},
	updated: function updated() {
		if (!this.$store.getters.loadings.partner && this.$store.getters.edituser && this.$store.getters.edituser.id != this.id) {
			this.update();
		}
	},
	destroyed: function destroyed() {
		this.reset();
	},

	methods: extends_default()({}, rest, {
		reset: function reset() {
			this.$store.commit('RESET_EDITUSER');
			this.$store.commit('RESET_ACTIVE_FIELD');
			this.$store.commit('RESET_PRESENTATIONID');
			this.$store.commit('UNSET_PRESENTATION');
			this.$store.commit('UNSET_ADDABLECHARTS');
			this.$store.commit('UNSET_CHARTS');
		},
		save: function save(payload) {
			var self = this;
			if (self.id && self.id == 'new') return this.create(payload);
			self.restpatch('/api/v1/partners/' + self.id, payload, 'customer');
		},
		create: function create(payload) {
			var self = this;
			if (self.id && self.id != 'new') return this.save(payload);
			self.restput('/api/v1/partners/' + self.id, payload, 'customer');
		},

		update: function update() {
			var self = this,
			    url = '/api/v1/partners/' + this.id;

			if (self.$store.getters.loadings.partner) return;
			if (self.$store.getters.edituser && self.$store.getters.edituser.id == this.id) return;

			if (self.id == 'new') {
				self.restoptions(url, 'partner').then(function (data) {
					self.$store.dispatch('SET_EDITUSER', data);
				});
			} else {
				self.restget(url, 'partner').then(function (data) {
					self.$store.dispatch('SET_EDITUSER', data);
				});
			}
		}
	})
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b76463a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PagePartner.vue
var PagePartner_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PagePartner"},[(!(_vm.$route.name.match(/-chart/) || _vm.$route.name.match(/-editor/)) && _vm.title)?_c('div',[_c('div',{staticClass:"row margin-bottom-medium"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"st-headline st-headline--1"},[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),(_vm.edituser && _vm.edituser.fields)?_c('div',[_c('FieldForm',{attrs:{"cancelable":true,"isnew":!_vm.edituser.id || _vm.edituser.id == 'new',"formfields":_vm.edituser.fields},on:{"save":_vm.save,"create":_vm.create,"cancel":function($event){_vm.$router.push({ name: 'partner-list' })}}})],1):_vm._e(),_vm._v(" "),(_vm.edituser.managers)?_c('UserSimpleList',{attrs:{"users":_vm.edituser.managers,"title":'Partner Leader',"newlink":_vm.edituser.urls.new_leader,"simpleusers":true}}):_vm._e(),_vm._v(" "),(_vm.edituser.employers)?_c('UserSimpleList',{attrs:{"users":_vm.edituser.employers,"title":'Partner Sales',"newlink":_vm.edituser.urls.new_user,"simpleusers":true}}):_vm._e(),_vm._v(" "),(_vm.edituser.customers)?_c('UserSimpleList',{attrs:{"users":_vm.edituser.customers,"title":'Customers',"simpleusers":true}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var PagePartner_staticRenderFns = []
var PagePartner_esExports = { render: PagePartner_render, staticRenderFns: PagePartner_staticRenderFns }
/* harmony default export */ var pages_PagePartner = (PagePartner_esExports);
// CONCATENATED MODULE: ./src/pages/PagePartner.vue
function PagePartner_injectStyle (ssrContext) {
  __webpack_require__("iHtE")
}
var PagePartner_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PagePartner___vue_template_functional__ = false
/* styles */
var PagePartner___vue_styles__ = PagePartner_injectStyle
/* scopeId */
var PagePartner___vue_scopeId__ = "data-v-4b76463a"
/* moduleIdentifier (server only) */
var PagePartner___vue_module_identifier__ = null
var PagePartner_Component = PagePartner_normalizeComponent(
  PagePartner,
  pages_PagePartner,
  PagePartner___vue_template_functional__,
  PagePartner___vue_styles__,
  PagePartner___vue_scopeId__,
  PagePartner___vue_module_identifier__
)

/* harmony default export */ var src_pages_PagePartner = (PagePartner_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageCustomerOverview.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var PageCustomerOverview = ({
	name: 'PageCustomerOverview',
	components: {
		UserList: src_components_UserList
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fd84d1f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageCustomerOverview.vue
var PageCustomerOverview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageCustomerOverview"},[_c('div',{staticClass:"row margin-bottom-xlarge"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"st-headline st-headline--1"},[_vm._v(_vm._s(_vm.$t('Customers')))])])]),_vm._v(" "),_c('div',{staticClass:"row margin-bottom-xlarge margin-top-xlarge"},[_c('div',{staticClass:"col-xs-12"},[_c('UserList',{attrs:{"apiurl":'/api/v1/customers',"columns":_vm._a(0,function(){return ['image', 'customernumber', 'this', 'leader', 'partners']}),"listname":'customers'}})],1)])])}
var PageCustomerOverview_staticRenderFns = []
var PageCustomerOverview_esExports = { render: PageCustomerOverview_render, staticRenderFns: PageCustomerOverview_staticRenderFns }
/* harmony default export */ var pages_PageCustomerOverview = (PageCustomerOverview_esExports);
// CONCATENATED MODULE: ./src/pages/PageCustomerOverview.vue
function PageCustomerOverview_injectStyle (ssrContext) {
  __webpack_require__("TcZC")
}
var PageCustomerOverview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageCustomerOverview___vue_template_functional__ = false
/* styles */
var PageCustomerOverview___vue_styles__ = PageCustomerOverview_injectStyle
/* scopeId */
var PageCustomerOverview___vue_scopeId__ = "data-v-7fd84d1f"
/* moduleIdentifier (server only) */
var PageCustomerOverview___vue_module_identifier__ = null
var PageCustomerOverview_Component = PageCustomerOverview_normalizeComponent(
  PageCustomerOverview,
  pages_PageCustomerOverview,
  PageCustomerOverview___vue_template_functional__,
  PageCustomerOverview___vue_styles__,
  PageCustomerOverview___vue_scopeId__,
  PageCustomerOverview___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageCustomerOverview = (PageCustomerOverview_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageCustomer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var PageCustomer = ({
	name: 'PageCustomer',
	components: {
		FieldForm: components_form_FieldForm, UserSimpleList: src_components_UserSimpleList
	},
	props: ['id'],
	data: function data() {
		return {
			loading: false
		};
	},
	computed: {
		title: helpers_user.editusertitle,
		edituser: function edituser() {
			return this.$store.getters.edituser;
		}
	},
	created: function created() {
		this.update();
	},
	mounted: function mounted() {
		this.update();
	},
	updated: function updated() {
		if (!this.$store.getters.loadings.customer && this.$store.getters.edituser && this.$store.getters.edituser.id != this.id) {
			this.update();
		}
	},
	destroyed: function destroyed() {
		this.reset();
	},

	methods: extends_default()({}, rest, {
		reset: function reset() {
			this.$store.commit('RESET_EDITUSER');
			this.$store.commit('RESET_ACTIVE_FIELD');
			this.$store.commit('RESET_PRESENTATIONID');
			this.$store.commit('UNSET_PRESENTATION');
			this.$store.commit('UNSET_ADDABLECHARTS');
			this.$store.commit('UNSET_CHARTS');
		},
		save: function save(payload) {
			var self = this;
			if (self.id && self.id == 'new') return this.create(payload);
			self.restpatch('/api/v1/customers/' + self.id, payload, 'customer');
		},
		create: function create(payload) {
			var self = this;
			if (self.id && self.id != 'new') return this.save(payload);
			self.restput('/api/v1/customers/' + self.id, payload, 'customer');
		},
		update: function update() {
			var self = this,
			    url = '/api/v1/customers/' + self.id;

			if (self.$store.getters.loadings.customer) return;
			if (self.$store.getters.edituser && self.$store.getters.edituser.id == this.id) return;

			if (self.id == 'new') {
				self.restoptions(url, 'customer').then(function (data) {
					self.$store.dispatch('SET_EDITUSER', data);
				});
			} else {
				self.restget(url, 'customer').then(function (data) {
					self.$store.dispatch('SET_EDITUSER', data);
				});
			}
		}
	})
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-168db338","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageCustomer.vue
var PageCustomer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageCustomer"},[(!(_vm.$route.name.match(/-chart/) || _vm.$route.name.match(/-editor/)))?_c('div',[(_vm.title)?_c('div',{staticClass:"row margin-bottom-medium"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"st-headline st-headline--1"},[_vm._v(_vm._s(_vm.title))])])]):_vm._e(),_vm._v(" "),(_vm.edituser && _vm.edituser.fields)?_c('div',[_c('FieldForm',{attrs:{"cancelable":true,"isnew":!_vm.edituser.id || _vm.edituser.id == 'new',"formfields":_vm.edituser.fields},on:{"save":_vm.save,"create":_vm.create,"cancel":function($event){_vm.$router.push({ name: 'customer-list' })}}})],1):_vm._e(),_vm._v(" "),(_vm.edituser.partners)?_c('UserSimpleList',{attrs:{"users":_vm.edituser.partners,"title":'Partners',"simpleusers":true}}):_vm._e(),_vm._v(" "),(_vm.edituser.involved)?_c('UserSimpleList',{attrs:{"users":_vm.edituser.involved,"title":'Involved',"simpleusers":true}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var PageCustomer_staticRenderFns = []
var PageCustomer_esExports = { render: PageCustomer_render, staticRenderFns: PageCustomer_staticRenderFns }
/* harmony default export */ var pages_PageCustomer = (PageCustomer_esExports);
// CONCATENATED MODULE: ./src/pages/PageCustomer.vue
function PageCustomer_injectStyle (ssrContext) {
  __webpack_require__("Izla")
}
var PageCustomer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageCustomer___vue_template_functional__ = false
/* styles */
var PageCustomer___vue_styles__ = PageCustomer_injectStyle
/* scopeId */
var PageCustomer___vue_scopeId__ = "data-v-168db338"
/* moduleIdentifier (server only) */
var PageCustomer___vue_module_identifier__ = null
var PageCustomer_Component = PageCustomer_normalizeComponent(
  PageCustomer,
  pages_PageCustomer,
  PageCustomer___vue_template_functional__,
  PageCustomer___vue_styles__,
  PageCustomer___vue_scopeId__,
  PageCustomer___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageCustomer = (PageCustomer_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js





































vue_esm["default"].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
	mode: 'history',
	routes: [{
		path: '404',
		from: '*',
		component: src_pages_p_404
	}, {
		path: '/panel',
		component: src_pages_p_panel,
		children: [{
			path: '404',
			component: src_pages_p_404
		}, {
			path: 'channel',
			component: src_pages_PageChannel
		}, {
			name: 'media_store',
			path: 'media_store',
			component: src_pages_PageMediaStore
		}, {
			name: 'test',
			path: 'test',
			component: src_pages_PageTest
		}, {
			name: 'settings',
			path: 'settings',
			component: src_pages_PageSettings
		}, {
			path: '',
			alias: 'home',
			component: src_pages_PageDashboard
		}, {
			name: 'styleguide',
			path: 'styleguide',
			component: src_pages_p_styleguide
		}, {
			name: 'translations',
			path: 'translations',
			component: src_pages_p_translations
		}, {
			path: 'partners',
			component: src_pages_PageGroupReset,
			canReuse: false,
			children: [{
				name: 'partner-list',
				path: '',
				component: src_pages_PagePartnerOverview
			}, {
				path: 'users/:uid',
				component: src_pages_PageUser,
				props: function props(route) {
					var p = route.params;
					p.role = 'partner';
					return p;
				},
				children: [{
					name: 'partner-user',
					path: '',
					component: src_pages_p_userform
				}]
			}, {
				path: ':id',
				component: src_pages_PageGroup,
				props: true,
				children: [{
					name: 'partner',
					path: '',
					component: src_pages_PagePartner,
					props: true
				}, {
					path: 'users',
					component: src_pages_PageGroup,
					children: [{
						name: 'partner-user-list',
						path: '',
						component: src_pages_PageUserOverview,
						props: function props(route) {
							var p = route.params;
							if (p.id) p.partnerid = p.id;
							p.role = 'partner';
							return p;
						}
					}, {
						name: 'partner-user-leader-list',
						path: 'leaders',
						component: src_pages_PageUserOverview,
						props: function props(route) {
							var p = route.params;
							p.role = 'partner_leader';
							if (p.id) p.partnerid = p.id;
							return p;
						}
					}, {
						path: ':uid',
						component: src_pages_PageUser,
						props: function props(route) {
							var p = route.params;
							if (p.id) p.partnerid = p.id;
							p.role = 'partner';
							return p;
						},
						children: [{
							name: 'partner-user-child',
							path: '',
							component: src_pages_p_userform
						}]
					}, {
						path: 'leaders/:uid',
						component: src_pages_PageUser,
						props: function props(route) {
							var p = route.params;
							if (p.id) p.partnerid = p.id;
							p.role = 'partner_leader';
							return p;
						},
						children: [{
							name: 'partner-leader-user',
							path: '',
							component: src_pages_p_userform
						}]
					}]
				}, {
					name: 'partner-editor',
					path: 'editor',
					component: src_pages_p_editor,
					children: [{
						name: 'partner-chart',
						path: ':chartid',
						props: true,
						component: components_p_editor_c_editor_charts
					}]
				}]
			}]
		}, {
			path: 'customers',
			component: src_pages_PageGroupReset,
			canReuse: false,
			children: [{
				name: 'customer-list',
				path: '',
				component: src_pages_PageCustomerOverview
			}, {
				name: 'customer',
				path: ':id',
				component: src_pages_PageCustomer,
				props: true,
				children: [{
					name: 'customer-editor',
					path: 'editor',
					component: src_pages_p_editor,
					children: [{
						name: 'customer-chart',
						path: ':chartid',
						props: true,
						component: components_p_editor_c_editor_charts
					}]
				}]
			}]
		}, {
			path: 'users',
			component: src_pages_PageGroupReset,
			canReuse: false,
			children: [{
				name: 'user-list',
				path: ':role',
				component: src_pages_PageUserOverview,
				props: true
			}, {
				name: 'user-permissions',
				path: ':role/permissions',
				component: src_pages_p_role_permission,
				props: true
			}, {
				path: ':role/:uid',
				component: src_pages_PageUser,
				props: true,
				children: [{
					name: 'user-edit',
					path: '',
					component: src_pages_p_userform
				}]
			}]
		}, {
			path: 'master-slides',
			component: src_pages_p_editor,
			props: {
				master: true
			},
			children: [{
				name: 'master-chart',
				path: ':chartid',
				props: true,
				component: components_p_editor_c_editor_charts
			}]
		}, {
			path: 'presentation',
			component: src_pages_PageGroupReset,
			canReuse: false,
			children: [{
				name: 'presentation-list',
				path: '',
				component: src_pages_p_presentations,
				canReuse: false
			}, {
				name: 'presentation-new',
				path: 'new',
				component: src_pages_PagePresentationSettings,
				canReuse: false
			}, {
				name: 'presentation-settings',
				path: 'settings/:pid',
				component: src_pages_PagePresentationSettings,
				canReuse: false,
				props: true
			}, {
				name: 'editor',
				path: 'edit/:pid',
				props: true,
				component: src_pages_p_editor,
				children: [{
					name: 'presentation-chart',
					path: ':chartid',
					props: true,
					component: components_p_editor_c_editor_charts
				}]
			}]
		}, {
			path: '*',
			redirect: '404'
		}]
	}]
}));
// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// EXTERNAL MODULE: ./node_modules/vue-filter/dist/vue-filter.js
var vue_filter = __webpack_require__("CjbC");
var vue_filter_default = /*#__PURE__*/__webpack_require__.n(vue_filter);

// EXTERNAL MODULE: ./node_modules/vuedraggable/dist/vuedraggable.js
var vuedraggable = __webpack_require__("DAYN");
var vuedraggable_default = /*#__PURE__*/__webpack_require__.n(vuedraggable);

// EXTERNAL MODULE: ./node_modules/vue-trumbowyg/dist/vue-trumbowyg.js
var vue_trumbowyg = __webpack_require__("Up6o");
var vue_trumbowyg_default = /*#__PURE__*/__webpack_require__.n(vue_trumbowyg);

// EXTERNAL MODULE: ./node_modules/trumbowyg/dist/plugins/cleanpaste/trumbowyg.cleanpaste.js
var trumbowyg_cleanpaste = __webpack_require__("ROoi");
var trumbowyg_cleanpaste_default = /*#__PURE__*/__webpack_require__.n(trumbowyg_cleanpaste);

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// EXTERNAL MODULE: ./node_modules/trumbowyg/dist/ui/trumbowyg.css
var trumbowyg = __webpack_require__("TGUE");
var trumbowyg_default = /*#__PURE__*/__webpack_require__.n(trumbowyg);

// EXTERNAL MODULE: ./node_modules/vue-croppa/dist/vue-croppa.js
var vue_croppa = __webpack_require__("86jz");
var vue_croppa_default = /*#__PURE__*/__webpack_require__.n(vue_croppa);

// EXTERNAL MODULE: ./node_modules/vue-croppa/dist/vue-croppa.css
var dist_vue_croppa = __webpack_require__("toYN");
var dist_vue_croppa_default = /*#__PURE__*/__webpack_require__.n(dist_vue_croppa);

// EXTERNAL MODULE: ./node_modules/vue-notification/dist/index.js
var dist = __webpack_require__("CLX7");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ./src/VueApi.js

// based on https://github.com/kimuraz/vue-rest/blob/dev/index.js




var VueApi = {
	install: function install(Vue, options) {
		if (Vue.vueApi) return;
		Vue.vueApi = true;

		var api = null;
		if (options && options.axiosOptions) {
			api = axios_default.a.create(options.axiosOptions);

			if (options.axiosOptions.localStorageAuthorization) {

				var localStorageAuthorization = options.axiosOptions.localStorageAuthorization;

				api.interceptors.request.use(function (config) {
					var token = localStorage.getItem(localStorageAuthorization.tokenItem);
					var prefix = localStorageAuthorization.prefix;

					if (!localStorageAuthorization.tokenItem || !prefix) {
						console.error('[ERR - VueApi]: Miss configuration at localStorageAuthorization.');
					}

					if (token) {
						assign_default()(config.headers, { Authorization: prefix + ' ' + token });
					}

					return config;
				});
			}
		}

		if (!api) {
			api = axios_default.a.create();
		}

		Vue.api = api;
		Vue.prototype.$api = api;
	}
};

/* harmony default export */ var src_VueApi = (VueApi);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/v-notice.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var v_notice = ({
	name: 'v-notice',
	props: {
		data: {
			type: Object,
			default: function _default() {
				return {
					text: '',
					type: 'notice',
					removeAble: true
				};
			}
		}
	},
	data: function data() {
		return {
			count: 0,
			interval: false
		};
	},
	mounted: function mounted() {
		var self = this;
		if (this.$store.getters['features/auto_hide_notifications'] || !this.interval && this.data.autoRemove) {
			this.count = 10; //reset
			this.interval = window.setInterval(function () {
				self.count -= 1;
				if (self.count === 0) {
					self.close(false, self.data.id);
					clearInterval(self.interval);
				}
			}, 1000);
		}
	},

	methods: {
		close: function close() {
			this.$store.commit('REMOVE_NOTICE', this.data.id);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e7f806a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v-notice.vue
var v_notice_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"v-notice","enter-active-class":"animated fadeInDown","leave-active-class":"animated fadeOutUp"}},[_c('div',{staticClass:"v-notice st-notice",class:'st-notice--'+_vm.data.type},[_c('div',{staticClass:"user-content-wrapper"},[(_vm.data.type == 'system' || _vm.data.type == 'permission')?_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.text)}}):_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.data.text))}}),_vm._v(" "),(_vm.data.removeAble)?_c('button',{staticClass:"st-btn st-btn--right st-btn--sm",attrs:{"data-id":_vm.data.id},on:{"click":_vm.close}},[_c('span',[_vm._v("X")])]):_vm._e()])])])}
var v_notice_staticRenderFns = []
var v_notice_esExports = { render: v_notice_render, staticRenderFns: v_notice_staticRenderFns }
/* harmony default export */ var components_v_notice = (v_notice_esExports);
// CONCATENATED MODULE: ./src/components/v-notice.vue
function v_notice_injectStyle (ssrContext) {
  __webpack_require__("kB4g")
}
var v_notice_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var v_notice___vue_template_functional__ = false
/* styles */
var v_notice___vue_styles__ = v_notice_injectStyle
/* scopeId */
var v_notice___vue_scopeId__ = "data-v-0e7f806a"
/* moduleIdentifier (server only) */
var v_notice___vue_module_identifier__ = null
var v_notice_Component = v_notice_normalizeComponent(
  v_notice,
  components_v_notice,
  v_notice___vue_template_functional__,
  v_notice___vue_styles__,
  v_notice___vue_scopeId__,
  v_notice___vue_module_identifier__
)

/* harmony default export */ var src_components_v_notice = (v_notice_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/v-tooldown.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var v_tooldown = ({
	name: 'v-tooldown',
	data: function data() {
		return {
			x: 0,
			y: 0,
			tooldownclass: '',
			escEvent: false,
			saveEvent: false
		};
	},

	props: {
		el: {
			default: function _default() {
				return document.createElement('div');
			}
		},
		type: {
			type: String,
			default: 'submit'
		},
		options: {
			type: Boolean,
			default: true
		},
		yesno: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		positiveBtnClass: function positiveBtnClass() {
			var classname = 'st-btn--' + this.type;

			return [classname, {
				'st-btn--loading': this.loading
			}];
		},
		style: function style() {
			return 'top: ' + this.y + 'px; left: ' + this.x + 'px;';

			/*
   if (!this.el || typeof this.el.getBoundingClientRect !== 'function') {
   	return '';
   }
   	const rect = this.el.getBoundingClientRect(),
   	  top 	= (Math.round(rect.top) + Math.round(rect.height) + 20),
   	  left 	= (( rect.left + (rect.width / 2) ) - 14);
   	return 'top: ' + top +'px; left: '+ left +'px;';
   */
		}
	},
	mounted: function mounted() {
		var mouseposition = this.$store.getters.mouseposition;
		if (this.el && (this.el.classList.contains('st-table-action__link') || this.el.classList.contains('st-link'))) {
			var bodyRect = document.documentElement.getBoundingClientRect(),
			    $elemRect = this.$el.getBoundingClientRect(),
			    elemRect = this.el.getBoundingClientRect();

			this.y = elemRect.top - (bodyRect.top < 0 ? 15 : bodyRect.top + 10) + elemRect.height;
			this.x = elemRect.left - bodyRect.left + (elemRect.width / 2 - 10);
		} else {
			this.y = mouseposition.y + 25;
			this.x = mouseposition.x - 7;
		}

		this.setTooldownCSSClasses();

		// this.escEvent = evn.subscribe('esc', this.$emit('cancel'));
		// this.saveEvent = evn.subscribe('save', this.$emit('ok'));
	},
	destroyed: function destroyed() {
		// if(this.escEvent) this.escEvent.remove();
		// if(this.saveEvent) this.saveEvent.remove();
	},

	methods: {
		setTooldownCSSClasses: function setTooldownCSSClasses() {
			this.tooldownclass = '';
			if (!this.$el) return;

			var rect = this.$el.getBoundingClientRect(),
			    left = rect.left + rect.width / 2 - 14;

			var right = true,
			    bottom = true;

			if (this.x + rect.width + 50 > window.innerWidth) {
				right = false;
			}

			if (this.y + rect.height + 50 > window.innerHeight) {
				bottom = false;
			}

			if (!right && !bottom) {

				this.tooldownclass = ' v-tooldown--left-top';
			} else if (!right && bottom) {

				this.tooldownclass = ' v-tooldown--left-bottom';
			} else if (right && !bottom) {

				this.tooldownclass = ' v-tooldown--right-top';
			} else if (right && bottom) {

				this.tooldownclass = ' v-tooldown--right-bottom';
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a0566f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v-tooldown.vue
var v_tooldown_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog',{ref:"dialog",staticClass:"v-tooldown",class:_vm.tooldownclass,style:(_vm.style),attrs:{"tabindex":"0","open":""},on:{"keypress":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }_vm.$emit('cancel')}}},[_c('div',{staticClass:"v-tooldown__content"},[_c('div',{staticClass:"margin-bottom-medium"},[_c('strong',{staticClass:"st-headline st-headline--2"},[_vm._t("title",[_vm._v("Titel")])],2),_vm._v(" "),_vm._t("message",[_vm._v("Hier könnte Ihre Meldung stehen!")])],2),_vm._v(" "),(_vm.options)?_c('div',[(_vm.yesno)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6 text-right"},[_c('button',{staticClass:"st-btn st-btn--small st-btn--cancel",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.$emit('cancel')}}},[_vm._t("negative",[_vm._v(_vm._s(_vm.$t('Cancel')))])],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('button',{staticClass:"st-btn st-btn--small",class:_vm.positiveBtnClass,on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.$emit('ok')}}},[_vm._t("positive",[_vm._v(_vm._s(_vm.$t('Confirm')))])],2)])])]):_vm._e(),_vm._v(" "),(!_vm.yesno)?_c('div',[_c('div',{staticClass:"text-right"},[_c('a',{staticClass:"st-btn st-btn--small st-btn--close",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.$emit('cancel')}}},[_vm._t("negative",[_vm._v(_vm._s(_vm.$t('Close')))])],2)])]):_vm._e()]):_vm._e()])])}
var v_tooldown_staticRenderFns = []
var v_tooldown_esExports = { render: v_tooldown_render, staticRenderFns: v_tooldown_staticRenderFns }
/* harmony default export */ var components_v_tooldown = (v_tooldown_esExports);
// CONCATENATED MODULE: ./src/components/v-tooldown.vue
function v_tooldown_injectStyle (ssrContext) {
  __webpack_require__("Vol5")
}
var v_tooldown_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var v_tooldown___vue_template_functional__ = false
/* styles */
var v_tooldown___vue_styles__ = v_tooldown_injectStyle
/* scopeId */
var v_tooldown___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var v_tooldown___vue_module_identifier__ = null
var v_tooldown_Component = v_tooldown_normalizeComponent(
  v_tooldown,
  components_v_tooldown,
  v_tooldown___vue_template_functional__,
  v_tooldown___vue_styles__,
  v_tooldown___vue_scopeId__,
  v_tooldown___vue_module_identifier__
)

/* harmony default export */ var src_components_v_tooldown = (v_tooldown_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/v-toolinline.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var v_toolinline = ({
	name: 'v-toolinline',
	props: {
		type: {
			type: String,
			default: 'submit'
		},
		options: {
			type: Boolean,
			default: true
		},
		yesno: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		positiveBtnClass: function positiveBtnClass() {
			var classname = 'st-btn--' + this.type;

			return [classname, {
				'st-btn--loading': this.loading
			}];
		},
		style: function style() {
			return 'top: ' + this.y + 'px; left: ' + this.x + 'px;';
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5df833d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v-toolinline.vue
var v_toolinline_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dialog",staticClass:"v-toolinline",style:(_vm.style),attrs:{"tabindex":"0"},on:{"click":function($event){$event.preventDefault();},"keypress":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }_vm.$emit('cancel')}}},[_c('div',{staticClass:"v-toolinline__content"},[_c('div',{staticClass:"margin-bottom-medium"},[_vm._t("message",[_vm._v("Hier könnte Ihre Meldung stehen!")])],2),_vm._v(" "),(_vm.options)?_c('div',{staticClass:"v-toolinline__options"},[(_vm.yesno)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('button',{staticClass:"st-btn st-btn--small",class:_vm.positiveBtnClass,on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.$emit('ok')}}},[_vm._t("positive",[_vm._v(_vm._s(_vm.$t('Confirm')))])],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 text-right"},[_c('button',{staticClass:"st-btn st-btn--small st-btn--cancel",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.$emit('cancel')}}},[_vm._t("negative",[_vm._v(_vm._s(_vm.$t('Cancel')))])],2)])])]):_vm._e(),_vm._v(" "),(!_vm.yesno)?_c('div',[_c('div',{staticClass:"text-right"},[_c('a',{staticClass:"st-btn st-btn--small st-btn--close",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.$emit('cancel')}}},[_vm._t("negative",[_vm._v(_vm._s(_vm.$t('Close')))])],2)])]):_vm._e()]):_vm._e()])])}
var v_toolinline_staticRenderFns = []
var v_toolinline_esExports = { render: v_toolinline_render, staticRenderFns: v_toolinline_staticRenderFns }
/* harmony default export */ var components_v_toolinline = (v_toolinline_esExports);
// CONCATENATED MODULE: ./src/components/v-toolinline.vue
function v_toolinline_injectStyle (ssrContext) {
  __webpack_require__("tgUS")
}
var v_toolinline_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var v_toolinline___vue_template_functional__ = false
/* styles */
var v_toolinline___vue_styles__ = v_toolinline_injectStyle
/* scopeId */
var v_toolinline___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var v_toolinline___vue_module_identifier__ = null
var v_toolinline_Component = v_toolinline_normalizeComponent(
  v_toolinline,
  components_v_toolinline,
  v_toolinline___vue_template_functional__,
  v_toolinline___vue_styles__,
  v_toolinline___vue_scopeId__,
  v_toolinline___vue_module_identifier__
)

/* harmony default export */ var src_components_v_toolinline = (v_toolinline_Component.exports);

// CONCATENATED MODULE: ./src/helpers/table.js
/* harmony default export */ var table = ({
	isLast: function isLast(arr, obj) {
		// sdfkonadfgkjbnak
		return arr.length - 1 == arr.indexOf(obj);
	},
	moment: function moment(timestamp) {
		var date = new Date(timestamp * 1000);
		return date.getDate() + '.' + date.getMonth() + '.' + date.getFullYear();
	},
	toggleMy: function toggleMy() {
		this.filters.my = !this.filters.my;
		this.$router.push({ query: {
				my: this.filters.my
			} });
		// this.update();
	},
	updateSearch: function updateSearch() {
		var self = this;
		if (this.searchtext.length > 2) {
			this.filters.q = this.searchtext;

			if (this.timeoutId) window.clearTimeout(this.timeoutId);
			this.timeoutId = window.setTimeout(function () {
				self.update();
			}, 500);
		} else if (this.filters.q.length > 0) {
			this.filters.q = '';

			if (this.timeoutId) window.clearTimeout(this.timeoutId);
			this.timeoutId = window.setTimeout(function () {
				self.update();
			}, 500);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/v-presentationtable.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var v_presentationtable = ({
	name: 'v-presentationtable',
	components: {
		Selectize: vue2_selectize_default.a,
		CPresentation: src_components_c_presentation,
		CUser: src_components_c_user
	},
	data: function data() {
		var channel = this.$store.getters.channel,
		    role = channel.roles[this.rolename];

		return {
			channel: channel,
			role: role,

			involved: {
				partners: [],
				customers: []
			},
			partners: false,
			customers: false,

			canCreate: false,

			loading: false,
			presentations: [],
			searchtext: '',
			pages: 0,
			filters: {
				q: '',
				page: 1,
				my: false,
				roles: [],
				involved: []
			}
		};
	},
	created: function created() {
		this.filters = assign_default()({}, this.filters, this.$router.history.current.query);

		var self = this;
		keys_default()(this.filters).forEach(function (i) {
			if (self.filters[i] === 'false') self.filters[i] = false;
			if (self.filters[i] === 'true') self.filters[i] = true;
			if (parseInt(self.filters[i]) > 0) self.filters[i] = parseInt(self.filters[i]);
		});

		this.update();
	},
	watch: {
		'$route': 'update'
	},
	methods: extends_default()({}, table, {

		resetFilters: function resetFilters() {
			this.filters.progress_status = undefined;
			this.filters.my = false;
			this.update();
		},

		update: function update() {
			var self = this,
			    url = this.$store.getters.channel.urls.presentations;
			//
			if (self.loading) return;
			self.loading = true;
			self.$store.commit('START_LOADING', 'presentations');

			self.filters.involved = [];
			keys_default()(self.involved).forEach(function (key) {
				var item = self.involved[key];
				item.forEach(function (id) {
					self.filters.involved.push(id);
				});
			});

			$.getJSON(url, self.filters, function (data) {
				self.presentations = data.message;
				self.$store.commit('END_LOADING', 'presentations');

				if (data.notices) {
					data.notices.forEach(function (notice) {
						self.$store.commit('ADD_NOTICE', notice);
					});
				}

				if (data.urls) {
					if (data.urls.new) {
						self.canCreate = data.urls.new;
					}
				} else {
					self.canCreate = false;
				}

				if (data.total) {
					if (typeof self.filters.limit !== 'undefined' && data.limit !== self.filters.limit) {
						self.filters.limit = data.limit;
					}

					var filters = self.filters;
					try {
						// self.$router.push({ query: JSON.parse(JSON.stringify(filters)) });
					} catch (e) {
						console.error(e);
					}

					var pages = Math.floor(data.total / (data.limit == 0 ? 10 : data.limit));
					if (pages <= 0) pages = 1;
					self.pages = pages;
				}
				self.loading = false;
			});
		},

		isSomeoneEditing: function isSomeoneEditing(id) {
			var presentation_edit_status = this.$store.getters['socket/getFromLive']('presentation_edit_status');
			return typeof presentation_edit_status[id] !== 'undefined';
		},


		changePageByNumber: function changePageByNumber(numb) {
			console.log(numb);
			console.log(this.filters.page);
			this.filters.page = numb;
			console.log(this.filters.page);
			this.update();
		},

		changePage: function changePage(add) {
			this.filters.page = this.filters.page + add;
			this.update();
		},

		toggleProgressStatus: function toggleProgressStatus(name) {
			this.filters.progress_status = name;
			this.update();
		},

		copyLink: function copyLink(ev) {
			ev.preventDefault();
			var href = ev.target.getAttribute('href');
			general.copyToClipboard(href);
			self.$emit('copyedLink', href);
		},

		iscurrentrole: helpers_user.iscurrentrole,
		iscurrentsubrole: helpers_user.iscurrentsubrole,
		issubrole: helpers_user.issubrole,
		isleaderrole: helpers_user.isleaderrole,
		getroleusers: helpers_user.getroleusers,
		hasfitlers: helpers_user.hasfitlers
	})
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0541c55a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v-presentationtable.vue
var v_presentationtable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-table v-presentationtable",class:{'v-table--loading':_vm.loading}},[_c('div',{staticClass:"row margin-bottom-medium"},[_c('div',{staticClass:"col col-xs-12 col-sm-10"},[_c('div',{staticClass:"inline-block"},[_c('h1',{staticClass:"st-headline st-headline--1"},[_vm._v(_vm._s(_vm.$t('Presentations')))])])]),_vm._v(" "),_c('div',{staticClass:"col col-xs-12 col-sm-2 text-sm-right"},[(_vm.canCreate)?_c('a',{staticClass:"st-btn st-btn--sm",attrs:{"href":_vm.canCreate}},[_c('i',{staticClass:"fa fa--plus"}),_vm._v(" "+_vm._s(_vm.$t("Create")))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row margin-bottom-medium"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{staticClass:"st-filters"},[_c('div',{staticClass:"inline"},[_c('div',{staticClass:"inline"},[_c('button',{staticClass:"st-filters__link",class:{'st-filters__link--active': !_vm.hasfitlers() },on:{"click":_vm.resetFilters}},[_vm._v(_vm._s(_vm.$t('All')))]),_c('span',[_vm._v(" | ")])]),_vm._v(" "),_c('div',{staticClass:"inline"},[_c('button',{staticClass:"st-filters__link",class:{ 'st-filters__link--active': _vm.filters.my },on:{"click":function($event){_vm.toggleMy()}}},[_vm._v(_vm._s(_vm.$t('My')))]),_c('span',[_vm._v(" | ")])]),_vm._v(" "),_c('div',{staticClass:"inline"},[_c('button',{staticClass:"st-filters__link",class:{ 'st-filters__link--active': _vm.filters.progress_status == 'final' },on:{"click":function($event){_vm.toggleProgressStatus('final')}}},[_vm._v(_vm._s(_vm.$t('Final')))]),_c('span',[_vm._v(" | ")])]),_vm._v(" "),_c('div',{staticClass:"inline"},[_c('button',{staticClass:"st-filters__link",class:{ 'st-filters__link--active': _vm.filters.progress_status == 'draft' },on:{"click":function($event){_vm.toggleProgressStatus('draft')}}},[_vm._v(_vm._s(_vm.$t('Draft')))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 text-sm-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchtext),expression:"searchtext"}],staticClass:"st-input st-input--sm st-input--text st-input--search",attrs:{"disabled":_vm.loading,"placeholder":_vm.$t('Search ...'),"type":"text"},domProps:{"value":(_vm.searchtext)},on:{"keyup":_vm.updateSearch,"input":function($event){if($event.target.composing){ return; }_vm.searchtext=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"inline-block"},[_c('v-paging',{attrs:{"current_page":parseInt(_vm.filters.page),"min_page":1,"max_page":_vm.pages},on:{"pagechange":_vm.changePageByNumber,"prev":_vm.changePage,"next":_vm.changePage}})],1)])]),_vm._v(" "),(_vm.presentations)?_c('table',{staticClass:"st-table st-table--full"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('Title')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('Appointment')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('Customers')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t(_vm.channel.roles.partner.plural)))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t(_vm.channel.roles.kam.plural)))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('Created by')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('Last edit')))])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.presentations),function(presentation,index){return _c('tr',{class:{ 'has-action' : presentation.urls && Object.keys(presentation.urls).length > 0, 'tr-is-editing' : _vm.isSomeoneEditing(presentation.id) }},[_c('td',[_c('c-presentation',{attrs:{"data":presentation},on:{"delete":function($event){_vm.presentations.splice(index, 1);}}})],1),_vm._v(" "),_c('td',[_vm._v("\n                        "+_vm._s(presentation.appointment)+"\n                    ")]),_vm._v(" "),_c('td',[(presentation.customer)?_c('div',[(presentation.customer)?_c('c-user',{attrs:{"simple":true,"data":presentation.customer}}):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('td',[(presentation.partner)?_c('div',[(presentation.partner)?_c('c-user',{attrs:{"simple":true,"data":presentation.partner}}):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('td',[(presentation.involved)?_c('div',_vm._l((presentation.involved),function(kam){return _c('div',[(kam && kam.mainrole && kam.mainrole.name == 'kam')?_c('c-user',{attrs:{"simple":true,"data":kam}}):_vm._e()],1)})):_vm._e()]),_vm._v(" "),_c('td',[(presentation.createdUser)?_c('c-user',{attrs:{"simple":true,"data":presentation.createdUser,"canedit":(presentation.createdUser.urls && Object.keys(presentation.createdUser.urls).length > 0)}}):_vm._e()],1),_vm._v(" "),_c('td',[_vm._v("\n                        "+_vm._s(_vm.moment(presentation.modified))+"\n                    ")])])}),_vm._v(" "),(_vm.presentations.length <= 0)?_c('tr',[_c('td',{attrs:{"colspan":Object.keys(_vm.channel.roles).length + 2}},[_vm._v(_vm._s(_vm.$t('Nothing Found')))])]):_vm._e()],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row margin-top-medium"},[_c('div',{staticClass:"col-xs-12 col-sm-6"}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 text-sm-right"},[_c('v-paging',{attrs:{"current_page":parseInt(_vm.filters.page),"min_page":1,"max_page":_vm.pages},on:{"pagechange":_vm.changePageByNumber,"prev":_vm.changePage,"next":_vm.changePage}})],1)])])}
var v_presentationtable_staticRenderFns = []
var v_presentationtable_esExports = { render: v_presentationtable_render, staticRenderFns: v_presentationtable_staticRenderFns }
/* harmony default export */ var components_v_presentationtable = (v_presentationtable_esExports);
// CONCATENATED MODULE: ./src/components/v-presentationtable.vue
function v_presentationtable_injectStyle (ssrContext) {
  __webpack_require__("JCVd")
}
var v_presentationtable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var v_presentationtable___vue_template_functional__ = false
/* styles */
var v_presentationtable___vue_styles__ = v_presentationtable_injectStyle
/* scopeId */
var v_presentationtable___vue_scopeId__ = "data-v-0541c55a"
/* moduleIdentifier (server only) */
var v_presentationtable___vue_module_identifier__ = null
var v_presentationtable_Component = v_presentationtable_normalizeComponent(
  v_presentationtable,
  components_v_presentationtable,
  v_presentationtable___vue_template_functional__,
  v_presentationtable___vue_styles__,
  v_presentationtable___vue_scopeId__,
  v_presentationtable___vue_module_identifier__
)

/* harmony default export */ var src_components_v_presentationtable = (v_presentationtable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/v-editorbar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var v_editorbar = ({
	name: 'v-editorbar',
	data: function data() {
		return {
			saveSub: false
		};
	},

	computed: {
		pres: function pres() {
			return this.$store.getters.presentation;
		},
		viewurl: function viewurl() {
			if (this.$route.params && this.$route.params.chartid && this.$route.params.chartid > 0) {
				var chart = this.$store.getters.getChartById(this.$route.params.chartid);
				return chart ? this.urls.view + '/#/' + chart.template + chart.id : this.urls.view;
			}
			return this.urls.view;
		}
	},
	props: {
		urls: {
			type: Object,
			default: function _default() {
				return {};
			}
		},
		token: {
			type: String,
			default: ''
		}
	},
	mounted: function mounted() {
		if (window.evn) this.saveSub = window.evn.subscribe('save', this.save);
	},
	destroyed: function destroyed() {
		if (window.evn && this.saveSub) {
			this.saveSub.remove();
			this.saveSub = false;
		}
	},

	methods: {
		save: function save() {
			this.$store.commit('RESET_ACTIVE_FIELD');
			this.$emit('save');
		},
		copy: function copy() {
			general.copyToClipboard(this.urls.view);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02133236","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v-editorbar.vue
var v_editorbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pres)?_c('div',{staticClass:"v-editorbar"},[_c('button',{staticClass:"st-btn st-btn--small st-btn--icon",class:{'st-btn--primary': _vm.pres.changed },attrs:{"title":_vm.$t('save Presentation')},on:{"click":function($event){_vm.save()}}},[_c('i',{staticClass:"fa fa-floppy-o",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),(_vm.urls.view)?_c('a',{staticClass:"st-btn st-btn--small st-btn--icon",attrs:{"href":_vm.viewurl,"title":_vm.$t('view Presentation'),"target":"_blank","rel":"noopener"}},[_c('i',{staticClass:"fa fa-play",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.urls.view)?_c('button',{staticClass:"st-btn st-btn--small st-btn--icon",attrs:{"title":_vm.$t('copy Presentationlink')},on:{"click":_vm.copy}},[_c('i',{staticClass:"fa fa-link",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.pres.id)?_c('router-link',{staticClass:"st-btn st-btn--small st-btn--icon",attrs:{"title":_vm.$t('edit Settings'),"to":_vm._a(0,function(){return { name: 'presentation-settings', params: {pid: _vm.pres.id} }})}},[_c('i',{staticClass:"fa fa-cog",attrs:{"aria-hidden":"true"}})]):_vm._e()],1):_vm._e()}
var v_editorbar_staticRenderFns = []
var v_editorbar_esExports = { render: v_editorbar_render, staticRenderFns: v_editorbar_staticRenderFns }
/* harmony default export */ var components_v_editorbar = (v_editorbar_esExports);
// CONCATENATED MODULE: ./src/components/v-editorbar.vue
function v_editorbar_injectStyle (ssrContext) {
  __webpack_require__("5ay1")
}
var v_editorbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var v_editorbar___vue_template_functional__ = false
/* styles */
var v_editorbar___vue_styles__ = v_editorbar_injectStyle
/* scopeId */
var v_editorbar___vue_scopeId__ = "data-v-02133236"
/* moduleIdentifier (server only) */
var v_editorbar___vue_module_identifier__ = null
var v_editorbar_Component = v_editorbar_normalizeComponent(
  v_editorbar,
  components_v_editorbar,
  v_editorbar___vue_template_functional__,
  v_editorbar___vue_styles__,
  v_editorbar___vue_scopeId__,
  v_editorbar___vue_module_identifier__
)

/* harmony default export */ var src_components_v_editorbar = (v_editorbar_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue2-dropzone/dist/vue2Dropzone.css
var dist_vue2Dropzone = __webpack_require__("hCol");
var dist_vue2Dropzone_default = /*#__PURE__*/__webpack_require__.n(dist_vue2Dropzone);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/StaticGmaps.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/**

{
	icon: 'https://cdn3.iconfinder.com/data/icons/forum-emoticons-2-20x20/20/Bier.png',
	address: 'Hannover Abelmanstraße 27 Germany',
	title: 'Hannover <3'
},
{
	icon: 'https://cdn3.iconfinder.com/data/icons/forum-emoticons-2-20x20/20/Bier.png',
	address: 'Hannover Bernwardstraße 38 Germany',
	title: 'Hannover <3'
},
{
	icon: 'https://cdn3.iconfinder.com/data/icons/forum-emoticons-2-20x20/20/Bier.png',
	address: 'Hannover Königstraße 49 Germany',
	title: 'Hannover <3'
}

 */

/* harmony default export */ var StaticGmaps = ({
	name: 'StaticGmaps',
	computed: {
		helper_center: {
			get: function get() {
				if (this.center.length > 0) return this.center;
				return '';
			},
			set: function set(value) {
				if (value.length > 0) this.center = value;else this.center = false;
			}
		}
	},
	data: function data() {
		return {
			value: '',
			isAuto: true,

			zoom: this.defaultZoom,
			scale: this.defaultScale,
			width: this.defaultWidth,
			height: this.defaultHeight,
			maptype: this.defaultMaptype,
			format: this.defaultFormat,
			center: this.defaultCenter,
			markerShadow: this.defaultMarkerShadow
		};
	},
	mounted: function mounted() {
		this.getStaticMapsUrl();
	},

	props: {
		baseUrl: {
			type: String,
			default: 'https://maps.googleapis.com/maps/api/staticmap'
		},
		gkey: {
			type: String,
			default: 'AIzaSyDoz2z-SdUmSpTT4unTyW440q4cR8g7HVM'
		},
		// &zoom=1
		defaultZoom: {
			type: Number,
			default: 12
		},
		// &scale=1
		defaultScale: {
			type: Number,
			default: 1
		},
		// &size=600x300
		defaultWidth: {
			type: Number,
			default: 600
		},
		defaultHeight: {
			type: Number,
			default: 600
		},
		// &maptype=roadmap
		defaultMaptype: {
			type: String,
			default: 'roadmap'
		},
		// &format=png
		defaultFormat: {
			type: String,
			default: 'png'
		},
		defaultCenter: {
			default: false
		},
		defaultMarkerShadow: {
			type: Boolean,
			default: false
		},
		markers: {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},
	methods: {
		getStaticMapsUrl: function getStaticMapsUrl() {
			var _this = this;

			var props = {};
			props.key = this.gkey;
			if (this.center) {
				props.center = this.center;
				props.zoom = this.zoom;
			} else {
				props.autoscale = 1;
			}
			props.scale = this.scale;
			props.size = this.width + 'x' + this.height;
			props.maptype = this.maptype;
			props.format = this.format;
			props.markers = [];
			// &markers=icon:https://cdn3.iconfinder.com/data/icons/forum-emoticons-2-20x20/20/Bier.png%7Cshadow:true%7CHannover
			forEach_default()(this.markers, function (marker, index) {
				var str = '';
				if (marker.icon) str += 'icon:' + marker.icon;
				if (_this.markerShadow) str += (str.length > 0 ? '|' : '') + 'shadow:true';
				if (marker.address) str += (str.length > 0 ? '|' : '') + marker.address;
				props.markers.push(str);
			});

			var urlParams = "";
			for (var key in props) {
				urlParams += urlParams.length <= 0 ? '?' : '&';
				if (typeof_default()(props[key]) == 'object') {
					forEach_default()(props[key], function (value) {
						urlParams += urlParams.length <= 0 ? '?' : '&';
						urlParams += key + "=" + encodeURIComponent(value);
					});
				} else {
					urlParams += key + "=" + encodeURIComponent(props[key]);
				}
			}
			var self = this;
			self.value = this.baseUrl + urlParams;
			self.$emit('input', this.value);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6210588c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StaticGmaps.vue
var StaticGmaps_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"StaticGmaps"},[_c('img',{attrs:{"src":_vm.value,"alt":" "}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isAuto),expression:"isAuto"}],attrs:{"name":"isauto","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isAuto)?_vm._i(_vm.isAuto,null)>-1:(_vm.isAuto)},on:{"change":function($event){var $$a=_vm.isAuto,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isAuto=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isAuto=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isAuto=$$c}}}})]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),(!_vm.isAuto)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.helper_center),expression:"helper_center"}],attrs:{"type":"text"},domProps:{"value":(_vm.helper_center)},on:{"input":function($event){if($event.target.composing){ return; }_vm.helper_center=$event.target.value}}})]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zoom),expression:"zoom"}],attrs:{"disabled":!_vm.helper_center,"type":"range","min":"0","max":"20","step":"0.5"},domProps:{"value":(_vm.zoom)},on:{"__r":function($event){_vm.zoom=$event.target.value}}})]),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),_c('input',{attrs:{"type":"button","value":"update"},on:{"click":function($event){_vm.getStaticMapsUrl()}}})])}
var StaticGmaps_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-sm-8"},[_c('label',{attrs:{"for":"isAuto"}},[_vm._v("Automatisch Ausrichten")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-sm-8"},[_c('label',{attrs:{"for":"isAuto"}},[_vm._v("Mittlepunkt")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-sm-8"},[_c('label',{attrs:{"for":"isAuto"}},[_vm._v("Zoom")])])}]
var StaticGmaps_esExports = { render: StaticGmaps_render, staticRenderFns: StaticGmaps_staticRenderFns }
/* harmony default export */ var components_StaticGmaps = (StaticGmaps_esExports);
// CONCATENATED MODULE: ./src/components/StaticGmaps.vue
function StaticGmaps_injectStyle (ssrContext) {
  __webpack_require__("nl26")
}
var StaticGmaps_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var StaticGmaps___vue_template_functional__ = false
/* styles */
var StaticGmaps___vue_styles__ = StaticGmaps_injectStyle
/* scopeId */
var StaticGmaps___vue_scopeId__ = "data-v-6210588c"
/* moduleIdentifier (server only) */
var StaticGmaps___vue_module_identifier__ = null
var StaticGmaps_Component = StaticGmaps_normalizeComponent(
  StaticGmaps,
  components_StaticGmaps,
  StaticGmaps___vue_template_functional__,
  StaticGmaps___vue_styles__,
  StaticGmaps___vue_scopeId__,
  StaticGmaps___vue_module_identifier__
)

/* harmony default export */ var src_components_StaticGmaps = (StaticGmaps_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/v-field.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ var v_field = ({
	name: 'v-field',
	components: {
		CroppableImage: src_components_CroppableImage,
		StaticGmaps: src_components_StaticGmaps,
		vueDropzone: vue2Dropzone_default.a,
		Selectize: vue2_selectize_default.a,
		MultiSelect: src_components_MultiSelect
	},
	computed: {
		presentation: function presentation() {
			return this.$store.getters.presentation;
		},
		comp: function comp() {
			if (this.inline) return 'v-toolinline';
			var el = this.$store.getters.active_field.element;
			if (el && window.innerHeight > 900) {
				return 'v-tooldown';
			}
			return 'v-modal';
		},
		activefield: function activefield() {
			return this.$store.getters.active_field;
		},
		field: function field() {
			return this.$store.getters.getChartField(this.activefield.chartid, this.activefield.fieldname);
		},
		activefieldelement: function activefieldelement() {
			return this.$store.getters.active_field.element;
		}
	},
	props: {
		inline: {
			type: Boolean,
			default: false
		},
		chart: {
			type: Object,
			default: function _default() {
				return {};
			}
		},
		name: {
			type: String,
			default: ''
		}
	},
	data: function data() {
		var channel = this.$store.getters.channel;
		var self = this;
		return {
			escSub: false,
			fileEl: null,
			value: '',
			croppaOptions: {},
			dropzoneOptions: {
				init: function init() {
					this.on("complete", function (file) {
						self.save(file);
					});
				},
				paramName: '',
				maxFiles: 1,
				addRemoveLinks: true,
				url: channel.urls.presentationchart.replace(':id', this.$store.getters.presentation.id).replace(':chart', this.chart.id),
				thumbnailWidth: 400,
				thumbnailHeight: 300,
				maxFilesize: 5 // 5 MB
			}
		};
	},
	created: function created() {

		if (this.field.type == 'image' && this.field && this.field.renderd) {
			this.value = this.field.renderd;
		} else {
			this.value = this.field.value;
		}
		this.dropzoneOptions.paramName = this.field.id;
	},
	mounted: function mounted() {
		if (window.evn) this.escSub = window.evn.subscribe('esc', this.cancel);
		if (this.$refs.dropzone) {
			var size = this.field.size ? this.field.size : 0;
			var mockFile = { name: general.basename(this.value), size: size };
			this.$refs.dropzone.manuallyAddFile(mockFile, this.value);
		}
	},
	destroyed: function destroyed() {
		if (this.escSub) {
			this.escSub.remove();
			this.escSub = false;
		}
	},

	methods: {
		saveClick: function saveClick() {
			if (this.field.type == 'image') {
				this.$store.commit('RESET_ACTIVE_FIELD');
			} else {
				this.save();
			}
		},
		save: function save(file) {
			console.log('emit save');
			if (this.field.type == 'image') {
				if (this.$store.getters['features/croppa'] && (this.field.options.width || this.field.options['max-width']) && (this.field.options.height || this.field.options['max-height']) && file.url) {
					this.$store.commit('UPDATE_FIELD', {
						id: this.chart.id,
						fieldname: this.name,
						assetID: file.id,
						default: file.url,
						renderd: file.url,
						value: file.url
					});
					this.$store.commit('RESET_ACTIVE_FIELD');
				} else if (file && file.xhr) {
					// alelös andere ist nicht echt
					var reps = JSON.parse(file.xhr.response);
					this.$store.commit('UPDATE_FIELD', {
						id: this.chart.id,
						fieldname: this.name,
						renderd: reps.message[this.name].url,
						value: reps.message[this.name].url
					});
				}
			} else if (this.field.type == 'map') {
				this.$store.commit('UPDATE_FIELD', {
					id: this.chart.id,
					fieldname: this.name,
					value: this.value,
					renderd: this.value
				});
			} else {
				this.$store.commit('UPDATE_FIELD', {
					id: this.chart.id,
					fieldname: this.name,
					value: this.value,
					renderd: this.value
				});
				this.$store.commit('RESET_ACTIVE_FIELD');
			}
		},
		cancel: function cancel() {
			console.log('emit cancel');
			if (this.field.default && this.value.length == 0) {
				this.value = this.field.default;
			}
			this.$emit('cancel', this.name);
		},
		changeFile: function changeFile(event) {
			this.fileEl = event.target;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef34f40c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v-field.vue
var v_field_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-field",class:{ 'v-field--inline' : _vm.inline }},[_c(_vm.comp,{tag:"div",attrs:{"yesno":(_vm.field.type != 'image')},on:{"ok":_vm.saveClick,"cancel":_vm.cancel}},[(!_vm.inline)?_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.$t('Edit'))+" "),(_vm.field.title)?_c('span',{domProps:{"textContent":_vm._s(_vm.field.title)}}):_c('span',[_vm._v(_vm._s(_vm.$t('Field: ' + _vm.name)))])]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"message"},slot:"message"},[_c('div',[(_vm.field.type == 'contacts' && _vm.field.options)?_c('div',[_c('MultiSelect',{attrs:{"options":_vm.field.options,"defaultValue":_vm.value},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1):(_vm.field.type == 'map')?_c('div',[_c('StaticGmaps',{attrs:{"defaultWidth":(typeof _vm.field.options.cwidth != 'undefined' ? _vm.field.options.cwidth : 600),"defaultHeight":(typeof _vm.field.options.cheight != 'undefined' ? _vm.field.options.cheight : 600)},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1):(_vm.field.type == 'contact' && _vm.field.options)?_c('div',{class:'v-field__input--' + _vm.field.id},[_c('selectize',{directives:[{name:"focus",rawName:"v-focus"}],model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.field.options),function(opt){return _c('option',{key:opt.value,domProps:{"value":opt.value}},[_vm._v(_vm._s((opt.translate ? _vm.$t(opt.label).trim() : opt.label)))])}))],1):(_vm.field.type == 'image')?_c('div',[(_vm.$store.getters['features/croppa'] && (_vm.field.options.width || _vm.field.options['max-width']) && (_vm.field.options.height || _vm.field.options['max-height']))?_c('CroppableImage',{attrs:{"fieldname":_vm.field.id,"id":_vm.field.assetID,"cid":_vm.chart.id,"pid":_vm.presentation.id,"width":_vm.field.options.width ? parseInt(_vm.field.options.width) : parseInt(_vm.field.options['max-width']),"height":_vm.field.options.height ? parseInt(_vm.field.options.height) : parseInt(_vm.field.options['max-height'])},on:{"saved":_vm.save}}):_c('div',[_c('vue-dropzone',{ref:"dropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions}}),_vm._v(" "),(_vm.field.options)?_c('div',_vm._l((_vm.field.options),function(value,name){return _c('div',[_vm._v(_vm._s(name)+": "+_vm._s(value))])})):_vm._e()],1)],1):(_vm.field.type == 'textarea')?_c('textarea',{directives:[{name:"focus",rawName:"v-focus"},{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"st-input st-input--full st-input--text",attrs:{"rows":(_vm.field.attributes &&_vm.field.attributes.rows ? _vm.field.attributes.rows : 3)},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}}):(_vm.field.type == 'wysiwyg')?_c('trumbowyg',{directives:[{name:"focus",rawName:"v-focus"}],attrs:{"config":_vm._a(0,function(){return {btns: [['removeformat'], ['bold', 'italic'], ['unorderedList', 'orderedList'], ['link']]}})},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):(_vm.inline)?_c('input',{directives:[{name:"focus",rawName:"v-focus"},{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"inline-field st-input--text",class:'v-field__input--' + _vm.field.id,attrs:{"type":"text"},domProps:{"value":(_vm.value)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.save($event)},"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}}):_c('input',{directives:[{name:"focus",rawName:"v-focus"},{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"st-input st-input--full st-input--text",class:'v-field__input--' + _vm.field.id,attrs:{"type":"text"},domProps:{"value":(_vm.value)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.save($event)},"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})],1)])])])}
var v_field_staticRenderFns = []
var v_field_esExports = { render: v_field_render, staticRenderFns: v_field_staticRenderFns }
/* harmony default export */ var components_v_field = (v_field_esExports);
// CONCATENATED MODULE: ./src/components/v-field.vue
function v_field_injectStyle (ssrContext) {
  __webpack_require__("phMY")
}
var v_field_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var v_field___vue_template_functional__ = false
/* styles */
var v_field___vue_styles__ = v_field_injectStyle
/* scopeId */
var v_field___vue_scopeId__ = "data-v-ef34f40c"
/* moduleIdentifier (server only) */
var v_field___vue_module_identifier__ = null
var v_field_Component = v_field_normalizeComponent(
  v_field,
  components_v_field,
  v_field___vue_template_functional__,
  v_field___vue_styles__,
  v_field___vue_scopeId__,
  v_field___vue_module_identifier__
)

/* harmony default export */ var src_components_v_field = (v_field_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/v-modal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var v_modal = ({
	name: 'v-modal',
	props: {
		options: {
			type: Boolean,
			default: true
		},
		yesno: {
			type: Boolean,
			default: false
		}
	},
	mounted: function mounted() {
		var self = this;
		document.addEventListener("keydown", function (e) {
			if (e.keyCode == 27) {
				self.$emit('cancel');
			}
		});
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a874568c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v-modal.vue
var v_modal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-modal",attrs:{"tabindex":"0"},on:{"keypress":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }_vm.$emit('cancel')}}},[_c('div',{staticClass:"st-overlay active"},[_c('dialog',{staticClass:"st-overlay__content"},[_c('div',{staticClass:"margin-bottom-medium"},[_c('strong',{staticClass:"st-headline st-headline--2"},[_vm._t("title",[_vm._v("Titel")])],2),_vm._v(" "),_vm._t("message",[_vm._v("Hier könnte Ihre Meldung stehen!")])],2),_vm._v(" "),(_vm.options)?_c('div',[(_vm.yesno)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('button',{staticClass:"st-btn st-btn--small st-btn--submit",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.$emit('ok')}}},[_vm._t("positive",[_vm._v("Bestätigen")])],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 text-right"},[_c('button',{staticClass:"st-btn st-btn--small st-btn--delete",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.$emit('cancel')}}},[_vm._t("negative",[_vm._v("Abbrechen")])],2)])])]):_vm._e(),_vm._v(" "),(!_vm.yesno)?_c('div',[_c('div',{staticClass:"text-right"},[_c('a',{staticClass:"st-btn st-btn--small st-btn--delete",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.$emit('cancel')}}},[_vm._t("negative",[_vm._v("Schließen")])],2)])]):_vm._e()]):_vm._e()])])])}
var v_modal_staticRenderFns = []
var v_modal_esExports = { render: v_modal_render, staticRenderFns: v_modal_staticRenderFns }
/* harmony default export */ var components_v_modal = (v_modal_esExports);
// CONCATENATED MODULE: ./src/components/v-modal.vue
function v_modal_injectStyle (ssrContext) {
  __webpack_require__("1b73")
}
var v_modal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var v_modal___vue_template_functional__ = false
/* styles */
var v_modal___vue_styles__ = v_modal_injectStyle
/* scopeId */
var v_modal___vue_scopeId__ = "data-v-a874568c"
/* moduleIdentifier (server only) */
var v_modal___vue_module_identifier__ = null
var v_modal_Component = v_modal_normalizeComponent(
  v_modal,
  components_v_modal,
  v_modal___vue_template_functional__,
  v_modal___vue_styles__,
  v_modal___vue_scopeId__,
  v_modal___vue_module_identifier__
)

/* harmony default export */ var src_components_v_modal = (v_modal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/v-mainnav.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var v_mainnav = ({
	name: 'v-mainnav',
	computed: {
		loadings: function loadings() {
			return this.$store.getters.loadings;
		},
		devmode: function devmode() {
			return this.$store.getters.devmode;
		},
		slimnavigation: function slimnavigation() {
			return this.$store.getters.slimnavigation;
		},
		channel: function channel() {
			return this.$store.getters.channel;
		}
	},
	methods: extends_default()({}, general)
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1064124","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v-mainnav.vue
var v_mainnav_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.channel.pages)?_c('div',{staticClass:"v-mainnav",class:{ 'st-mainnav--slim': _vm.slimnavigation }},[_c('ul',{staticClass:"st-mainnav",class:{ 'st-mainnav--slim': _vm.slimnavigation }},[_vm._l((_vm.channel.pages),function(page){return _c('li',{staticClass:"st-mainnav__item",class:'st-mainnav__item--'+page.template},[_c('router-link',{staticClass:"st-mainnav__link st-mainnav__link--router",attrs:{"to":page.url,"active-class":"st-mainnav__link--current","exact-active-class":"st-mainnav__link--exact"}},[(page.iconname)?_c('i',{staticClass:"fa",class:'fa-'+page.iconname}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"st-mainnav__title"},[_vm._v(_vm._s(_vm.$t(page.title)))])]),_vm._v(" "),(page.actions)?_c('ul',{staticClass:"st-mainnav__submenu"},_vm._l((page.actions),function(action){return _c('li',{staticClass:"st-mainnav__item"},[_c('router-link',{staticClass:"st-mainnav__link st-mainnav__link--router st-mainnav__link--subnav",attrs:{"to":action.url,"exact-active-class":"st-mainnav__link--exact"}},[(action.iconname)?_c('i',{staticClass:"fa",class:'fa-'+action.iconname}):_vm._e(),_vm._v(" "),(action.i18n)?_c('span',{staticClass:"st-mainnav__title"},[_vm._v(_vm._s(_vm.$t(action.title, _vm.translate(action.i18n))))]):_c('span',{staticClass:"st-mainnav__title"},[_vm._v(_vm._s(_vm.$t(action.title)))])])],1)})):_vm._e()],1)}),_vm._v(" "),(_vm.channel.files && _vm.channel.files.length > 0)?_c('li',[_c('hr')]):_vm._e(),_vm._v(" "),((_vm.channel.files && _vm.channel.files.length > 0 || _vm.channel.page))?_c('li',{staticClass:"st-mainnav__item st-mainnav__item--open"},[(_vm.channel.page)?_c('router-link',{staticClass:"st-mainnav__link st-mainnav__link--router st-mainnav__link--subnav",attrs:{"to":'/panel/channel',"exact-active-class":"st-mainnav__link--exact"}},[_c('i',{staticClass:"fa fa-info"}),_vm._v(" "),_c('span',{staticClass:"st-mainnav__title"},[_vm._v(_vm._s(_vm.$t('Infoguide')))])]):_c('span',{staticClass:"st-mainnav__el"},[_c('i',{staticClass:"fa fa-info"}),_vm._v(" "),_c('span',{staticClass:"st-mainnav__title"},[_vm._v(_vm._s(_vm.$t('Infoguide')))])]),_vm._v(" "),_c('ul',{staticClass:"st-mainnav__submenu"},_vm._l((_vm.channel.files),function(file){return _c('li',{staticClass:"st-mainnav__item"},[_c('a',{staticClass:"st-mainnav__link st-mainnav__link--subnav",attrs:{"href":file.url,"download":""}},[(file.icon)?_c('i',{staticClass:"fa",class:'fa-' + file.icon}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"st-mainnav__title"},[_vm._v(_vm._s((file.description ? file.description : file.basename)))])])])}))],1):_vm._e()],2),_vm._v(" "),_c('transition',{attrs:{"name":"mainnav-dev","enter-active-class":"animated fadeInUp","leave-active-class":"animated fadeOutDown"}},[(_vm.devmode)?_c('ul',{staticClass:"st-mainnav",class:{'st-mainnav--slim': _vm.slimnavigation }},[_c('li',{staticClass:"st-mainnav__item"},[_c('router-link',{staticClass:"st-mainnav__link st-mainnav__link--router",attrs:{"to":_vm._a(0,function(){return { name :'test' }}),"active-class":"st-mainnav__link--current","exact-active-class":"st-mainnav__link--exact"}},[_c('i',{staticClass:"fa fa-angellist"}),_vm._v(" "),_c('span',{staticClass:"st-mainnav__title"},[_vm._v(_vm._s(_vm.$t('Test')))])])],1),_vm._v(" "),_c('li',{staticClass:"st-mainnav__item"},[_c('router-link',{staticClass:"st-mainnav__link st-mainnav__link--router",attrs:{"to":_vm._a(1,function(){return { name :'settings' }}),"active-class":"st-mainnav__link--current","exact-active-class":"st-mainnav__link--exact"}},[_c('i',{staticClass:"fa fa-sliders"}),_vm._v(" "),_c('span',{staticClass:"st-mainnav__title"},[_vm._v(_vm._s(_vm.$t('Settings')))])])],1),_vm._v(" "),_c('li',{staticClass:"st-mainnav__item"},[_c('router-link',{staticClass:"st-mainnav__link st-mainnav__link--router",attrs:{"to":_vm._a(2,function(){return { name:'media_store' }}),"active-class":"st-mainnav__link--current","exact-active-class":"st-mainnav__link--exact"}},[_c('i',{staticClass:"fa fa-image"}),_vm._v(" "),_c('span',{staticClass:"st-mainnav__title"},[_vm._v(_vm._s(_vm.$t('Media Store')))])])],1),_vm._v(" "),_c('li',{staticClass:"st-mainnav__item"},[_c('router-link',{staticClass:"st-mainnav__link st-mainnav__link--router",attrs:{"to":_vm._a(3,function(){return { name:'styleguide' }}),"active-class":"st-mainnav__link--current","exact-active-class":"st-mainnav__link--exact"}},[_c('i',{staticClass:"fa fa-paint-brush"}),_vm._v(" "),_c('span',{staticClass:"st-mainnav__title"},[_vm._v(_vm._s(_vm.$t('Styleguide')))])])],1),_vm._v(" "),_c('li',{staticClass:"st-mainnav__item"},[_c('router-link',{staticClass:"st-mainnav__link st-mainnav__link--router",attrs:{"to":_vm._a(4,function(){return { name:'translations' }}),"active-class":"st-mainnav__link--current","exact-active-class":"st-mainnav__link--exact"}},[_c('i',{staticClass:"fa fa-flag"}),_vm._v(" "),_c('span',{staticClass:"st-mainnav__title"},[_vm._v(_vm._s(_vm.$t('Translations')))])])],1),_vm._v(" "),(_vm.channel.me.role === 'superuser')?_c('li',{staticClass:"st-mainnav__item"},[_c('a',{staticClass:"st-mainnav__link st-mainnav__link--router",attrs:{"href":"/processwire/","active-class":"st-mainnav__link--current","exact-active-class":"st-mainnav__link--exact"}},[_c('i',{staticClass:"fa fa-bug"}),_vm._v(" "),_c('span',{staticClass:"st-mainnav__title"},[_vm._v(_vm._s(_vm.$t('Processwire')))])])]):_vm._e(),_vm._v(" "),_c('li',[(_vm.devmode)?_c('div',{staticClass:"devmode devmode--block"},[(_vm.loadings)?_c('div',_vm._l((_vm.loadings),function(lstatestatus,lstatename){return (lstatestatus)?_c('div',[_vm._v(_vm._s(lstatename)+" "),_c('div',{staticClass:"inline-block spinner spinner--white spinner--large"})]):_vm._e()})):_vm._e(),_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.$t('DEV MODE'))+"\n\t\t\t\t\t")]):_vm._e()])]):_vm._e()])],1):_vm._e()}
var v_mainnav_staticRenderFns = []
var v_mainnav_esExports = { render: v_mainnav_render, staticRenderFns: v_mainnav_staticRenderFns }
/* harmony default export */ var components_v_mainnav = (v_mainnav_esExports);
// CONCATENATED MODULE: ./src/components/v-mainnav.vue
function v_mainnav_injectStyle (ssrContext) {
  __webpack_require__("V2go")
}
var v_mainnav_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var v_mainnav___vue_template_functional__ = false
/* styles */
var v_mainnav___vue_styles__ = v_mainnav_injectStyle
/* scopeId */
var v_mainnav___vue_scopeId__ = "data-v-f1064124"
/* moduleIdentifier (server only) */
var v_mainnav___vue_module_identifier__ = null
var v_mainnav_Component = v_mainnav_normalizeComponent(
  v_mainnav,
  components_v_mainnav,
  v_mainnav___vue_template_functional__,
  v_mainnav___vue_styles__,
  v_mainnav___vue_scopeId__,
  v_mainnav___vue_module_identifier__
)

/* harmony default export */ var src_components_v_mainnav = (v_mainnav_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-popperjs/dist/js/vue-popper.js
var vue_popper = __webpack_require__("Miuz");
var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper);

// EXTERNAL MODULE: ./node_modules/vue-popperjs/dist/css/vue-popper.css
var css_vue_popper = __webpack_require__("N0Tb");
var css_vue_popper_default = /*#__PURE__*/__webpack_require__.n(css_vue_popper);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/vuex-persistedstate/dist/vuex-persistedstate.es.js + 1 modules
var vuex_persistedstate_es = __webpack_require__("424j");

// CONCATENATED MODULE: ./src/store/mutations.js



// define the possible mutations that can be applied to our state
var mutations = {
    // ------------------------ ERRORS ------------------------
    ADD_ERROR: function ADD_ERROR(state, data) {
        if (this.getters.devmode) console.debug('ADD_ERROR', data);
        var errors = state.errors.slice(0);
        errors.push(data);
        state.errors = errors;
    },
    REMOVE_ERROR: function REMOVE_ERROR(state, id) {
        if (this.getters.devmode) console.debug('REMOVE_ERROR', id);
        state.errors = state.errors.filter(function (err) {
            return err.id !== id;
        });
    },
    UNSET_ERRORS: function UNSET_ERRORS(state) {
        if (this.getters.devmode) console.debug('UNSET_ERRORS');
        state.errors = [];
    },

    // ------------------------ NOTICE ------------------------
    ADD_NOTICE: function ADD_NOTICE(state, data) {
        if (this.getters.devmode) console.debug('ADD_NOTICE', data);
        var notices = state.notices;
        if (!data.id) data.id = Math.random().toString(16); // @ToDo ggf hier was besseres
        if (!data.removeAble) data.removeAble = true;
        notices.push(data);
        state.notices = notices;
    },

    REMOVE_NOTICE: function REMOVE_NOTICE(state, id) {
        if (this.getters.devmode) console.debug('REMOVE_NOTICE', id);
        state.notices = state.notices.filter(function (note) {
            return note.id !== id;
        });
    },
    UNSET_NOTICE: function UNSET_NOTICE(state) {
        if (this.getters.devmode) console.debug('UNSET_NOTICE');
        state.notices = [];
    },

    SET_DEBUG: function SET_DEBUG(state) {
        if (this.getters.devmode) console.debug('SET_DEBUG');
        state.debug = true;
    },
    UNSET_DEBUG: function UNSET_DEBUG(state) {
        if (this.getters.devmode) console.debug('UNSET_DEBUG');
        state.debug = false;
    },


    // ------------------------ SAVEING ------------------------
    START_SAVEING: function START_SAVEING(state) {
        if (this.getters.devmode) console.debug('START_SAVEING');
        state.saveing = true;
    },
    END_SAVEING: function END_SAVEING(state) {
        if (this.getters.devmode) console.debug('END_SAVEING');
        state.saveing = false;
    },
    // ------------------------ EDITING ------------------------
    START_EDITING: function START_EDITING(state) {
        if (this.getters.devmode) console.debug('START_EDITING');
        state.editing = true;
    },
    END_EDITING: function END_EDITING(state) {
        if (this.getters.devmode) console.debug('END_EDITING');
        state.editing = false;
    },
    // ------------------------ CHANGED ------------------------
    HAS_CHANGED: function HAS_CHANGED(state) {
        if (this.getters.devmode) console.debug('HAS_CHANGED');
        state.changed = true;
    },
    RESET_CHANGED: function RESET_CHANGED(state) {
        if (this.getters.devmode) console.debug('RESET_CHANGED');
        state.changed = false;
    },

    // ------------------------ LOADING ------------------------
    START_LOADING: function START_LOADING(state, name) {
        if (!name) console.error('START_LOADING requires a name');
        if (this.getters.devmode) console.debug('START_LOADING', name);
        vue_esm["default"].set(state.loading, name, true);
    },
    END_LOADING: function END_LOADING(state, name) {
        if (!name) console.error('END_LOADING requires a name');
        if (this.getters.devmode) console.debug('END_LOADING', name);
        vue_esm["default"].set(state.loading, name, false);
    },

    // ------------------------ NAVIGATION ------------------------
    // $store.getters.slimnavigation
    TOGGLE_SLIMNAVIGATION: function TOGGLE_SLIMNAVIGATION(state) {
        if (this.getters.devmode) console.debug('TOGGLE_SLIMNAVIGATION');
        state.slimnavigation = !state.slimnavigation;
    },
    ENABLE_SLIMNAVIGATION: function ENABLE_SLIMNAVIGATION(state) {
        if (this.getters.devmode) console.debug('ENABLE_SLIMNAVIGATION');
        state.slimnavigation = true;
    },
    DISABLE_SLIMNAVIGATION: function DISABLE_SLIMNAVIGATION(state) {
        if (this.getters.devmode) console.debug('DISABLE_SLIMNAVIGATION');
        state.slimnavigation = false;
    },

    // ------------------------ CHANNEL ------------------------
    SET_CHANNEL: function SET_CHANNEL(state, data) {
        if (this.getters.devmode) console.debug('SET_CHANNEL', data);

        if ((typeof data === 'undefined' ? 'undefined' : typeof_default()(data)) === 'object') data.time = new Date().getTime();

        state.channel = data;
    },
    UNSET_CHANNEL: function UNSET_CHANNEL(state) {
        if (this.getters.devmode) console.debug('UNSET_CHANNEL');
        state.channel = false;
    },
    // ------------------------ CHANNELS ------------------------
    SET_CHANNELS: function SET_CHANNELS(state, data) {
        if (this.getters.devmode) console.debug('SET_CHANNELS', data);
        state.channels = data;
    },
    UNSET_CHANNELS: function UNSET_CHANNELS(state) {
        if (this.getters.devmode) console.debug('UNSET_CHANNELS');
        state.channels = false;
    },

    // ------------------------ USER ------------------------
    SET_USER: function SET_USER(state, data) {
        if (this.getters.devmode) console.debug('SET_USER', data);
        state.user = data;
    },
    UNSET_USER: function UNSET_USER(state) {
        if (this.getters.devmode) console.debug('UNSET_USER');
        state.user = {};
    },
    SET_EDITUSER: function SET_EDITUSER(state, data) {
        if (this.getters.devmode) console.debug('SET_EDITUSER', data);

        if (data.id) {
            this.dispatch('socket/SEND_PACKAGE', {
                name: 'start edit user',
                payload: data.id,
                time: new Date().getTime()
            });
        }

        state.edituser = data;
    },
    UNSET_EDITUSER: function UNSET_EDITUSER(state) {
        if (this.getters.devmode) console.debug('UNSET_EDITUSER');

        if (state.edituser.id) {
            this.dispatch('socket/SEND_PACKAGE', {
                name: 'end edit user',
                payload: state.edituser.id,
                time: new Date().getTime()
            });
        }

        state.edituser = false;
    },
    RESET_EDITUSER: function RESET_EDITUSER(state) {
        if (this.getters.devmode) console.debug('RESET_EDITUSER');

        if (state.edituser.id) {
            this.dispatch('socket/SEND_PACKAGE', {
                name: 'end edit user',
                payload: state.edituser.id,
                time: new Date().getTime()
            });
        }

        state.edituser = false;
    },

    TOGGLE_DEVMODE: function TOGGLE_DEVMODE(state) {
        if (this.getters.devmode) console.debug('TOGGLE_DEVMODE');
        state.devmode = !state.devmode;
    },
    SET_DEVMODE: function SET_DEVMODE(state, data) {
        if (this.getters.devmode) console.debug('SET_DEVMODE', data);
        state.devmode = data;
    },
    RESET_DEVMODE: function RESET_DEVMODE(state) {
        if (this.getters.devmode) console.debug('RESET_DEVMODE');
        state.devmode = false;
    },

    MOUSE_MOVE: function MOUSE_MOVE(state, event) {
        state.mouseposition.x = event.pageX;
        state.mouseposition.y = event.pageY;
    },

    LOGOUT: function LOGOUT(state) {
        var _this = this;

        if (this.getters.devmode) console.debug('LOGOUT');
        var actions = ['UNSET_CHANNEL', 'UNSET_CHANNELS', 'DISABLE_SLIMNAVIGATION', 'UNSET_NOTICE', 'END_SAVEING', 'END_EDITING', 'RESET_CHANGED', 'UNSET_PRESENTATION', 'RESET_PRESENTATIONID', 'UNSET_USER', 'RESET_EDITUSER', 'UNSET_CHARTTEMPLATES'];

        actions.forEach(function (action) {
            try {
                _this.commit(action);
            } catch (e) {
                console.error(e);
            }
        });

        this.commit('END_LOADING', 'LOGOUT');
    }
};

/* harmony default export */ var store_mutations = (mutations);
// CONCATENATED MODULE: ./src/store/actions.js


/* harmony default export */ var actions = ({
	SET_EDITUSER: function SET_EDITUSER(_ref, data) {
		var getters = _ref.getters,
		    dispatch = _ref.dispatch,
		    commit = _ref.commit;

		if (getters.devmode) console.debug('A|SET_EDITUSER');

		if (data) commit('SET_EDITUSER', data);

		if (data && data.presentation) dispatch('SET_PRESENTATION', getters.edituser.presentation);
	}
});
// CONCATENATED MODULE: ./src/store/getters.js



/* harmony default export */ var store_getters = ({
    // Notices
    errors: function errors(state) {
        return state.errors;
    },
    notices: function notices(state) {
        return state.notices;
    },

    // Datas
    channel: function channel(state) {
        // if(!isCacheValid(state.channel.time)) return false;
        return state.channel;
    },
    channels: function channels(state) {
        // if(!state.channel || !isCacheValid(state.channel.time)) return false;
        return state.channels;
    },
    user: function user(state) {
        return state.user;
    },
    edituser: function edituser(state) {
        return state.edituser;
    },

    // statussen
    slimnavigation: function slimnavigation(state) {
        return state.slimnavigation;
    },
    loading: function loading(state) {
        var isLoading = false;
        keys_default()(state.loading).forEach(function (name) {
            if (!isLoading && state.loading[name]) isLoading = true;
        });
        return isLoading;
    },
    loadings: function loadings(state) {
        return state.loading;
    },
    saveing: function saveing(state) {
        return state.saveing;
    },
    editing: function editing(state) {
        return state.edting;
    },
    changed: function changed(state) {
        return state.changed;
    },
    devmode: function devmode(state) {
        return state.devmode;
    },

    getEditFieldById: function getEditFieldById(state, getters) {
        return function (name) {

            if (getters.edituser && getters.edituser.fields) {
                return helpers_storeutilis.getUsereditFieldById(getters.edituser.fields, name);
            }

            if (getters.presentation && getters.presentation.form_fields) {
                return helpers_storeutilis.getUsereditFieldById(getters.presentation.form_fields, name);
            }

            if (getters.channel && getters.channel.page) {
                return helpers_storeutilis.getUsereditFieldById(getters.channel.page, name);
            }

            return false;
        };
    },

    mouseposition: function mouseposition(state) {
        return state.mouseposition;
    }
});
// CONCATENATED MODULE: ./src/store/preseditor/mutations.js




/* harmony default export */ var preseditor_mutations = ({
  PRESEDITOR_RESET: function PRESEDITOR_RESET(state) {
    if (this.getters.devmode) console.debug('M|PRESEDITOR_RESET', data);
    state.presentation = false;
    state.charts = false;
  },

  // ------------------------ ADDCHART ------------------------
  START_ADDCHART: function START_ADDCHART(state, id) {
    if (id === 0) id = true;
    if (this.getters.devmode) console.debug('M|START_ADDCHART', id);
    state.addchart = id;
  },
  END_ADDCHART: function END_ADDCHART(state) {
    if (this.getters.devmode) console.debug('M|END_ADDCHART');
    state.addchart = false;
  },

  // ------------------------ CHARTSTEMPALTES ------------------------
  SET_CHARTTEMPLATES: function SET_CHARTTEMPLATES(state, templates) {
    if (this.getters.devmode) console.debug('M|SET_CHARTTEMPLATES', templates);
    if (!state.chartemplates) state.chartemplates = {};
    state.chartemplates = assign_default()({}, state.chartemplates, templates);
  },
  UNSET_CHARTTEMPLATES: function UNSET_CHARTTEMPLATES(state) {
    if (this.getters.devmode) console.debug('M|UNSET_CHARTTEMPLATES');
    state.chartemplates = false;
  },

  ADD_CHARTTEMPLATES: function ADD_CHARTTEMPLATES(state, templates) {
    var _this = this;

    if (this.getters.devmode) console.debug('M|ADD_CHARTTEMPLATES', templates);
    keys_default()(templates).forEach(function (name) {
      _this.commit('ADD_CHARTTEMPLATE', {
        name: name,
        template: templates[name]
      });
    });
  },
  REMOVE_CHARTTEMPLATES: function REMOVE_CHARTTEMPLATES(state, templatenames) {
    var _this2 = this;

    if (this.getters.devmode) console.debug('M|REMOVE_CHARTTEMPLATES', templatenames);
    templatenames.forEach(function (name) {
      _this2.commit('REMOVE_CHARTTEMPLATE', name);
    });
  },

  ADD_CHARTTEMPLATE: function ADD_CHARTTEMPLATE(state, charttemplate) {
    if (this.getters.devmode) console.debug('M|ADD_CHARTTEMPLATE', charttemplate);
    if (!state.chartemplates) state.chartemplates = {};
    vue_esm["default"].set(state.chartemplates, charttemplate.name, charttemplate.template);
  },

  REMOVE_CHARTTEMPLATE: function REMOVE_CHARTTEMPLATE(state, name) {
    if (this.getters.devmode) console.debug('M|REMOVE_CHARTTEMPLATE', name);
    if (!state.chartemplates) state.chartemplates = {};
    vue_esm["default"].delete(state.chartemplates, name);
  },

  START_LOADING_CHARTTEMPLATES: function START_LOADING_CHARTTEMPLATES(state) {
    if (this.getters.devmode) console.debug('M|START_LOADING_CHARTTEMPLATES');
    state.chartemplates_loading = true;
  },
  STOP_LOADING_CHARTTEMPLATES: function STOP_LOADING_CHARTTEMPLATES(state) {
    if (this.getters.devmode) console.debug('M|STOP_LOADING_CHARTTEMPLATES');
    state.chartemplates_loading = false;
  },

  // ------------------------ CHARTS ------------------------
  SET_CHARTS: function SET_CHARTS(state, data) {
    if (this.getters.devmode) console.debug('M|SET_CHARTS', data);
    state.charts = data;
  },
  UNSET_CHARTS: function UNSET_CHARTS(state) {
    if (this.getters.devmode) console.debug('M|UNSET_CHARTS');
    state.charts = {};
  },

  TOGGLE_CHART_VISIBILITY: function TOGGLE_CHART_VISIBILITY(state, id) {
    if (this.getters.devmode) console.debug('M|TOGGLE_CHART_VISIBILITY', id);
    var chart = this.getters.getChartById(id);
    if (chart) chart.visible = !chart.visible;
    state.charts = state.charts; // trigger update?
  },
  TOGGLE_CHART_TRASHED: function TOGGLE_CHART_TRASHED(state, id) {
    if (this.getters.devmode) console.debug('M|TOGGLE_CHART_TRASHED', id);
    var chart = this.getters.getChartById(id);
    if (chart) chart.trashed = !chart.trashed;
    state.charts = state.charts; // trigger update?
  },
  DELETE_CHART: function DELETE_CHART(state, chartid) {
    if (this.getters.devmode) console.debug('M|DELETE_CHART', chartid);

    var chart = this.getters.getChartById(chartid, true);
    if (chart.parent && chart._index && chart.parent[chart._index]) {
      if (this.getters.devmode) console.debug('M|DELETE_CHART M 2', chart.id, chart.parent, chart._index);
      vue_esm["default"].delete(chart.parent, chart._index);
    } else if (state.charts[chartid]) {
      if (this.getters.devmode) console.debug('M|DELETE_CHART M 3', chart.id, chartid);
      vue_esm["default"].delete(state.charts, chartid);
    } else if (chart.parent && chart.parent.charts && chart.parent.charts[chart.id]) {
      if (this.getters.devmode) console.debug('M|DELETE_CHART M 1', chart.id, chartid);
      vue_esm["default"].delete(chart.parent.charts, chartid);
    } else if (chart._index && state.charts[chart._index]) {
      if (this.getters.devmode) console.debug('M|DELETE_CHART M 4', chart.id, chartid, chart._index);
      vue_esm["default"].delete(state.charts, chart._index);
    }

    state.charts = state.charts;
  },
  UPDATE_CHART: function UPDATE_CHART(state, payload) {
    var _this3 = this;

    if (this.getters.devmode) console.debug('M|UPDATE_CHART', payload);
    var id = payload.id;

    var oldPosition = false,
        newPosition = false,
        parent = false;

    var chart = this.getters.getChartById(id, true);
    keys_default()(payload).forEach(function (key) {
      if (key == 'id') return;
      switch (key) {
        case 'position':
          oldPosition = chart[key];
          newPosition = payload[key];
          parent = chart.parent ? chart.parent.charts : _this3.getters.charts;
          delete chart.parent;
          break;

        default:
          vue_esm["default"].set(chart, key, payload[key]);
          break;
      }
    });

    chart.changed = true;

    // reorder
    if (oldPosition >= 0 && newPosition >= 0 && parent) {
      var indixer = 0;
      keys_default()(parent).filter(function (key) {
        return parent[key].id != id;
      }).sort(function (a, b) {
        if (parent[a].position == parent[b].position) return 0;
        return parent[a].position < parent[b].position ? -1 : 1;
      }).forEach(function (key, index) {
        var item = parent[key];
        if (index == newPosition) indixer += 1;

        item.position = index + indixer;
      });

      chart.position = newPosition;
    }
    vue_esm["default"].set(state.presentation, 'changed', true);
    state.charts = state.charts; // trigger update?
  },
  UPDATE_FIELD: function UPDATE_FIELD(state, payload) {
    if (this.getters.devmode) console.debug('M|UPDATE_FIELD', payload);
    var id = payload.id,
        fieldname = payload.fieldname;

    this.dispatch('socket/SEND_PACKAGE', {
      name: 'UPDATE_FIELD',
      payload: payload,
      time: new Date().getTime()
    });

    var chart = this.getters.getChartById(id),
        field = chart.fields[fieldname];

    keys_default()(payload).forEach(function (key) {
      if (key == 'id' || key == 'fieldname') return;

      vue_esm["default"].set(field, key, payload[key]);

      vue_esm["default"].set(field, 'changed', true);
    });

    chart.changed = true;

    state.charts = state.charts; // trigger update?
  },


  // ------------------------ CHART ------------------------
  SET_PRESENTATION: function SET_PRESENTATION(state, data) {
    if (this.getters.devmode) console.debug('M|SET_PRESENTATION', data);
    state.presentation = data;
  },
  UNSET_PRESENTATION: function UNSET_PRESENTATION(state) {
    if (this.getters.devmode) console.debug('M|UNSET_PRESENTATION');
    state.presentation = {};
  },
  SET_PRESENTATIONID: function SET_PRESENTATIONID(state, cid) {
    if (this.getters.devmode) console.debug('M|SET_PRESENTATIONID', cid);
    state.active_presentation = cid;
  },
  RESET_PRESENTATIONID: function RESET_PRESENTATIONID(state) {
    if (this.getters.devmode) console.debug('M|RESET_PRESENTATIONID');
    state.active_presentation = 0;
  },
  SET_ACTIVE_FIELD: function SET_ACTIVE_FIELD(state, payload) {
    if (this.getters.devmode) console.debug('M|SET_ACTIVE_FIELD', payload);
    state.active_field = payload;
  },
  RESET_ACTIVE_FIELD: function RESET_ACTIVE_FIELD(state) {
    if (this.getters.devmode) console.debug('M|RESET_ACTIVE_FIELD');
    state.active_field = false;
  },

  SET_ADDABLECHARTS: function SET_ADDABLECHARTS(state, data) {
    if (this.getters.devmode) console.debug('M|SET_ADDABLECHARTS');
    state.editor.addablecharts = data;
  },
  UNSET_ADDABLECHARTS: function UNSET_ADDABLECHARTS(state) {
    if (this.getters.devmode) console.debug('M|UNSET_ADDABLECHARTS');
    state.editor.addablecharts = {};
  },

  ADD_CHARTCOMPONENTS: function ADD_CHARTCOMPONENTS(state, name) {
    if (this.getters.devmode) console.debug('M|ADD_CHARTCOMPONENTS', name);
    state.editor.chartcomponents.push(name);
  },

  REMOVE_CHARTCOMPONENTS: function REMOVE_CHARTCOMPONENTS(state, name) {
    if (this.getters.devmode) console.debug('M|REMOVE_CHARTCOMPONENTS');
    var index = state.editor.chartcomponents.find(name);
    if (index) {
      delete state.editor.chartcomponents[index];
    }
  },

  INCREASE_NEWCHARTCOUNTER: function INCREASE_NEWCHARTCOUNTER(state) {
    if (this.getters.devmode) console.debug('M|INCREASE_NEWCHARTCOUNTER');
    state.newchartcounter -= 1;
  }
});
// CONCATENATED MODULE: ./src/store/preseditor/actions.js








function actions_getSaveableChart(chart, index) {
	var self = this;
	var sachart = {};

	sachart.id = chart.id;

	sachart.position = chart.position;
	sachart.trashed = chart.trashed;
	sachart.visible = chart.visible;
	sachart.template = chart.template;
	if (chart.newImage) {
		sachart.image = chart.image;
	}

	if (chart.charts) {
		sachart.charts = {};
		keys_default()(chart.charts).forEach(function (key, index) {
			sachart.charts[chart.charts[key].id] = actions_getSaveableChart(chart.charts[key], index);
		});
	}

	sachart.fields = {};
	forEach_default()(chart.fields, function (field, key) {
		if (key == 'background-image' || key == 'background-video') return;
		if (field.changed) {
			sachart.fields[key] = field.value;
		}
	});

	return sachart;
};

/* harmony default export */ var preseditor_actions = ({
	SET_PRESENTATION: function SET_PRESENTATION(_ref, data) {
		var dispatch = _ref.dispatch,
		    rootGetters = _ref.rootGetters,
		    getters = _ref.getters,
		    commit = _ref.commit;

		if (rootGetters.devmode) console.debug('A|SET_PRESENTATION');

		if (data) commit('SET_PRESENTATION', data);
		if (data.id) commit('SET_PRESENTATIONID', data.id);
		if (data.charts) {
			commit('SET_CHARTS', data.charts);
		} else {
			console.log(data.charts, data);
			commit('UNSET_CHARTS');
		}

		if (data.addablecharts) {
			commit('SET_ADDABLECHARTS', data.addablecharts);
		} else {
			commit('UNSET_ADDABLECHARTS');
		}
	},
	SAVE_PRESENTATION: function SAVE_PRESENTATION(_ref2, presentation) {
		var dispatch = _ref2.dispatch,
		    rootGetters = _ref2.rootGetters,
		    getters = _ref2.getters,
		    commit = _ref2.commit;

		if (rootGetters.devmode) console.debug('A|SAVE_PRESENTATION');

		var preUrl = void 0,
		    id = void 0;
		var payload = {};

		if (presentation.type == 'user') {
			preUrl = getters.channel.urls.user, id = presentation.id;
		} else if (presentation.type == 'customer') {
			preUrl = '/api/v1/customers/:id:', id = getters.edituser.id;
		} else if (presentation.type == 'partner') {
			preUrl = '/api/v1/partners/:id:', id = getters.edituser.id;
		} else {
			preUrl = getters.channel.urls.presentation, id = presentation.type == 'master' ? 'master' : presentation.id;
		}

		payload.id = id;
		payload.charts = {};
		forEach_default()(presentation.charts, function (chart, index) {
			payload.charts[chart.id] = actions_getSaveableChart(chart, index);
		});

		var url = preUrl.replace(':id:', id);
		console.log(url, payload, 'presentation');
		// this.restpatch(url, payload, 'presentation')
		// .then(message => {
		// 	if(message && message.updated && message.updated.charts) {
		// 		self.updateCharts(message.updated.charts);
		// 	} else {
		// 		self.updateCharts(message);
		// 	}
		// });
	},
	ADD_CHART: function ADD_CHART(_ref3, payload) {
		var state = _ref3.state,
		    dispatch = _ref3.dispatch,
		    rootGetters = _ref3.rootGetters,
		    getters = _ref3.getters,
		    commit = _ref3.commit;

		if (rootGetters.devmode) console.debug('A|ADD_CHART', payload);

		if (Array.isArray(state.charts)) {
			console.warn('chart.charts is array');
			state.charts = {};
		}

		var parent = state.charts;
		if (typeof getters.addchart == 'number' && getters.addchart != 0) {
			var chart = getters.getChartById(getters.addchart);
			if (chart) {
				if (Array.isArray(chart.charts)) {
					console.warn('chart.charts is array');
					chart.charts = {};
				}

				parent = chart.charts;
			}
		} else if (typeof_default()(getters.addchart) == 'object') {
			if (getters.addchart.parent) {
				var _chart = getters.getChartById(getters.addchart.parent);
				if (_chart) {
					if (Array.isArray(_chart.charts)) {
						console.warn('chart.charts is array');
						_chart.charts = {};
					}
					parent = _chart.charts;
				}
			}

			payload = assign_default()({}, payload, getters.addchart);
		}

		if (parent !== state.charts) delete payload.charts; // darf halt nur auf der root ebene sein
		if (!payload.position) payload.position = keys_default()(parent).length; // update position

		if (rootGetters.devmode) console.debug('M|ADD_CHART on ', payload.position, ' to parent:', parent);

		vue_esm["default"].set(parent, payload.id.toString(), payload);

		if (rootGetters.devmode) console.debug('M|ADD_CHART CHART', parent);

		return parent[payload.id.toString()];
	},


	// WIP
	UPDATE_FIELD: function UPDATE_FIELD(_ref4, payload) {
		var state = _ref4.state,
		    dispatch = _ref4.dispatch,
		    rootGetters = _ref4.rootGetters,
		    getters = _ref4.getters,
		    commit = _ref4.commit;

		if (rootGetters.devmode) console.debug('A|UPDATE_FIELD', payload);
		var id = payload.id,
		    fieldname = payload.fieldname;

		dispatch('socket/SEND_PACKAGE', {
			name: 'UPDATE_FIELD',
			payload: payload,
			time: new Date().getTime()
		});

		var chart = getters.getChartById(id),
		    field = chart.fields[fieldname];

		keys_default()(payload).forEach(function (key) {
			if (key == 'id' || key == 'fieldname') return;

			vue_esm["default"].set(field, key, payload[key]);

			vue_esm["default"].set(field, 'changed', true);
		});

		chart.changed = true;

		state.charts = state.charts; // trigger update?

		return field;
	}
});
// CONCATENATED MODULE: ./src/store/preseditor/getters.js



/* harmony default export */ var preseditor_getters = ({
    presentation: function presentation(state) {
        return state.presentation;
    },
    charts: function charts(state) {
        return state.charts;
    },
    chartemplates_loading: function chartemplates_loading(state) {
        return state.chartemplates_loading;
    },

    persistedtime_chartemplates: function persistedtime_chartemplates(state) {
        return state.persistedtime_chartemplates;
    },

    chartemplates: function chartemplates(state) {
        // if(!state.persistedtime_chartemplates || !isCacheValid(state.persistedtime_chartemplates)) return false;

        return state.chartemplates;
    },

    addchart: function addchart(state) {
        return state.addchart;
    },

    ordertCharts: function ordertCharts(state) {
        return helpers_storeutilis.orderCharts(state.charts);
    },

    getBackgroundImageByChartId: function getBackgroundImageByChartId(state, getters) {
        return function (id) {
            var chart = getters.getChartById(id);

            if (chart.image) {
                return chart.image;
            }

            if (chart.fields && chart.fields['background-image']) {
                return chart.fields['background-image'].value;
            }

            return false;
        };
    },

    getChartField: function getChartField(state, getters) {
        return function (chartid, fieldname, getWithParent) {
            var chart = getters.getChartById(chartid, getWithParent);

            if (chart.fields && chart.fields[fieldname]) {
                return chart.fields[fieldname];
            }

            if (chart.parent && chart.parent.fields && chart.parent.fields[fieldname]) {
                return chart.parent.fields[fieldname];
            }

            return false;
        };
    },

    getChartFields: function getChartFields(state, getters) {
        return function (chartid, getWithParent) {
            var chart = getters.getChartById(chartid, getWithParent);
            var fields = chart.fields;

            if (getWithParent && chart.parent && chart.parent.fields) {
                fields = assign_default()({}, chart.parent.fields, chart.fields);
            }

            return fields || false;
        };
    },

    getChartById: function getChartById(state) {
        return function (id, getWithParent) {
            if (!state.charts) return false;

            if (state.charts[id]) {
                return state.charts[id];
            }

            return helpers_storeutilis.findChart(state.charts, id, getWithParent);
        };
    },
    getUsereditFieldById: function getUsereditFieldById(state) {
        return function (name) {
            if (!state.edituser) return false;
            if (!state.edituser.fields) return false;
            return helpers_storeutilis.getUsereditFieldById(state.edituser.fields, name);
        };
    },

    active_presentation: function active_presentation(state) {
        return state.active_presentation == 0 ? false : state.active_presentation;
    },

    active_field: function active_field(state) {
        return state.active_field == 0 ? false : state.active_field;
    },
    active_field_el: function active_field_el(state) {
        return state.active_field_el;
    },

    chartcomponents: function chartcomponents(state) {
        return state.editor.chartcomponents;
    },
    newchartcounter: function newchartcounter(state) {
        return state.newchartcounter;
    }
});
// CONCATENATED MODULE: ./src/store/preseditor/index.js






var preseditor_state = {

   presentation: false,
   active_presentation: false,
   charts: {},
   active_field: 0,
   active_field_el: false,
   addchart: false,

   chartemplates_loading: false,

   persistedtime_chartemplates: false,

   newchartcounter: 0,

   chartemplates: false,

   editor: {
      chartcomponents: []
   }
};

/* harmony default export */ var preseditor = ({
   state: preseditor_state,
   mutations: preseditor_mutations,
   actions: preseditor_actions,
   getters: preseditor_getters
   // plugins: [createPersistedState({paths: ['persistedtime_chartemplates', 'chartemplates']})]
});
// CONCATENATED MODULE: ./src/store/socket/mutations.js


/* harmony default export */ var socket_mutations = ({
    SET_SOCKET: function SET_SOCKET(state, socket) {
        if (this.getters.devmode) console.debug('M|SET_SOCKET');
        state.socket = socket;
    },
    UNSET_SOCKET: function UNSET_SOCKET(state) {
        if (this.getters.devmode) console.debug('M|UNSET_SOCKET');
        state.socket = false;
    },
    ADD_TO_POOL: function ADD_TO_POOL(state, payload) {
        if (this.getters.devmode) console.debug('M|ADD_TO_POOL', payload);
        console.log(state.pool);
        state.pool.push(payload);
        console.log(state.pool);
    },
    REMOVE_FROM_POOL: function REMOVE_FROM_POOL(state, index) {
        if (this.getters.devmode) console.debug('M|REMOVE_FROM_POOL', index);
        state.pool.splice(index, 1);
    },
    ONLINE: function ONLINE(state, socket) {
        if (this.getters.devmode) console.debug('M|ONLINE');
        state.online = true;
    },
    OFFLINE: function OFFLINE(state) {
        if (this.getters.devmode) console.debug('M|OFFLINE');
        state.online = false;
    }
});
// EXTERNAL MODULE: ./node_modules/socket.io-client/lib/index.js
var lib = __webpack_require__("DmT9");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/store/socket/actions.js







/* harmony default export */ var socket_actions = ({
	CONNECT: function CONNECT(_ref, local) {
		var getters = _ref.getters,
		    rootGetters = _ref.rootGetters,
		    state = _ref.state,
		    commit = _ref.commit,
		    dispatch = _ref.dispatch;

		return new promise_default.a(function (resolve, reject) {
			if (rootGetters.devmode) console.debug('A|CONNECT');
			if (getters.socket) {
				console.debug('A|DISCONNECT FIRST FROM SOCKET');
				return;
			}

			if (!rootGetters || !rootGetters.channel || !rootGetters.channel.me || !rootGetters.channel.me.id) {
				console.debug('A|U NEED TO LOGIN!');
				return;
			}

			var socket_url = local ? 'localhost:3000' : 'https://sales-tool-store.linienflug.design/';
			var socket = lib_default()(socket_url, {
				transports: ['websocket']
			});

			socket.on('connect', function () {
				commit('ONLINE');

				socket.emit('me', rootGetters.channel.me);

				if (getters.pool.length > 0) {
					forEach_default()(getters.pool, function (payload, index) {
						dispatch('SEND_PACKAGE', payload).then(function () {
							commit('REMOVE_FROM_POOL', index);
						});
					});
				}
			});

			socket.on('package', function (payload) {
				dispatch('PARSE_PACKAGE', payload);
			});

			socket.on('disconnect', function () {
				dispatch('DISCONNECT');
			});

			commit('SET_SOCKET', socket);

			resolve();
		});
	},
	PARSE_PACKAGE: function PARSE_PACKAGE(_ref2, payload) {
		var getters = _ref2.getters,
		    rootGetters = _ref2.rootGetters,
		    state = _ref2.state,
		    commit = _ref2.commit,
		    dispatch = _ref2.dispatch;

		if (rootGetters.devmode) console.debug('A|PARSE_PACKAGE', payload);
		return new promise_default.a(function (resolve, reject) {
			vue_esm["default"].set(state.live, payload.name, payload.payload);
		});
	},
	SEND_PACKAGE: function SEND_PACKAGE(_ref3, payload) {
		var getters = _ref3.getters,
		    rootGetters = _ref3.rootGetters,
		    state = _ref3.state,
		    commit = _ref3.commit,
		    dispatch = _ref3.dispatch;

		if (rootGetters.devmode) console.debug('A|SEND_PACKAGE', payload);
		return new promise_default.a(function (resolve, reject) {
			if (!getters.socket) {
				commit('ADD_TO_POOL', payload);
				resolve();
				return;
			}

			getters.socket.emit('package', payload);
		});
	},
	DISCONNECT: function DISCONNECT(_ref4, payload) {
		var getters = _ref4.getters,
		    rootGetters = _ref4.rootGetters,
		    state = _ref4.state,
		    commit = _ref4.commit,
		    dispatch = _ref4.dispatch;

		return new promise_default.a(function (resolve, reject) {
			console.log('DC', payload);
			commit('OFFLINE');
			commit('UNSET_SOCKET');
		});
	}
});
// CONCATENATED MODULE: ./src/store/socket/getters.js


/* harmony default export */ var socket_getters = ({
    socket: function socket(state) {
        return state.socket;
    },
    online: function online(state) {
        return state.online;
    },
    offline: function offline(state) {
        return !state.online;
    },
    pool: function pool(state) {
        return state.pool;
    },

    live: function live(state) {
        return state.live;
    },
    getFromLive: function getFromLive(state, getters) {
        return function (name) {
            if (!getters['live']) return false;
            if (!getters['live'][name]) return false;
            return getters['live'][name];
        };
    }
});
// CONCATENATED MODULE: ./src/store/socket/index.js




var socket_state = {
	socket: false,
	online: false,
	pool: [],
	live: {}
};

/* harmony default export */ var store_socket = ({
	namespaced: true,
	state: socket_state,
	mutations: socket_mutations,
	actions: socket_actions,
	getters: socket_getters
});
// CONCATENATED MODULE: ./src/store/features/mutations.js


/* harmony default export */ var features_mutations = ({

   SET_CROPPA: function SET_CROPPA(state, payload) {
      if (this.getters.devmode) console.debug('M|SET_CROPPA', payload);
      state.croppa = payload;
   },
   UNSET_CROPPA: function UNSET_CROPPA(state) {
      if (this.getters.devmode) console.debug('M|UNSET_CROPPA', payload);
      state.croppa = false;
   },

   SET_MEDIA_STORE: function SET_MEDIA_STORE(state, payload) {
      if (this.getters.devmode) console.debug('M|SET_MEDIA_STORE', payload);
      state.media_store = payload;
   },
   UNSET_MEDIA_STORE: function UNSET_MEDIA_STORE(state) {
      if (this.getters.devmode) console.debug('M|UNSET_MEDIA_STORE', payload);
      state.media_store = false;
   },

   SET_LIVEPREVIEW: function SET_LIVEPREVIEW(state, payload) {
      if (this.getters.devmode) console.debug('M|SET_LIVEPREVIEW', payload);
      state.livepreview = payload;
   },
   UNSET_LIVEPREVIEW: function UNSET_LIVEPREVIEW(state) {
      if (this.getters.devmode) console.debug('M|UNSET_LIVEPREVIEW', payload);
      state.livepreview = false;
   },

   SET_INLINEMOD: function SET_INLINEMOD(state, payload) {
      if (this.getters.devmode) console.debug('M|SET_INLINEMOD', payload);
      state.inlinemod = payload;
   },
   UNSET_INLINEMOD: function UNSET_INLINEMOD(state) {
      if (this.getters.devmode) console.debug('M|UNSET_INLINEMOD', payload);
      state.inlinemod = false;
   },

   SET_AUTO_HIDE_NOTIFICATIONS: function SET_AUTO_HIDE_NOTIFICATIONS(state, payload) {
      if (this.getters.devmode) console.debug('M|SET_INLINEMOD', payload);
      state.auto_hide_notifications = payload;
   },
   UNSET_AUTO_HIDE_NOTIFICATIONS: function UNSET_AUTO_HIDE_NOTIFICATIONS(state) {
      if (this.getters.devmode) console.debug('M|UNSET_INLINEMOD', payload);
      state.auto_hide_notifications = false;
   }
});
// CONCATENATED MODULE: ./src/store/features/actions.js




/* harmony default export */ var features_actions = ({});
// CONCATENATED MODULE: ./src/store/features/getters.js


/* harmony default export */ var features_getters = ({
    croppa: function croppa(state) {
        return state.croppa;
    },

    media_store: function media_store(state) {
        return state.media_store;
    },

    livepreview: function livepreview(state) {
        return state.livepreview;
    },

    inlinemod: function inlinemod(state) {
        return state.inlinemod;
    },

    auto_hide_notifications: function auto_hide_notifications(state) {
        return state.auto_hide_notifications;
    }
});
// CONCATENATED MODULE: ./src/store/features/index.js





var features_state = {
   croppa: true,
   media_store: true,
   livepreview: true,
   inlinemod: false,
   auto_hide_notifications: true
};

/* harmony default export */ var features = ({
   namespaced: true,
   state: features_state,
   mutations: features_mutations,
   actions: features_actions,
   getters: features_getters
});
// CONCATENATED MODULE: ./src/store/index.js




vue_esm["default"].use(vuex_esm["a" /* default */]);









var store_state = {
  // Notices
  errors: [],
  notices: [],
  devmode: false,

  // Datas
  channel: false,
  channels: false,
  user: {},
  edituser: false,

  // statussen
  debug: false,
  slimnavigation: false,
  loading: {},
  saveing: false,
  editing: false,
  changed: false,

  mouseposition: { x: 0, y: 0 }

};

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: store_state,
  mutations: store_mutations,
  actions: actions,
  getters: store_getters,
  modules: {
    preseditor: preseditor,
    socket: store_socket,
    features: features
  }
  // plugins: [createPersistedState({paths: ['channel', 'channels']})]
}));
// CONCATENATED MODULE: ./src/i18n.js



var _extends2, _extends3;

var sameOnEveryLanguage = {
	'Test': 'Test!',
	'Logo': 'Logo',
	'Involved': 'Involved',
	'Media Store': 'Media library',
	'Customer name': 'Customer name',
	'Map Marker': 'Map Marker',
	'Company information': 'Company information',

	'Download {name}': 'Download {name}',

	'Company name': 'Company name',

	'Admin information': 'Admin information',
	'Leader': 'Leader',
	'Contacts': 'Contacts',
	'Roles': 'Roles',
	'Irrevocably delete this account.': 'Irrevocably delete this account.',

	'Someone is currently editing this Presentation. Please try again later.': 'Someone is currently editing this Presentation. Please try again later.',
	'Someone is currently editing this User. Please try again later.': 'Someone is currently editing this User. Please try again later.',

	'Email Domain': 'E-Mail Domain',
	'If the domain is set, only partners with an associated e-mail address can be added.': 'Wenn die Domain gesetzt ist, können nur Partner mit einer dazugehörigen E-Mail Adresse hinzugefügt werden.'
};

/* harmony default export */ var i18n = ({
	en: extends_default()({}, sameOnEveryLanguage, (_extends2 = {
		'Contacts: Show': 'Show',
		'Contacts: Typ': 'Typ',
		'Save Image': 'Save Image',

		'Choose an image': 'Choose an image',
		'Hold left mouse button to move picture. Use Mousewheel to zoom in & out.': 'Hold left mouse button to move picture. Use Mousewheel to zoom in & out.',

		'en': 'English',
		'de': 'German',

		'Partner Leader': 'Partner Leader',
		'Partner Company': 'Partner Company',
		'Delete Presentation': 'Delete Presentation',
		'Successfull Deleted': 'Successfull Deleted',

		'Your logouts successfull': 'Your logouts successfull',
		'Chart is fixed': 'Chart is fixed',

		'404 nothing found': '404 nothing found',
		'There are errors in the Form': 'There are errors in the Form',
		'Email address': 'Email address',
		'Innovative Minutes': 'Innovative Minutes',
		'Successfull saved': 'Successfull saved',
		'Back to {name}': 'Back to {name}',

		'Mobile': 'Mobile',

		// template names
		"Start Screen": "Start Screen",
		"Intro Screen": "Intro Screen",
		"Contact Screen": "Contact Screen",
		"Kunde Start": "Kunde Start",
		"About KM 01": "About KM 01",
		"Market Share": "Market Share",
		"About KM 02 Video-BG": "About KM 02 Video-BG",
		"About KM 03": "About KM 03",
		"About KM 04": "About KM 04",
		"About KM 05": "About KM 05",
		"About KM 06": "About KM 06",
		"About KM 06 Intro": "About KM 06 Intro",

		"Template Partner 01": "Template Partner 01",
		"Video Chapter Chart": "Video Chapter Chart",
		"Bizhub Ready": "bizhub Ready",
		"Reifegrad": "Reifegrad",
		"Digital Matrix": "Digital Matrix",
		"End Screen": "End Screen",
		"KM Standard Intro": "KM Default Intro",
		"KM Standard 01": "KM Default 01",
		"KM Standard 02": "KM Default 02",
		"KM Standard 03": "KM Default 03",
		"Standard Template Intro": "Default Template Intro",

		"Column: image": 'Image',
		"Column: this": 'Name',
		"Column: mainrole": 'Role',
		"Column: subrole": 'Bereich',
		"Column: leader": 'Responsible',
		"Column: managers": 'Partner leader',
		"Column: customers": 'Customers',
		"Column: partners": 'Partners',
		"Column: patners": 'Partners',
		"Column: customernumber": "Customer number",

		'New {name}': 'New {name}', // mainnav
		'Create new {name}': 'Create new {name}', // forms
		'Edit {name}': 'Edit {name}', // forms
		'My {name}': 'My {name}', // mainnav
		'Order by {name}': 'Order by {name}', // mainnav


		'Create': 'Create',
		'Create new': 'Create new',
		'Save': 'Save',
		'Save {name}': 'Save {name}',
		'Edit': 'Edit',
		'Cancel': 'Cancel',
		'See all': 'See all',
		'None': 'None',
		'Delete': 'Delete',
		'delete': 'delete',
		'Confirm': 'Confirm',
		'Close': 'Close',
		'Download': 'Offline Version',

		'Delete User': 'Delete User',
		'Do you really want to delete this user.': 'Do you really want to delete this user.',

		// roles
		'Marketing': 'Marketing',
		'KM Sales': 'KM Sales',
		'KM Sales Leader': 'KM Sales Leader',
		'KM Sales Leaders': 'KM Sales Leaders',
		'Project Business': 'Project Business',
		'Partner Business': 'Partner Business',
		'Partner Sales': 'Partner Sales',
		'Customer': 'Customer', //singular
		'Customers': 'Customer', //plural
		'Partner': 'Partner', //singular
		'Partners': 'Partner', //plural

		// Nav
		'Dashboard': 'Dashboard',
		'Infoguide': 'Infoguide',
		'Presentation': 'Presentation',
		'Presentations': 'Presentations',
		'Master Slides': 'Master Slides',
		'Styleguide': 'Styleguide',
		'Translations': 'Translations',
		'Processwire': 'ProcessWire CMS',

		'View': 'View',
		'Copy Link': 'Copy Link',
		'Settings': 'Settings',

		// system
		'Nothing Found': 'Nothing Found',

		// topbar
		'Logout': 'Logout',
		'Account': 'Account',
		'Switch to': 'Switch to',

		//dashboard
		'Latest presentation': 'Latest presentation',
		'Latest customer': 'Latest customer',
		'Next appointment': 'Next appointment',

		// listing
		'Final': 'Final',
		'final': 'Final',
		'Draft': 'Draft',
		'draft': 'Draft',
		'Preview': 'Preview',
		'preview': 'Preview',
		'Archive': 'Archiv',
		'archive': 'Archiv',

		'Progress Status': 'Progress Status',
		'My': 'My',
		'All': 'All',

		'Search ...': 'Search ...',
		'Name': 'Name',
		'Subroles': 'Subroles',
		'Title': 'Title',
		'Last edit': 'Last edit',
		'Appointment': 'Appointment',
		'Created by': 'Created by',

		// pageing
		'Page': 'Page',
		'to': 'to',

		// editor
		'show Chart': 'show Chart',
		'hide Chart': 'hide Chart',
		'delete Chart': 'delete Chart',
		'edit Charttitle': 'edit Charttitle',
		'edit Settings': 'edit Settings',
		'save Presentation': 'save Presentation',
		'view Presentation': 'view Presentation',
		'copy Presentationlink': 'copy Presentationlink',

		// presentation form
		'Presentation name': 'Presentation name',
		'Without': 'Without',
		'Organization': 'Organization'
	}, defineProperty_default()(_extends2, 'Appointment', 'Appointment'), defineProperty_default()(_extends2, 'Personal information', 'Personal information'), defineProperty_default()(_extends2, 'Corporate information', 'Corporate information'), defineProperty_default()(_extends2, 'Corporate Logo', 'Corporate Logo'), defineProperty_default()(_extends2, 'Portrait Photo', 'Portrait Photo'), defineProperty_default()(_extends2, 'Salutation', 'Salutation'), defineProperty_default()(_extends2, 'choose', 'choose'), defineProperty_default()(_extends2, 'Mr', 'Mr'), defineProperty_default()(_extends2, 'Mrs', 'Mrs'), defineProperty_default()(_extends2, 'Other', 'Other'), defineProperty_default()(_extends2, 'Contact', 'Contact'), defineProperty_default()(_extends2, 'Organisation', 'Organisation'), defineProperty_default()(_extends2, 'Customer Number', 'Customer Number'), defineProperty_default()(_extends2, 'Corporate name', 'Corporate name'), defineProperty_default()(_extends2, 'First name and surname', 'First name and surname'), defineProperty_default()(_extends2, 'Firstname', 'Firstname'), defineProperty_default()(_extends2, 'Your firstname', 'Your firstname'), defineProperty_default()(_extends2, 'Surname', 'Surname'), defineProperty_default()(_extends2, 'Your surname', 'Your surname'), defineProperty_default()(_extends2, 'Titel', 'Title'), defineProperty_default()(_extends2, 'Department', 'Department'), defineProperty_default()(_extends2, 'Company Address', 'Company Address'), defineProperty_default()(_extends2, 'Adresse', 'Adresse'), defineProperty_default()(_extends2, 'Email Address', 'Email Address'), defineProperty_default()(_extends2, 'Phone', 'Phone'), defineProperty_default()(_extends2, 'Password', 'Password'), defineProperty_default()(_extends2, 'Password Confirmation', 'Password Confirmation'), defineProperty_default()(_extends2, 'Assistant Manager', ''), defineProperty_default()(_extends2, 'Customer Management Dept.', ''), defineProperty_default()(_extends2, 'Konica Minolta Hauptstraße 42, 10400 Musterhausen', ''), defineProperty_default()(_extends2, 'maria.musterfrau@konicaminolta.de', ''), defineProperty_default()(_extends2, 'max.mustermann@konicaminolta.de', ''), defineProperty_default()(_extends2, 'Role', 'Function'), defineProperty_default()(_extends2, 'After submitting this form, an automatic e-mail will be sent with login information to the specified address.', 'After submitting this form, an automatic e-mail will be sent with login information to the specified address.'), defineProperty_default()(_extends2, 'User Slides', 'User Slides'), defineProperty_default()(_extends2, 'to the editor', 'to the editor'), defineProperty_default()(_extends2, 'Field: contacts', 'Contact Person'), defineProperty_default()(_extends2, 'Field: Contacts', 'Contact Card'), defineProperty_default()(_extends2, 'Field: background-image', 'Background Image'), defineProperty_default()(_extends2, 'Field: background-video', 'Background Video'), defineProperty_default()(_extends2, 'Field: title', 'Title'), defineProperty_default()(_extends2, 'Field: headline', 'Headline'), defineProperty_default()(_extends2, 'Field: subheadline', 'Subheadline'), defineProperty_default()(_extends2, 'Field: sub-headline', 'Subheadline'), defineProperty_default()(_extends2, 'Field: sub-headline-1', 'Subheadline'), defineProperty_default()(_extends2, 'Field: sub-headline-2', 'Subheadline'), defineProperty_default()(_extends2, 'Field: subheadline1', 'Subheadline'), defineProperty_default()(_extends2, 'Field: subheadline2', 'Subheadline'), defineProperty_default()(_extends2, 'Field: headline-left', 'Headline left'), defineProperty_default()(_extends2, 'Field: headline-right', 'Headline right'), defineProperty_default()(_extends2, 'Field: text', 'Text'), defineProperty_default()(_extends2, 'Field: text1', 'Text'), defineProperty_default()(_extends2, 'Field: text-1', 'Text'), defineProperty_default()(_extends2, 'Field: text2', 'Text'), defineProperty_default()(_extends2, 'Field: text-2', 'Text'), defineProperty_default()(_extends2, 'Field: text-left', 'Text left'), defineProperty_default()(_extends2, 'Field: text-right', 'Text right'), defineProperty_default()(_extends2, 'Field: image-gfx', 'Image'), defineProperty_default()(_extends2, 'Field: image-logo', 'Image (Logo)'), defineProperty_default()(_extends2, 'Field: kunde-image-halfsize', 'Image'), defineProperty_default()(_extends2, 'Field: image_left', 'Image left'), defineProperty_default()(_extends2, 'Field: image_right', 'Image right'), defineProperty_default()(_extends2, 'Field: right-map', 'Map'), defineProperty_default()(_extends2, 'new Slide', 'new Slide'), defineProperty_default()(_extends2, 'new Child Slide', 'new Child Slide'), defineProperty_default()(_extends2, 'Your account is currently locked. Please contact our staff..', 'Your account is currently locked. Please contact our staff..'), defineProperty_default()(_extends2, 'Check your user data and try again.', 'Check your user data and try again.'), defineProperty_default()(_extends2, 'Your account may be locked!', 'Your account may be locked!'), defineProperty_default()(_extends2, 'Sign in', 'Sign in'), defineProperty_default()(_extends2, 'Password forgot?', 'Password forgot?'), defineProperty_default()(_extends2, 'DEV MODE', 'DEV MODE'), defineProperty_default()(_extends2, 'system', {
		NotFound: '404 - Not found'
	}), _extends2)),
	de: extends_default()({}, sameOnEveryLanguage, (_extends3 = {

		'Contacts: Show': 'Anzeigen',
		'Contacts: Typ': 'Type',
		'Save Image': 'Bild speichern',

		'Choose an image': 'Wählen Sie ein Bild',
		'Hold left mouse button to move picture. Use Mousewheel to zoom in & out.': 'Bei gedrückter linker Maustaste das Bild bewegen. Mit dem Scrollrad ein- und auszoomen.',

		'en': 'Englisch',
		'de': 'Deutsch',

		'Partner Leader': 'Partner Verkaufsleiter',
		'Partner Company': 'Partner Firma',
		'Delete Presentation': 'Präsentation löschen',
		'Successfull Deleted': 'Erfolgreich gelöscht',

		'Your logouts successfull': 'Ihre Abmeldung war erfolgreich',
		'Chart is fixed': 'Folie ist fixiert',

		'404 nothing found': '404 nothing found',
		'There are errors in the Form': 'Fehler im Formular',
		'Email address': 'E-Mail-Adresse',
		'Innovative Minutes': 'Innovative Minutes',
		'Successfull saved': 'Erfolgreich gespeichert',
		'Back to {name}': 'Zurück zu {name}',

		'Mobile': 'Mobile',

		// template names
		"Start Screen": "Startseite",
		"Intro Screen": "Introseite",
		"Contact Screen": "Kontaktseite",
		"Kunde Start": "Kunde Start",
		"About KM 01": "Über KM 01",
		"Market Share": "Marktanteil",
		"About KM 02 Video-BG": "Über KM 02 Video-BG",
		"About KM 03": "Über KM 03",
		"About KM 04": "Über KM 04",
		"About KM 05": "Über KM 05",
		"About KM 06": "Über KM 06",
		"About KM 06 Intro": "Über KM 06 Intro",

		"Template Partner 01": "Template Partner 01",
		"Video Chapter Chart": "Video Kapitel Chart",
		"Bizhub Ready": "bizhub Ready",
		"Reifegrad": "Reifegrad",
		"Digital Matrix": "Digitale Matrix",
		"End Screen": "Abschlußseite",
		"KM Standard Intro": "KM Standard Intro",
		"KM Standard 01": "KM Standard 01",
		"KM Standard 02": "KM Standard 02",
		"KM Standard 03": "KM Standard 03",
		"Standard Template Intro": "Standard Template Intro",

		"Column: image": 'Bild',
		"Column: this": 'Name',
		"Column: mainrole": 'Funktion',
		"Column: subrole": 'Bereich',
		"Column: leader": 'Verantwortlich',
		"Column: managers": 'Partner Verkaufsleiter',
		"Column: customers": 'Kunden',
		"Column: partners": 'Partner',
		"Column: patners": 'Partner',
		"Column: customernumber": "Kundennr.",

		'New {name}': 'Neu {name}', // mainnav
		'Create new {name}': '{name} neu erstellen', // forms
		'Edit {name}': '{name} bearbeiten', // forms
		'My {name}': 'Mein {name}', // mainnav
		'Order by {name}': 'Nach {name} sortieren', // mainnav


		'Create': 'Erstellen',
		'Create new': 'Neuen erstellen',
		'Save': 'Speichern',
		'Save {name}': 'Speicher {name}',
		'Edit': 'Bearbeiten',
		'Cancel': 'Abbrechen',
		'See all': 'Alle ansehen',
		'None': 'Keine',
		'Delete': 'Löschen',
		'delete': 'löschen',
		'Confirm': 'Bestätigen',
		'Close': 'Schließen',
		'Download': 'Offline Version',

		'Delete User': 'Benutzer löschen',
		'Do you really want to delete this user.': 'Möchten Sie diesen Benutzer wirklich löschen.',

		// roles
		'Marketing': 'Marketing',
		'KM Sales': 'KM Sales',
		'KM Sales Leader': 'KM Sales Teamleiter',
		'KM Sales Leaders': 'KM Sales Teamleiter',
		'Project Business': 'Project Business',
		'Partner Business': 'Partner Business',
		'Partner Sales': 'Partner Sales',
		'Customer': 'Kunde', //singular
		'Customers': 'Kunde', //plural
		'Partner': 'Partner', //singular
		'Partners': 'Partner', //plural

		// Nav
		'Dashboard': 'Dashboard',
		'Infoguide': 'Infoguide',

		'Presentation': 'Präsentation',
		'Presentations': 'Präsentationen',
		'Master Slides': 'Master Folien',
		'Order by Partners': 'Nach Partner sortieren',
		'Order by Customers': 'Nach Kunden sortieren',
		'Styleguide': 'Styleguide',
		'Translations': 'Übersetzungen',
		'Processwire': 'ProcessWire CMS',

		'View': 'Ansehen',
		'Copy Link': 'Link kopieren',
		'Settings': 'Einstellungen',

		// system
		'Nothing Found': 'Nichts gefunden',

		// topbar
		'Logout': 'Abmelden',
		'Account': 'Kontoeinstellungen',
		'Switch to': 'Wechseln zu', // switch to $channel


		//dashboard
		'Latest presentation': 'Neuste Präsentationen',
		'Latest customer': 'Neuste Kunden',
		'Next appointment': 'Nächsten Termine',

		// listing

		'Final': 'Final',
		'final': 'Final',
		'Draft': 'Entwurf',
		'draft': 'Entwurf',
		'Preview': 'Vorschau',
		'preview': 'Vorschau',
		'Archive': 'Archiv',
		'archive': 'Archiv'

	}, defineProperty_default()(_extends3, 'Final', 'Final'), defineProperty_default()(_extends3, 'Draft', 'Entwurf'), defineProperty_default()(_extends3, 'Progress Status', 'Fortschrittsstatus'), defineProperty_default()(_extends3, 'My', 'Meine'), defineProperty_default()(_extends3, 'All', 'Alle'), defineProperty_default()(_extends3, 'Search ...', 'Suche ...'), defineProperty_default()(_extends3, 'Name', 'Name'), defineProperty_default()(_extends3, 'Subroles', 'Bereiche'), defineProperty_default()(_extends3, 'Title', 'Titel'), defineProperty_default()(_extends3, 'Last edit', 'Letzte Bearbeitung'), defineProperty_default()(_extends3, 'Appointment', 'Termin'), defineProperty_default()(_extends3, 'Created by', 'Erstellt von'), defineProperty_default()(_extends3, 'Page', 'Seite'), defineProperty_default()(_extends3, 'to', 'von'), defineProperty_default()(_extends3, 'show Chart', 'Folie zeigen'), defineProperty_default()(_extends3, 'hide Chart', 'Folie verstecken'), defineProperty_default()(_extends3, 'delete Chart', 'Folie löschen'), defineProperty_default()(_extends3, 'edit Charttitle', 'Folientitel bearbeiten'), defineProperty_default()(_extends3, 'edit Settings', 'Einstellungen bearbeiten'), defineProperty_default()(_extends3, 'save Presentation', 'Präsentation speichern'), defineProperty_default()(_extends3, 'view Presentation', 'Präsentation anzeigen'), defineProperty_default()(_extends3, 'copy Presentationlink', 'Präsentationslink kopieren'), defineProperty_default()(_extends3, 'Presentation name', 'Präsentationsname'), defineProperty_default()(_extends3, 'Without', 'Ohne'), defineProperty_default()(_extends3, 'Organization', 'Organisation'), defineProperty_default()(_extends3, 'Appointment', 'Termin'), defineProperty_default()(_extends3, 'Personal information', 'Persönliche Information'), defineProperty_default()(_extends3, 'Corporate information', 'Unternehmensinformationen'), defineProperty_default()(_extends3, 'Corporate Logo', 'Unternehmenslogo'), defineProperty_default()(_extends3, 'Portrait Photo', 'Portrait Foto'), defineProperty_default()(_extends3, 'Salutation', 'Anrede'), defineProperty_default()(_extends3, 'choose', 'auswählen'), defineProperty_default()(_extends3, 'Mr', 'Herr'), defineProperty_default()(_extends3, 'Mrs', 'Frau'), defineProperty_default()(_extends3, 'Other', 'Andere'), defineProperty_default()(_extends3, 'Contact', 'Kontakt'), defineProperty_default()(_extends3, 'Organisation', 'Organisation'), defineProperty_default()(_extends3, 'Customer Number', 'Kunden Nr.'), defineProperty_default()(_extends3, 'Corporate name', 'Unternehmensname'), defineProperty_default()(_extends3, 'First name and surname', 'Vor- und Nachname'), defineProperty_default()(_extends3, 'Firstname', 'Vorname'), defineProperty_default()(_extends3, 'Your firstname', 'Ihr Vorname'), defineProperty_default()(_extends3, 'Surname', 'Nachname'), defineProperty_default()(_extends3, 'Your surname', 'Ihr Nachname'), defineProperty_default()(_extends3, 'Titel', 'Titel'), defineProperty_default()(_extends3, 'Department', 'Abteilung'), defineProperty_default()(_extends3, 'Address', 'Adresse'), defineProperty_default()(_extends3, 'Company Address', 'Geschäftsadresse'), defineProperty_default()(_extends3, 'Adresse', 'Adresse'), defineProperty_default()(_extends3, 'Email Address', 'E-Mail'), defineProperty_default()(_extends3, 'Phone', 'Telefon'), defineProperty_default()(_extends3, 'Password', 'Passwort'), defineProperty_default()(_extends3, 'Password Confirmation', 'Passwort Bestätigung'), defineProperty_default()(_extends3, 'Assistant Manager', ''), defineProperty_default()(_extends3, 'Customer Management Dept.', ''), defineProperty_default()(_extends3, 'Konica Minolta Hauptstraße 42, 10400 Musterhausen', ''), defineProperty_default()(_extends3, 'maria.musterfrau@konicaminolta.de', ''), defineProperty_default()(_extends3, 'max.mustermann@konicaminolta.de', ''), defineProperty_default()(_extends3, 'Role', 'Funktion'), defineProperty_default()(_extends3, 'Subrole', 'Bereich'), defineProperty_default()(_extends3, 'After submitting this form, an automatic e-mail will be sent with login information to the specified address.', 'Mit absenden dieses Formulars wird automatisch eine E-Mail mit den Log-In Daten an die angegebene E-Mail-Adresse verschickt.'), defineProperty_default()(_extends3, 'User Slides', 'Benutzer Folien'), defineProperty_default()(_extends3, 'to the editor', 'Zum Editor'), defineProperty_default()(_extends3, 'Field: contacts', 'Ansprechpartner'), defineProperty_default()(_extends3, 'Field: Contacts', 'Ansprechpartner Visitenkarte'), defineProperty_default()(_extends3, 'Field: background-image', 'Hintergrundbild'), defineProperty_default()(_extends3, 'Field: background-video', 'Hintergrundvideo'), defineProperty_default()(_extends3, 'Field: title', 'Folientitel'), defineProperty_default()(_extends3, 'Field: headline', 'Überschrift'), defineProperty_default()(_extends3, 'Field: subheadline', 'Zwischenüberschrift'), defineProperty_default()(_extends3, 'Field: sub-headline', 'Zwischenüberschrift'), defineProperty_default()(_extends3, 'Field: sub-headline-1', 'Zwischenüberschrift'), defineProperty_default()(_extends3, 'Field: sub-headline-2', 'Zwischenüberschrift'), defineProperty_default()(_extends3, 'Field: subheadline1', 'Zwischenüberschrift'), defineProperty_default()(_extends3, 'Field: subheadline2', 'Zwischenüberschrift'), defineProperty_default()(_extends3, 'Field: headline-left', 'Überschrift links'), defineProperty_default()(_extends3, 'Field: headline-right', 'Überschrift rechts'), defineProperty_default()(_extends3, 'Field: text', 'Text'), defineProperty_default()(_extends3, 'Field: text1', 'Text'), defineProperty_default()(_extends3, 'Field: text-1', 'Text'), defineProperty_default()(_extends3, 'Field: text2', 'Text'), defineProperty_default()(_extends3, 'Field: text-2', 'Text'), defineProperty_default()(_extends3, 'Field: text-left', 'Text links'), defineProperty_default()(_extends3, 'Field: text-right', 'Text rechts'), defineProperty_default()(_extends3, 'Field: image-gfx', 'Bild'), defineProperty_default()(_extends3, 'Field: image-logo', 'Bild (Logo)'), defineProperty_default()(_extends3, 'Field: kunde-image-halfsize', 'Bild'), defineProperty_default()(_extends3, 'Field: image_left', 'Bild links'), defineProperty_default()(_extends3, 'Field: image_right', 'Bild rechts'), defineProperty_default()(_extends3, 'Field: right-map', 'Karte'), defineProperty_default()(_extends3, 'new Slide', 'Neue Folie'), defineProperty_default()(_extends3, 'new Child Slide', 'Neue Unterfolie'), defineProperty_default()(_extends3, 'Your account is currently locked. Please contact our staff..', 'Ihr Account is derzeit gesperrt. Bitte kontaktieren Sie dazu Ihren bekannten Konica Minolta Ansprechpartner.'), defineProperty_default()(_extends3, 'Check your user data and try again.', 'Überprüfen Sie bitte Ihre Anmeldedaten und versuchen Sie es erneut.'), defineProperty_default()(_extends3, 'Your account may be locked!', 'Ihr Account ist vermutlich gesperrt!'), defineProperty_default()(_extends3, 'Sign in', 'Einloggen'), defineProperty_default()(_extends3, 'Password forgot?', 'Passwort vergessen?'), defineProperty_default()(_extends3, 'DEV MODE', 'ENTWICKLUNGSUMGEBUNG'), defineProperty_default()(_extends3, 'system', {
		NotFound: '404 - Not found'
	}), _extends3))
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/p-loginform.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var p_loginform = ({
	name: 'p-loginform',
	computed: {
		saveing: function saveing() {
			return this.$store.getters.saveing;
		},
		loading: function loading() {
			return this.$store.getters.loading;
		},
		notices: function notices() {
			var notices = this.$store.getters.notices;
			return notices;
		}
	},
	data: function data() {
		return {
			forgot: false,
			email: '',
			password: ''
		};
	},

	methods: extends_default()({}, rest, {
		toggleForgot: function toggleForgot() {
			this.forgot = !this.forgot;
		},
		submit: function submit() {
			var self = this;
			this.$validator.validateAll().then(function (result) {
				if (result) {
					if (self.forgot) {
						self.restpatch('/api/v1/request_password', { email: self.email }, 'request_password').then(function (message) {
							console.log(message);
						});
					} else {
						self.restpatch('/api/v1/login', { email: self.email, password: self.password }, 'login').then(function (message) {
							if (!isEmpty_default()(message)) self.$emit('login', message);
						});
					}
				}
			}).catch(function (err) {
				console.log(err);
			});
		}
	})
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b0796b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/p-loginform.vue
var p_loginform_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"st-login st-animate st-animate--fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-center margin-bottom-medium"},[_c('h1',{staticClass:"st-headline st-headline--1"},[_vm._v(_vm._s(_vm.$t('Innovative Minutes')))])])]),_vm._v(" "),_c('form',{ref:"form",attrs:{"method":"post"},on:{"submit":function($event){$event.preventDefault();_vm.submit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 margin-bottom-medium"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({email: true, required: true}),expression:"{email: true, required: true}"},{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],ref:"email",staticClass:"st-input st-input--full",class:{'st-input--error': _vm.errors.has('email')},attrs:{"autofocus":"","type":"email","name":"email","placeholder":_vm.$t('Email address'),"disabled":_vm.loading || _vm.saveing},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"error"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.errors.first('email'))+"\n\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 margin-bottom-medium"},[(!_vm.forgot)?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],ref:"password",staticClass:"st-input st-input--full",class:{'st-input--error': _vm.errors.has('password')},attrs:{"autofocus":"","type":"password","name":"password","placeholder":_vm.$t('Password'),"disabled":_vm.loading || _vm.saveing},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}],staticClass:"error"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.errors.first('password'))+"\n\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 margin-bottom-medium"},[_c('button',{staticClass:"st-btn st-btn--full st-btn--primary",class:{'st-btn--loading':_vm.loading || _vm.saveing},attrs:{"disabled":_vm.loading || _vm.saveing}},[(!_vm.forgot)?_c('span',[_vm._v(_vm._s(_vm.$t('Sign in')))]):_c('span',[_vm._v(_vm._s(_vm.$t('Request new Password')))])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 text-center"},[_c('a',{staticClass:"link",class:{'link--loading':_vm.loading || _vm.saveing},attrs:{"href":"#","disabled":_vm.loading || _vm.saveing},on:{"click":function($event){$event.preventDefault();_vm.toggleForgot($event)}}},[(!_vm.forgot)?_c('span',[_vm._v(_vm._s(_vm.$t('Password forgot?')))]):_c('span',[_vm._v(_vm._s(_vm.$t('Switch to Login')))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{ref:"panelnotes",staticClass:"notices"},[(_vm.notices.length > 0)?_c('div',{staticClass:"margin-top-large margin-bottom-xlarge"},_vm._l((_vm.notices),function(data,index){return _c('v-notice',{key:data.id,attrs:{"data":data}})})):_vm._e()])])])])}
var p_loginform_staticRenderFns = []
var p_loginform_esExports = { render: p_loginform_render, staticRenderFns: p_loginform_staticRenderFns }
/* harmony default export */ var pages_p_loginform = (p_loginform_esExports);
// CONCATENATED MODULE: ./src/pages/p-loginform.vue
function p_loginform_injectStyle (ssrContext) {
  __webpack_require__("g3XG")
}
var p_loginform_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var p_loginform___vue_template_functional__ = false
/* styles */
var p_loginform___vue_styles__ = p_loginform_injectStyle
/* scopeId */
var p_loginform___vue_scopeId__ = "data-v-3b0796b4"
/* moduleIdentifier (server only) */
var p_loginform___vue_module_identifier__ = null
var p_loginform_Component = p_loginform_normalizeComponent(
  p_loginform,
  pages_p_loginform,
  p_loginform___vue_template_functional__,
  p_loginform___vue_styles__,
  p_loginform___vue_scopeId__,
  p_loginform___vue_module_identifier__
)

/* harmony default export */ var src_pages_p_loginform = (p_loginform_Component.exports);

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/locale/de.js
var locale_de = __webpack_require__("qqz1");
var locale_de_default = /*#__PURE__*/__webpack_require__.n(locale_de);

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/locale/en.js
var en = __webpack_require__("q4V8");
var en_default = /*#__PURE__*/__webpack_require__.n(en);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var validateLangs = {
	de: locale_de_default.a,
	en: en_default.a
};

/* harmony default export */ var App = ({
	name: 'app',
	data: function data() {
		return {
			interval: false,
			loginNav: false
		};
	},

	components: {
		PLoginform: src_pages_p_loginform
	},
	computed: {
		devmode: function devmode() {
			return this.$store.getters.devmode;
		},
		loading: function loading() {
			return this.$store.getters.loading;
		},
		slimnavigation: function slimnavigation() {
			return this.$store.getters.slimnavigation;
		},
		channel: function channel() {
			return this.$store.getters.channel;
		},
		channels: function channels() {
			if (this.$store.getters.channels) return this.$store.getters.channels;
			if (this.$store.getters.channel.channels) return this.$store.getters.channel.channels;
			return false;
		},
		notices: function notices() {
			return this.$store.getters.notices;
		}
	},
	created: function created() {
		this.init();
	},
	mounted: function mounted() {
		document.addEventListener('mousemove', this.onMouseUpdate, false);
		document.addEventListener('mouseenter', this.onMouseUpdate, false);
	},
	destroyed: function destroyed() {
		document.removeEventListener('mousemove', this.onMouseUpdate);
		document.removeEventListener('mouseenter', this.onMouseUpdate);
	},

	methods: extends_default()({}, rest, {
		init: function init() {
			var _this = this;

			var self = this;

			this.getChannel().then(this.setLocals).then(this.getChannels).then(function (channel) {
				if (self.channel && self.channel.me.role === 'superuser' || self.channel && self.channel.name === 'linienflug') {
					_this.$store.commit('SET_DEVMODE', true);
					self.$store.commit('ADD_NOTICE', {
						'text': 'Developer mode activated',
						'type': 'success'
					});
				}

				self.interval = window.setInterval(function () {
					axios_default.a.get('/api/v1/knock/knock').then(function (response) {
						if (!response.data.message) {
							self.$store.commit('ADD_NOTICE', {
								'text': 'The session has expired.',
								'type': 'error'
							});
							clearInterval(self.interval);
							self.$store.commit('LOGOUT');
						}
					});
				}, 30000);

				_this.$store.dispatch('socket/CONNECT', window.location.hostname == 'localhost' || window.location.hostname == 'sales-tool.local').catch(function (err) {
					console.error(err);
				});
			}).catch(function (error) {
				console.error(error);
			});
		},
		onMouseUpdate: function onMouseUpdate(e) {
			this.$store.commit('MOUSE_MOVE', e);
		},
		getChannel: function getChannel() {
			var self = this;
			return new promise_default.a(function (resolve, reject) {
				if (self.channel) {
					console.debug('USE Cached channel');
					resolve(self.channel);
					return self.channel;
				}

				self.restget('/api/v1/channel', 'channel').then(function (message) {
					if ((typeof message === 'undefined' ? 'undefined' : typeof_default()(message)) == 'object') {
						console.debug('Ajax Channel: ', message);
						self.$store.commit('SET_CHANNEL', message);

						if (message.local) {
							self.$i18n.locale = message.local;
						}

						resolve(message);
						return;
					}
					resolve();
				}).catch(function (error) {
					self.$store.commit('ADD_ERROR', error);
					reject(error);
				});
			});
		},
		getChannels: function getChannels(channel) {
			var self = this;
			return new promise_default.a(function (resolve, reject) {
				if (self.channels) {
					console.debug('USE Cached channels');
					resolve(self.channels);
					return self.channels;
				}

				if (channel && channel.urls && channel.urls.channels) {
					axios_default.a.get(channel.urls.channels).then(function (response) {
						var _this2 = this;

						console.debug('Ajax channels: ', channel);

						if (notices) {
							notices.forEach(function (notice) {
								_this2.$store.commit('ADD_NOTICE', notice);
							});
						}
						var channels = response.data.message;
						self.$store.commit('SET_CHANNELS', channels);
						resolve(channel);
					}).catch(function (error) {
						self.$store.commit('ADD_ERROR', error);
						reject(error);
					});
				} else {
					resolve();
				}
			});
		},
		setLocals: function setLocals(channel) {
			var self = this;
			return new promise_default.a(function (resolve, reject) {
				self.$i18n.locale = 'de';
				keys_default()(self.$i18n.messages).forEach(function (langcode) {
					if (!validateLangs[langcode]) {
						console.error('missing langcode in validateLangs');
						return;
					}
					self.$validator.localize(langcode, {
						messages: validateLangs[langcode].messages,
						attributes: {
							'title': self.$i18n.messages[langcode]['Presentation name'],
							'firstname': self.$i18n.messages[langcode]['Firstname'],
							'email': self.$i18n.messages[langcode]['Email Address'],
							'password': self.$i18n.messages[langcode]['Password'],
							'password_confirmation': self.$i18n.messages[langcode]['Password Confirmation']
						}
					});
				});
				resolve(channel);
			});
		},
		switchto: function switchto(langcode) {
			this.$i18n.locale = langcode;
		},
		logout: function logout() {
			var self = this;
			clearInterval(self.interval);
			this.restpatch('/api/v1/logout', {}, 'logout').then(function (data) {
				self.$store.commit('LOGOUT');
			});
		}
	})
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b01e966","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui"},[(!_vm.channel && _vm.loading)?_c('div',[_c('transition',{attrs:{"name":"ui-init","enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[_c('div',{staticClass:"st-login st-animate st-animate--fadeIn"},[_c('img',{staticClass:"konicaminolta-header__img",attrs:{"src":"/site/assets/images/konicaminolta__logo.svg","alt":"Konica Minolta"}}),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"spinner"})])])])],1):_vm._e(),_vm._v(" "),(!_vm.channel && !_vm.loading)?_c('div',[_c('p-loginform',{on:{"login":_vm.init}})],1):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"ui-header","enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[(_vm.channel)?_c('div',{staticClass:"ui-header"},[_c('div',{staticClass:"ui-wrapper ui-wrapper--header"},[_c('div',{staticClass:"row konicaminolta-header"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"konicaminolta-header__wrap"},[_c('img',{staticClass:"konicaminolta-header__img",attrs:{"alt":"Konica Minolta","src":"/site/assets/images/konicaminolta__logo.svg"}})])])]),_vm._v(" "),_c('div',{staticClass:"row user-header"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{staticClass:"user-header__wrap"},[(_vm.channel)?_c('div',[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.$t("Innovative Minutes"))+" | "+_vm._s(_vm.channel.title)+"\n\t\t\t\t\t\t\t\t"),(_vm.loading)?_c('span',[_c('div',{staticClass:"inline-block spinner spinner--white spinner--large"})]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 text-right"},[_c('div',{staticClass:"user-header__wrap"},[(_vm.channel.localTitle)?_c('div',{staticClass:"inline-block"},[_vm._v("\n\t                            "+_vm._s(_vm.channel.localTitle)+"\n\t                        ")]):_vm._e(),_vm._v(" "),(_vm.channel && _vm.channel.me)?_c('div',{staticClass:"user-login",class:{'user-login--active': _vm.loginNav}},[_c('div',{staticClass:"user-login__name",on:{"click":function($event){_vm.loginNav = !_vm.loginNav}}},[_vm._v("\n\t                                "+_vm._s(_vm.channel.me.fancyname)+"\n\t                            ")]),_vm._v(" "),_c('div',{staticClass:"user-login__nav"},[(_vm.channel.me && _vm.channel.me.urls && _vm.channel.me.urls.edit)?_c('div',{staticClass:"user-login__item"},[_c('router-link',{staticClass:"user-login__link",attrs:{"to":_vm._a(0,function(){return { name: 'user-edit', params: { uid : _vm.channel.me.id.toString(), role: _vm.channel.me.role.toString() }}})}},[_vm._v(_vm._s(_vm.$t('Account')))])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.channels),function(ch){return (_vm.channels)?_c('div',{staticClass:"user-login__item"},[(ch.id != _vm.channel.id)?_c('a',{staticClass:"user-login__link",attrs:{"href":'/panel/?channel=' + ch.id}},[_vm._v(_vm._s(_vm.$t('Switch to'))+" "+_vm._s(ch.title))]):_vm._e()]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"user-login__item"},[_c('a',{staticClass:"user-login__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.logout($event)}}},[_vm._v(_vm._s(_vm.$t('Logout')))])]),_vm._v(" "),_c('div',{staticClass:"user-login__item user-login__item--langs"},[_c('div',{staticClass:"row"},_vm._l((_vm.$i18n.messages),function(messages,langcode){return _c('div',{staticClass:"col-xs-6"},[_c('a',{staticClass:"user-login__link",on:{"click":function($event){$event.preventDefault();_vm.switchto(langcode)}}},[_vm._v(_vm._s(_vm.$t(langcode)))])])}))])],2)]):_c('div',[_c('a',{staticClass:"user-login__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.logout($event)}}},[_vm._v(_vm._s(_vm.$t('Logout')))])])])])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"ui-wrapper"},[_c('transition',{attrs:{"name":"ui-mainnav","enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[(_vm.channel)?_c('div',{staticClass:"ui-sidebar",class:{'ui-sidebar--slim': _vm.slimnavigation }},[_c('v-mainnav')],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"ui-main","enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[(_vm.channel)?_c('div',{staticClass:"ui-main st-animate st-animate--fadeIn",class:{'ui-main--slim': _vm.$store.getters.slimnavigation }},[_c('div',{ref:"panelnotes",staticClass:"notices"},[(_vm.notices.length > 0)?_c('div',{staticClass:"margin-top-large margin-bottom-xlarge"},_vm._l((_vm.notices),function(data,index){return _c('v-notice',{key:data.id,attrs:{"data":data}})})):_vm._e()]),_vm._v(" "),_c('notifications',{attrs:{"group":"main"}}),_vm._v(" "),_c('router-view',{staticClass:"view"}),_vm._v(" "),_c('div',{staticClass:"st-overlay"})],1):_vm._e()])],1)],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("AyeP")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/main.js















/**
 * evn
 * @author https://davidwalsh.name/pubsub-javascript
 * @author Pascal Franzke <pf@linienflug.design>
 * @example
 * evn.publish('/page/load', {
 *     url: '/some/url/path' // any argument
 * });
 * var subscription = evn.subscribe('/page/load', function(obj) {
 *      // Do something now that the event has occurred
 * });
 *
 * // ...sometime later where I no longer want subscription...
 * subscription.remove();
 *
 *
 */
var evn = function () {

    var debug = window.location.href.match(/file:\/\/|staging.|.dev|.local|localhost|linienflug.design/) ? true : false;
    var topics = {};
    var hOP = topics.hasOwnProperty;

    return {
        unsubscribe: function unsubscribe(topic, listener) {
            if (debug) console.debug('%c' + '/app/evn:unsubscribe | ' + topic, 'background-color: #2b3846; color: #ffa300; padding: 3px .5em;');
            // Create the topic's object if not yet created
            if (!hOP.call(topics, topic)) topics[topic] = [];
            // doses topic exists?
            if (!topics[topic]) return true;
            // find listner
            var index = topics[topic].find(listener);
            //delete listner
            return delete topics[topic][index];
        },
        subscribe: function subscribe(topic, listener) {
            if (debug) console.debug('%c' + '/app/evn:subscribe | ' + topic, 'background-color: #2b3846; color: #ffa300; padding: 3px .5em;');
            // Create the topic's object if not yet created
            if (!hOP.call(topics, topic)) topics[topic] = [];
            // Add the listener to queue
            var index = topics[topic].push(listener) - 1;

            // Provide handle back for removal of topic
            return {
                remove: function remove() {
                    delete topics[topic][index];
                }
            };
        },
        publish: function publish(topic, info) {
            if (debug) console.debug('%c' + '/app/evn:publish | ' + topic, 'background-color: #2b3846; color: #ffa300; padding: 3px .5em;');
            // If the topic doesn't exist, or there's no listeners in queue, just leave
            if (!hOP.call(topics, topic)) return;

            // Cycle through topics queue, fire!
            topics[topic].forEach(function (item) {
                item(info !== undefined ? info : {});
            });
        }
    };
}();
if (typeof window.evn == 'undefined') window.evn = evn;

document.addEventListener("keydown", function (e) {
    if (e.keyCode == 27) {
        evn.publish('esc', e);
    }

    if (event.ctrlKey || event.metaKey) {
        switch (String.fromCharCode(event.which).toLowerCase()) {
            case ' ':
                evn.publish('search', e);
                break;
            case 's':
                evn.publish('save', e);
                break;
            case 'f':
                evn.publish('find', e);
                break;
            case 'c':
                evn.publish('copy', e);
                break;
            case 'v':
                evn.publish('paste', e);
                break;
            case 'x':
                evn.publish('cut', e);
                break;
        }
    }
});

// setup
vue_esm["default"].config.devtools = true;
vue_esm["default"].config.performance = true;
// Vue.config.productionTip = false;

vue_esm["default"].directive('focus', { inserted: function inserted(el) {
        el.focus();
    } });

vue_esm["default"].use(vue_croppa_default.a);
vue_esm["default"].use(vee_validate_esm["a" /* default */]);
vue_esm["default"].use(dist_default.a);

vue_esm["default"].use(vue_i18n_esm["a" /* default */]);
vue_esm["default"].use(src_VueApi);

vue_esm["default"].use(vue_filter_default.a);
vue_esm["default"].use(vue_trumbowyg_default.a);

vue_esm["default"].component('draggable', vuedraggable_default.a);

// global Comps

vue_esm["default"].component('v-notice', src_components_v_notice);


vue_esm["default"].component('v-tooldown', src_components_v_tooldown);


vue_esm["default"].component('v-toolinline', src_components_v_toolinline);


vue_esm["default"].component('v-presentationtable', src_components_v_presentationtable);


vue_esm["default"].component('v-editorbar', src_components_v_editorbar);


vue_esm["default"].component('v-field', src_components_v_field);


vue_esm["default"].component('v-modal', src_components_v_modal);


vue_esm["default"].component('v-mainnav', src_components_v_mainnav);


vue_esm["default"].component('v-paging', src_components_v_paging);


vue_esm["default"].component('v-editable', src_components_v_editable);
// ich hab kein plan waurm das scheiß teil nicht als recursive als child weitergeleitet wird


vue_esm["default"].component('c-chart-list', components_p_editor_c_chart_list);



vue_esm["default"].component('vue-popper', vue_popper_default.a);

// lokal Comps



var main_i18n = new vue_i18n_esm["a" /* default */]({
    locale: 'en', // set locale
    messages: i18n
});



console.log('%c' + 'Linienflug Design ✈ Weil bewegt bewegt.', 'line-height: 30px; font-size: 18px; border-radius: .25em;background-color: #2b3846; color: #ffa300; padding: 3px .5em;');
window.app = new vue_esm["default"]({
    el: '#vapp',
    name: 'vapp',
    router: router,
    store: store,
    i18n: main_i18n,
    template: '<App/>',
    components: { App: src_App }
});

/***/ }),

/***/ "NLJ+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NYZZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OJrQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OLMQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qop4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qy75":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TGUE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TcZC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UtT8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V2go":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vol5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VvVP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XKnb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xp6x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YRXF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aDG2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bItx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dKjR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eRPj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g3XG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hCol":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hekq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iHtE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kB4g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m2QC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mhMr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nl26":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oxJP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "phMY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qO0a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ravv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tgUS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "toYN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wBQz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ziuR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.js